var Zs = Object.defineProperty;
var Xs = (r, e, t) => e in r ? Zs(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t;
var _t = (r, e, t) => (Xs(r, typeof e != "symbol" ? e + "" : e, t), t), Mn = (r, e, t) => {
  if (!e.has(r))
    throw TypeError("Cannot " + t);
};
var te = (r, e, t) => (Mn(r, e, "read from private field"), t ? t.call(r) : e.get(r)), re = (r, e, t) => {
  if (e.has(r))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(r) : e.set(r, t);
}, H = (r, e, t, n) => (Mn(r, e, "write to private field"), n ? n.call(r, t) : e.set(r, t), t);
var wr = function(r, e) {
  return wr = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, n) {
    t.__proto__ = n;
  } || function(t, n) {
    for (var i in n)
      Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
  }, wr(r, e);
};
function K(r, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  wr(r, e);
  function t() {
    this.constructor = r;
  }
  r.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
}
var y = function() {
  return y = Object.assign || function(e) {
    for (var t, n = 1, i = arguments.length; n < i; n++) {
      t = arguments[n];
      for (var s in t)
        Object.prototype.hasOwnProperty.call(t, s) && (e[s] = t[s]);
    }
    return e;
  }, y.apply(this, arguments);
};
function Ve(r, e) {
  var t = {};
  for (var n in r)
    Object.prototype.hasOwnProperty.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(r); i < n.length; i++)
      e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[i]) && (t[n[i]] = r[n[i]]);
  return t;
}
function J(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    s = Reflect.decorate(r, e, t, n);
  else
    for (var a = r.length - 1; a >= 0; a--)
      (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}
function ce(r, e, t, n) {
  function i(s) {
    return s instanceof t ? s : new t(function(o) {
      o(s);
    });
  }
  return new (t || (t = Promise))(function(s, o) {
    function a(l) {
      try {
        u(n.next(l));
      } catch (f) {
        o(f);
      }
    }
    function c(l) {
      try {
        u(n.throw(l));
      } catch (f) {
        o(f);
      }
    }
    function u(l) {
      l.done ? s(l.value) : i(l.value).then(a, c);
    }
    u((n = n.apply(r, e || [])).next());
  });
}
function le(r, e) {
  var t = { label: 0, sent: function() {
    if (s[0] & 1)
      throw s[1];
    return s[1];
  }, trys: [], ops: [] }, n, i, s, o;
  return o = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function a(u) {
    return function(l) {
      return c([u, l]);
    };
  }
  function c(u) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, u[0] && (t = 0)), t; )
      try {
        if (n = 1, i && (s = u[0] & 2 ? i.return : u[0] ? i.throw || ((s = i.return) && s.call(i), 0) : i.next) && !(s = s.call(i, u[1])).done)
          return s;
        switch (i = 0, s && (u = [u[0] & 2, s.value]), u[0]) {
          case 0:
          case 1:
            s = u;
            break;
          case 4:
            return t.label++, { value: u[1], done: !1 };
          case 5:
            t.label++, i = u[1], u = [0];
            continue;
          case 7:
            u = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (s = t.trys, !(s = s.length > 0 && s[s.length - 1]) && (u[0] === 6 || u[0] === 2)) {
              t = 0;
              continue;
            }
            if (u[0] === 3 && (!s || u[1] > s[0] && u[1] < s[3])) {
              t.label = u[1];
              break;
            }
            if (u[0] === 6 && t.label < s[1]) {
              t.label = s[1], s = u;
              break;
            }
            if (s && t.label < s[2]) {
              t.label = s[2], t.ops.push(u);
              break;
            }
            s[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        u = e.call(r, t);
      } catch (l) {
        u = [6, l], i = 0;
      } finally {
        n = s = 0;
      }
    if (u[0] & 5)
      throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
function Rt(r, e, t) {
  if (t || arguments.length === 2)
    for (var n = 0, i = e.length, s; n < i; n++)
      (s || !(n in e)) && (s || (s = Array.prototype.slice.call(e, 0, n)), s[n] = e[n]);
  return r.concat(s || Array.prototype.slice.call(e));
}
function Ks(r) {
  return !!(r && typeof r == "object" && "kind" in r && "definitions" in r);
}
class eo extends CustomEvent {
  constructor(e, t) {
    super(e, {
      ...t,
      bubbles: !0,
      composed: !0
    });
  }
}
class Hi extends eo {
  constructor(e) {
    super(e);
  }
}
var Jr;
const qt = class extends Hi {
  constructor(e) {
    super(qt.type), this.controller = e;
  }
};
let Tt = qt;
Jr = new WeakMap(), re(Tt, Jr, qt.type = "apollo-controller-connected");
var Zr;
const Ut = class extends Hi {
  constructor(e) {
    super(Ut.type), this.controller = e;
  }
};
let nt = Ut;
Zr = new WeakMap(), re(nt, Zr, Ut.type = "apollo-controller-disconnected");
var Le, ge, pe;
class ut {
  constructor(e, t) {
    re(this, Le, void 0);
    re(this, ge, void 0);
    re(this, pe, void 0);
    var n, i, s;
    this.host = e, H(this, Le, {}), H(this, ge, null), H(this, pe, null), this.called = !0, this.data = null, this.error = null, this.errors = [], this.loading = !1, e instanceof EventTarget ? this.emitter = e : (t == null ? void 0 : t.hostElement) instanceof EventTarget ? this.emitter = t.hostElement : this.emitter = new EventTarget(), this.options = t != null ? t : {}, this.client = (i = (n = this.options.client) != null ? n : window.__APOLLO_CLIENT__) != null ? i : null, (s = e.addController) == null || s.call(e, this);
  }
  static o(e, t) {
    Object.defineProperty(e, "options", {
      get() {
        return te(this, Le);
      },
      set(n) {
        var i;
        H(this, Le, n), (i = this.optionsChanged) == null || i.call(this, n);
      }
    });
  }
  get client() {
    return te(this, ge);
  }
  set client(e) {
    var n;
    const t = te(this, ge);
    H(this, ge, e), (n = this.clientChanged) == null || n.call(this, e), this.notify({
      client: t
    });
  }
  get document() {
    return te(this, pe);
  }
  set document(e) {
    var t;
    if (e !== te(this, pe))
      if (!e)
        H(this, pe, null);
      else if (Ks(e))
        H(this, pe, e), this.notify({
          document: e
        }), (t = this.documentChanged) == null || t.call(this, e);
      else {
        const n = this.constructor.name.replace(/Apollo(\w+)(Controller|Behavior)/, "$1");
        throw new TypeError(`${n} must be a parsed GraphQL document.`);
      }
  }
  get variables() {
    var e, t;
    return (t = (e = this.options) == null ? void 0 : e.variables) != null ? t : null;
  }
  set variables(e) {
    var t;
    if (!e)
      delete this.options.variables;
    else {
      if (e === this.options.variables)
        return;
      this.options.variables = e;
    }
    this.notify({
      variables: e
    }), (t = this.variablesChanged) == null || t.call(this, e);
  }
  notify(e) {
    if (e && this.host.requestUpdate.length > 0)
      for (const [t, n] of Object.entries(e))
        this.host.requestUpdate(t, n);
    else
      this.host.requestUpdate();
  }
  init(e) {
    var t, n;
    (n = this.variables) != null || (this.variables = (t = this.options.variables) != null ? t : null), this.document = e;
  }
  hostConnected() {
    this.emitter.dispatchEvent(new Tt(this));
  }
  hostDisconnected() {
    this.emitter.dispatchEvent(new nt(this)), window.dispatchEvent(new nt(this));
  }
}
Le = new WeakMap(), ge = new WeakMap(), pe = new WeakMap();
J([ut.o], ut.prototype, "options", void 0);
const Rn = !0;
function ee(r, e, t) {
  if (typeof (t == null ? void 0 : t.value) != "function")
    throw new TypeError(`Only methods can be decorated with @bound. <${e != null ? e : r.name}> is not a method!`);
  return {
    configurable: Rn,
    get() {
      const n = t.value.bind(this);
      return Object.defineProperty(this, e, {
        value: n,
        configurable: Rn,
        writable: !0
      }), n;
    }
  };
}
class to extends ut {
  constructor(e, t, n) {
    super(e, n), this.mostRecentMutationId = 0, this.called = !1, this.init(t != null ? t : null);
  }
  get mutation() {
    return this.document;
  }
  set mutation(e) {
    this.document = e;
  }
  async mutate(e) {
    var c, u;
    if (!this.client)
      throw new TypeError("No Apollo client. See https://apolloelements.dev/guides/getting-started/apollo-client/");
    const t = this.generateMutationId(), {
      called: n = !1,
      data: i,
      error: s,
      errors: o,
      loading: a
    } = this;
    return this.loading = !0, this.called = !0, this.error = null, this.errors = [], this.data = null, this.notify({
      called: n,
      data: i,
      error: s,
      errors: o,
      loading: a
    }), this.client.mutate({
      mutation: this.mutation,
      awaitRefetchQueries: this.options.awaitRefetchQueries,
      context: this.options.context,
      errorPolicy: this.options.errorPolicy,
      fetchPolicy: this.options.fetchPolicy,
      optimisticResponse: this.options.optimisticResponse,
      refetchQueries: (c = this.options.refetchQueries) != null ? c : void 0,
      update: this.options.update,
      variables: (u = this.variables) != null ? u : void 0,
      ...e
    }).then(this.onCompletedMutation.bind(this, t)).catch(this.onMutationError.bind(this, t));
  }
  generateMutationId() {
    return this.mostRecentMutationId += 1, this.mostRecentMutationId;
  }
  isMostRecentMutation(e) {
    return this.mostRecentMutationId === e;
  }
  onCompletedMutation(e, t) {
    var a, c, u, l;
    const {
      data: n,
      error: i,
      errors: s,
      loading: o
    } = this;
    return this.emitter.dispatchEvent(new CustomEvent("apollo-mutation-result", {
      detail: t
    })), this.isMostRecentMutation(e) && (this.loading = !1, this.options.ignoreResults || (this.error = null, this.data = (a = t.data) != null ? a : null, this.errors = (c = t.errors) != null ? c : [], (l = (u = this.options).onCompleted) == null || l.call(u, this.data)), this.notify({
      data: n,
      error: i,
      errors: s,
      loading: o
    })), t;
  }
  onMutationError(e, t) {
    var o, a;
    this.emitter.dispatchEvent(new CustomEvent("apollo-error", {
      detail: t
    }));
    const {
      data: n,
      error: i,
      loading: s
    } = this;
    throw this.isMostRecentMutation(e) && (this.loading = !1, this.data = null, this.error = t), (a = (o = this.options).onError) == null || a.call(o, t), this.notify({
      data: n,
      error: i,
      loading: s
    }), t;
  }
}
J([ee], to.prototype, "mutate", null);
var er = "Invariant Violation", Pn = Object.setPrototypeOf, ro = Pn === void 0 ? function(r, e) {
  return r.__proto__ = e, r;
} : Pn, N = function(r) {
  K(e, r);
  function e(t) {
    t === void 0 && (t = er);
    var n = r.call(this, typeof t == "number" ? er + ": " + t + " (see https://github.com/apollographql/invariant-packages)" : t) || this;
    return n.framesToPop = 1, n.name = er, ro(n, e.prototype), n;
  }
  return e;
}(Error);
function _(r, e) {
  if (!r)
    throw new N(e);
}
var Wi = ["debug", "log", "warn", "error", "silent"], no = Wi.indexOf("log");
function wt(r) {
  return function() {
    if (Wi.indexOf(r) >= no) {
      var e = console[r] || console.log;
      return e.apply(console, arguments);
    }
  };
}
(function(r) {
  r.debug = wt("debug"), r.log = wt("log"), r.warn = wt("warn"), r.error = wt("error");
})(_ || (_ = {}));
function Y(r) {
  try {
    return r();
  } catch {
  }
}
const Fn = Y(function() {
  return globalThis;
}) || Y(function() {
  return window;
}) || Y(function() {
  return self;
}) || Y(function() {
  return global;
}) || Y(function() {
  return Y.constructor("return this")();
});
var Ln = "__", jn = [Ln, Ln].join("DEV");
function io() {
  try {
    return Boolean(__DEV__);
  } catch {
    return Object.defineProperty(Fn, jn, {
      value: Y(function() {
        return process.env.NODE_ENV;
      }) !== "production",
      enumerable: !1,
      configurable: !0,
      writable: !0
    }), Fn[jn];
  }
}
const tr = io();
function fe(r) {
  try {
    return r();
  } catch {
  }
}
var Sr = fe(function() {
  return globalThis;
}) || fe(function() {
  return window;
}) || fe(function() {
  return self;
}) || fe(function() {
  return global;
}) || fe(function() {
  return fe.constructor("return this")();
}), Or = !1;
function so() {
  Sr && !fe(function() {
    return process.env.NODE_ENV;
  }) && !fe(function() {
    return process;
  }) && (Object.defineProperty(Sr, "process", {
    value: {
      env: {
        NODE_ENV: "production"
      }
    },
    configurable: !0,
    enumerable: !1,
    writable: !0
  }), Or = !0);
}
so();
function Vn() {
  Or && (delete Sr.process, Or = !1);
}
function It(r, e) {
  if (!Boolean(r))
    throw new Error(e);
}
function oo(r) {
  return typeof r == "object" && r !== null;
}
function ao(r, e) {
  if (!Boolean(r))
    throw new Error(
      e != null ? e : "Unexpected invariant triggered."
    );
}
const uo = /\r\n|[\n\r]/g;
function Dr(r, e) {
  let t = 0, n = 1;
  for (const i of r.body.matchAll(uo)) {
    if (typeof i.index == "number" || ao(!1), i.index >= e)
      break;
    t = i.index + i[0].length, n += 1;
  }
  return {
    line: n,
    column: e + 1 - t
  };
}
function co(r) {
  return Gi(
    r.source,
    Dr(r.source, r.start)
  );
}
function Gi(r, e) {
  const t = r.locationOffset.column - 1, n = "".padStart(t) + r.body, i = e.line - 1, s = r.locationOffset.line - 1, o = e.line + s, a = e.line === 1 ? t : 0, c = e.column + a, u = `${r.name}:${o}:${c}
`, l = n.split(/\r\n|[\n\r]/g), f = l[i];
  if (f.length > 120) {
    const h = Math.floor(c / 80), p = c % 80, d = [];
    for (let v = 0; v < f.length; v += 80)
      d.push(f.slice(v, v + 80));
    return u + Qn([
      [`${o} |`, d[0]],
      ...d.slice(1, h + 1).map((v) => ["|", v]),
      ["|", "^".padStart(p)],
      ["|", d[h + 1]]
    ]);
  }
  return u + Qn([
    [`${o - 1} |`, l[i - 1]],
    [`${o} |`, f],
    ["|", "^".padStart(c)],
    [`${o + 1} |`, l[i + 1]]
  ]);
}
function Qn(r) {
  const e = r.filter(([n, i]) => i !== void 0), t = Math.max(...e.map(([n]) => n.length));
  return e.map(([n, i]) => n.padStart(t) + (i ? " " + i : "")).join(`
`);
}
function lo(r) {
  const e = r[0];
  return e == null || "kind" in e || "length" in e ? {
    nodes: e,
    source: r[1],
    positions: r[2],
    path: r[3],
    originalError: r[4],
    extensions: r[5]
  } : e;
}
class Xr extends Error {
  constructor(e, ...t) {
    var n, i, s;
    const { nodes: o, source: a, positions: c, path: u, originalError: l, extensions: f } = lo(t);
    super(e), this.name = "GraphQLError", this.path = u != null ? u : void 0, this.originalError = l != null ? l : void 0, this.nodes = $n(
      Array.isArray(o) ? o : o ? [o] : void 0
    );
    const h = $n(
      (n = this.nodes) === null || n === void 0 ? void 0 : n.map((d) => d.loc).filter((d) => d != null)
    );
    this.source = a != null ? a : h == null || (i = h[0]) === null || i === void 0 ? void 0 : i.source, this.positions = c != null ? c : h == null ? void 0 : h.map((d) => d.start), this.locations = c && a ? c.map((d) => Dr(a, d)) : h == null ? void 0 : h.map((d) => Dr(d.source, d.start));
    const p = oo(
      l == null ? void 0 : l.extensions
    ) ? l == null ? void 0 : l.extensions : void 0;
    this.extensions = (s = f != null ? f : p) !== null && s !== void 0 ? s : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, {
      message: {
        writable: !0,
        enumerable: !0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), l != null && l.stack ? Object.defineProperty(this, "stack", {
      value: l.stack,
      writable: !0,
      configurable: !0
    }) : Error.captureStackTrace ? Error.captureStackTrace(this, Xr) : Object.defineProperty(this, "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    });
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
  toString() {
    let e = this.message;
    if (this.nodes)
      for (const t of this.nodes)
        t.loc && (e += `

` + co(t.loc));
    else if (this.source && this.locations)
      for (const t of this.locations)
        e += `

` + Gi(this.source, t);
    return e;
  }
  toJSON() {
    const e = {
      message: this.message
    };
    return this.locations != null && (e.locations = this.locations), this.path != null && (e.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (e.extensions = this.extensions), e;
  }
}
function $n(r) {
  return r === void 0 || r.length === 0 ? void 0 : r;
}
function U(r, e, t) {
  return new Xr(`Syntax Error: ${t}`, {
    source: r,
    positions: [e]
  });
}
class fo {
  constructor(e, t, n) {
    this.start = e.start, this.end = t.end, this.startToken = e, this.endToken = t, this.source = n;
  }
  get [Symbol.toStringTag]() {
    return "Location";
  }
  toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  }
}
class Yi {
  constructor(e, t, n, i, s, o) {
    this.kind = e, this.start = t, this.end = n, this.line = i, this.column = s, this.value = o, this.prev = null, this.next = null;
  }
  get [Symbol.toStringTag]() {
    return "Token";
  }
  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }
}
const Ji = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, ho = new Set(Object.keys(Ji));
function qn(r) {
  const e = r == null ? void 0 : r.kind;
  return typeof e == "string" && ho.has(e);
}
var Ne;
(function(r) {
  r.QUERY = "query", r.MUTATION = "mutation", r.SUBSCRIPTION = "subscription";
})(Ne || (Ne = {}));
var Tr;
(function(r) {
  r.QUERY = "QUERY", r.MUTATION = "MUTATION", r.SUBSCRIPTION = "SUBSCRIPTION", r.FIELD = "FIELD", r.FRAGMENT_DEFINITION = "FRAGMENT_DEFINITION", r.FRAGMENT_SPREAD = "FRAGMENT_SPREAD", r.INLINE_FRAGMENT = "INLINE_FRAGMENT", r.VARIABLE_DEFINITION = "VARIABLE_DEFINITION", r.SCHEMA = "SCHEMA", r.SCALAR = "SCALAR", r.OBJECT = "OBJECT", r.FIELD_DEFINITION = "FIELD_DEFINITION", r.ARGUMENT_DEFINITION = "ARGUMENT_DEFINITION", r.INTERFACE = "INTERFACE", r.UNION = "UNION", r.ENUM = "ENUM", r.ENUM_VALUE = "ENUM_VALUE", r.INPUT_OBJECT = "INPUT_OBJECT", r.INPUT_FIELD_DEFINITION = "INPUT_FIELD_DEFINITION";
})(Tr || (Tr = {}));
var O;
(function(r) {
  r.NAME = "Name", r.DOCUMENT = "Document", r.OPERATION_DEFINITION = "OperationDefinition", r.VARIABLE_DEFINITION = "VariableDefinition", r.SELECTION_SET = "SelectionSet", r.FIELD = "Field", r.ARGUMENT = "Argument", r.FRAGMENT_SPREAD = "FragmentSpread", r.INLINE_FRAGMENT = "InlineFragment", r.FRAGMENT_DEFINITION = "FragmentDefinition", r.VARIABLE = "Variable", r.INT = "IntValue", r.FLOAT = "FloatValue", r.STRING = "StringValue", r.BOOLEAN = "BooleanValue", r.NULL = "NullValue", r.ENUM = "EnumValue", r.LIST = "ListValue", r.OBJECT = "ObjectValue", r.OBJECT_FIELD = "ObjectField", r.DIRECTIVE = "Directive", r.NAMED_TYPE = "NamedType", r.LIST_TYPE = "ListType", r.NON_NULL_TYPE = "NonNullType", r.SCHEMA_DEFINITION = "SchemaDefinition", r.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", r.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", r.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", r.FIELD_DEFINITION = "FieldDefinition", r.INPUT_VALUE_DEFINITION = "InputValueDefinition", r.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", r.UNION_TYPE_DEFINITION = "UnionTypeDefinition", r.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", r.ENUM_VALUE_DEFINITION = "EnumValueDefinition", r.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", r.DIRECTIVE_DEFINITION = "DirectiveDefinition", r.SCHEMA_EXTENSION = "SchemaExtension", r.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", r.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", r.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", r.UNION_TYPE_EXTENSION = "UnionTypeExtension", r.ENUM_TYPE_EXTENSION = "EnumTypeExtension", r.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension";
})(O || (O = {}));
function Ir(r) {
  return r === 9 || r === 32;
}
function ct(r) {
  return r >= 48 && r <= 57;
}
function Zi(r) {
  return r >= 97 && r <= 122 || r >= 65 && r <= 90;
}
function Xi(r) {
  return Zi(r) || r === 95;
}
function po(r) {
  return Zi(r) || ct(r) || r === 95;
}
function vo(r) {
  var e;
  let t = Number.MAX_SAFE_INTEGER, n = null, i = -1;
  for (let o = 0; o < r.length; ++o) {
    var s;
    const a = r[o], c = yo(a);
    c !== a.length && (n = (s = n) !== null && s !== void 0 ? s : o, i = o, o !== 0 && c < t && (t = c));
  }
  return r.map((o, a) => a === 0 ? o : o.slice(t)).slice(
    (e = n) !== null && e !== void 0 ? e : 0,
    i + 1
  );
}
function yo(r) {
  let e = 0;
  for (; e < r.length && Ir(r.charCodeAt(e)); )
    ++e;
  return e;
}
function mo(r, e) {
  const t = r.replace(/"""/g, '\\"""'), n = t.split(/\r\n|[\n\r]/g), i = n.length === 1, s = n.length > 1 && n.slice(1).every((p) => p.length === 0 || Ir(p.charCodeAt(0))), o = t.endsWith('\\"""'), a = r.endsWith('"') && !o, c = r.endsWith("\\"), u = a || c, l = !(e != null && e.minimize) && (!i || r.length > 70 || u || s || o);
  let f = "";
  const h = i && Ir(r.charCodeAt(0));
  return (l && !h || s) && (f += `
`), f += t, (l || u) && (f += `
`), '"""' + f + '"""';
}
var m;
(function(r) {
  r.SOF = "<SOF>", r.EOF = "<EOF>", r.BANG = "!", r.DOLLAR = "$", r.AMP = "&", r.PAREN_L = "(", r.PAREN_R = ")", r.SPREAD = "...", r.COLON = ":", r.EQUALS = "=", r.AT = "@", r.BRACKET_L = "[", r.BRACKET_R = "]", r.BRACE_L = "{", r.PIPE = "|", r.BRACE_R = "}", r.NAME = "Name", r.INT = "Int", r.FLOAT = "Float", r.STRING = "String", r.BLOCK_STRING = "BlockString", r.COMMENT = "Comment";
})(m || (m = {}));
class go {
  constructor(e) {
    const t = new Yi(m.SOF, 0, 0, 0, 0);
    this.source = e, this.lastToken = t, this.token = t, this.line = 1, this.lineStart = 0;
  }
  get [Symbol.toStringTag]() {
    return "Lexer";
  }
  advance() {
    return this.lastToken = this.token, this.token = this.lookahead();
  }
  lookahead() {
    let e = this.token;
    if (e.kind !== m.EOF)
      do
        if (e.next)
          e = e.next;
        else {
          const t = Eo(this, e.end);
          e.next = t, t.prev = e, e = t;
        }
      while (e.kind === m.COMMENT);
    return e;
  }
}
function bo(r) {
  return r === m.BANG || r === m.DOLLAR || r === m.AMP || r === m.PAREN_L || r === m.PAREN_R || r === m.SPREAD || r === m.COLON || r === m.EQUALS || r === m.AT || r === m.BRACKET_L || r === m.BRACKET_R || r === m.BRACE_L || r === m.PIPE || r === m.BRACE_R;
}
function Ge(r) {
  return r >= 0 && r <= 55295 || r >= 57344 && r <= 1114111;
}
function zt(r, e) {
  return Ki(r.charCodeAt(e)) && es(r.charCodeAt(e + 1));
}
function Ki(r) {
  return r >= 55296 && r <= 56319;
}
function es(r) {
  return r >= 56320 && r <= 57343;
}
function _e(r, e) {
  const t = r.source.body.codePointAt(e);
  if (t === void 0)
    return m.EOF;
  if (t >= 32 && t <= 126) {
    const n = String.fromCodePoint(t);
    return n === '"' ? `'"'` : `"${n}"`;
  }
  return "U+" + t.toString(16).toUpperCase().padStart(4, "0");
}
function V(r, e, t, n, i) {
  const s = r.line, o = 1 + t - r.lineStart;
  return new Yi(e, t, n, s, o, i);
}
function Eo(r, e) {
  const t = r.source.body, n = t.length;
  let i = e;
  for (; i < n; ) {
    const s = t.charCodeAt(i);
    switch (s) {
      case 65279:
      case 9:
      case 32:
      case 44:
        ++i;
        continue;
      case 10:
        ++i, ++r.line, r.lineStart = i;
        continue;
      case 13:
        t.charCodeAt(i + 1) === 10 ? i += 2 : ++i, ++r.line, r.lineStart = i;
        continue;
      case 35:
        return _o(r, i);
      case 33:
        return V(r, m.BANG, i, i + 1);
      case 36:
        return V(r, m.DOLLAR, i, i + 1);
      case 38:
        return V(r, m.AMP, i, i + 1);
      case 40:
        return V(r, m.PAREN_L, i, i + 1);
      case 41:
        return V(r, m.PAREN_R, i, i + 1);
      case 46:
        if (t.charCodeAt(i + 1) === 46 && t.charCodeAt(i + 2) === 46)
          return V(r, m.SPREAD, i, i + 3);
        break;
      case 58:
        return V(r, m.COLON, i, i + 1);
      case 61:
        return V(r, m.EQUALS, i, i + 1);
      case 64:
        return V(r, m.AT, i, i + 1);
      case 91:
        return V(r, m.BRACKET_L, i, i + 1);
      case 93:
        return V(r, m.BRACKET_R, i, i + 1);
      case 123:
        return V(r, m.BRACE_L, i, i + 1);
      case 124:
        return V(r, m.PIPE, i, i + 1);
      case 125:
        return V(r, m.BRACE_R, i, i + 1);
      case 34:
        return t.charCodeAt(i + 1) === 34 && t.charCodeAt(i + 2) === 34 ? Io(r, i) : So(r, i);
    }
    if (ct(s) || s === 45)
      return wo(r, i, s);
    if (Xi(s))
      return xo(r, i);
    throw U(
      r.source,
      i,
      s === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : Ge(s) || zt(t, i) ? `Unexpected character: ${_e(r, i)}.` : `Invalid character: ${_e(r, i)}.`
    );
  }
  return V(r, m.EOF, n, n);
}
function _o(r, e) {
  const t = r.source.body, n = t.length;
  let i = e + 1;
  for (; i < n; ) {
    const s = t.charCodeAt(i);
    if (s === 10 || s === 13)
      break;
    if (Ge(s))
      ++i;
    else if (zt(t, i))
      i += 2;
    else
      break;
  }
  return V(
    r,
    m.COMMENT,
    e,
    i,
    t.slice(e + 1, i)
  );
}
function wo(r, e, t) {
  const n = r.source.body;
  let i = e, s = t, o = !1;
  if (s === 45 && (s = n.charCodeAt(++i)), s === 48) {
    if (s = n.charCodeAt(++i), ct(s))
      throw U(
        r.source,
        i,
        `Invalid number, unexpected digit after 0: ${_e(
          r,
          i
        )}.`
      );
  } else
    i = rr(r, i, s), s = n.charCodeAt(i);
  if (s === 46 && (o = !0, s = n.charCodeAt(++i), i = rr(r, i, s), s = n.charCodeAt(i)), (s === 69 || s === 101) && (o = !0, s = n.charCodeAt(++i), (s === 43 || s === 45) && (s = n.charCodeAt(++i)), i = rr(r, i, s), s = n.charCodeAt(i)), s === 46 || Xi(s))
    throw U(
      r.source,
      i,
      `Invalid number, expected digit but got: ${_e(
        r,
        i
      )}.`
    );
  return V(
    r,
    o ? m.FLOAT : m.INT,
    e,
    i,
    n.slice(e, i)
  );
}
function rr(r, e, t) {
  if (!ct(t))
    throw U(
      r.source,
      e,
      `Invalid number, expected digit but got: ${_e(
        r,
        e
      )}.`
    );
  const n = r.source.body;
  let i = e + 1;
  for (; ct(n.charCodeAt(i)); )
    ++i;
  return i;
}
function So(r, e) {
  const t = r.source.body, n = t.length;
  let i = e + 1, s = i, o = "";
  for (; i < n; ) {
    const a = t.charCodeAt(i);
    if (a === 34)
      return o += t.slice(s, i), V(r, m.STRING, e, i + 1, o);
    if (a === 92) {
      o += t.slice(s, i);
      const c = t.charCodeAt(i + 1) === 117 ? t.charCodeAt(i + 2) === 123 ? Oo(r, i) : Do(r, i) : To(r, i);
      o += c.value, i += c.size, s = i;
      continue;
    }
    if (a === 10 || a === 13)
      break;
    if (Ge(a))
      ++i;
    else if (zt(t, i))
      i += 2;
    else
      throw U(
        r.source,
        i,
        `Invalid character within String: ${_e(
          r,
          i
        )}.`
      );
  }
  throw U(r.source, i, "Unterminated string.");
}
function Oo(r, e) {
  const t = r.source.body;
  let n = 0, i = 3;
  for (; i < 12; ) {
    const s = t.charCodeAt(e + i++);
    if (s === 125) {
      if (i < 5 || !Ge(n))
        break;
      return {
        value: String.fromCodePoint(n),
        size: i
      };
    }
    if (n = n << 4 | tt(s), n < 0)
      break;
  }
  throw U(
    r.source,
    e,
    `Invalid Unicode escape sequence: "${t.slice(
      e,
      e + i
    )}".`
  );
}
function Do(r, e) {
  const t = r.source.body, n = Un(t, e + 2);
  if (Ge(n))
    return {
      value: String.fromCodePoint(n),
      size: 6
    };
  if (Ki(n) && t.charCodeAt(e + 6) === 92 && t.charCodeAt(e + 7) === 117) {
    const i = Un(t, e + 8);
    if (es(i))
      return {
        value: String.fromCodePoint(n, i),
        size: 12
      };
  }
  throw U(
    r.source,
    e,
    `Invalid Unicode escape sequence: "${t.slice(e, e + 6)}".`
  );
}
function Un(r, e) {
  return tt(r.charCodeAt(e)) << 12 | tt(r.charCodeAt(e + 1)) << 8 | tt(r.charCodeAt(e + 2)) << 4 | tt(r.charCodeAt(e + 3));
}
function tt(r) {
  return r >= 48 && r <= 57 ? r - 48 : r >= 65 && r <= 70 ? r - 55 : r >= 97 && r <= 102 ? r - 87 : -1;
}
function To(r, e) {
  const t = r.source.body;
  switch (t.charCodeAt(e + 1)) {
    case 34:
      return {
        value: '"',
        size: 2
      };
    case 92:
      return {
        value: "\\",
        size: 2
      };
    case 47:
      return {
        value: "/",
        size: 2
      };
    case 98:
      return {
        value: "\b",
        size: 2
      };
    case 102:
      return {
        value: "\f",
        size: 2
      };
    case 110:
      return {
        value: `
`,
        size: 2
      };
    case 114:
      return {
        value: "\r",
        size: 2
      };
    case 116:
      return {
        value: "	",
        size: 2
      };
  }
  throw U(
    r.source,
    e,
    `Invalid character escape sequence: "${t.slice(
      e,
      e + 2
    )}".`
  );
}
function Io(r, e) {
  const t = r.source.body, n = t.length;
  let i = r.lineStart, s = e + 3, o = s, a = "";
  const c = [];
  for (; s < n; ) {
    const u = t.charCodeAt(s);
    if (u === 34 && t.charCodeAt(s + 1) === 34 && t.charCodeAt(s + 2) === 34) {
      a += t.slice(o, s), c.push(a);
      const l = V(
        r,
        m.BLOCK_STRING,
        e,
        s + 3,
        vo(c).join(`
`)
      );
      return r.line += c.length - 1, r.lineStart = i, l;
    }
    if (u === 92 && t.charCodeAt(s + 1) === 34 && t.charCodeAt(s + 2) === 34 && t.charCodeAt(s + 3) === 34) {
      a += t.slice(o, s), o = s + 1, s += 4;
      continue;
    }
    if (u === 10 || u === 13) {
      a += t.slice(o, s), c.push(a), u === 13 && t.charCodeAt(s + 1) === 10 ? s += 2 : ++s, a = "", o = s, i = s;
      continue;
    }
    if (Ge(u))
      ++s;
    else if (zt(t, s))
      s += 2;
    else
      throw U(
        r.source,
        s,
        `Invalid character within String: ${_e(
          r,
          s
        )}.`
      );
  }
  throw U(r.source, s, "Unterminated string.");
}
function xo(r, e) {
  const t = r.source.body, n = t.length;
  let i = e + 1;
  for (; i < n; ) {
    const s = t.charCodeAt(i);
    if (po(s))
      ++i;
    else
      break;
  }
  return V(
    r,
    m.NAME,
    e,
    i,
    t.slice(e, i)
  );
}
const ko = 10, ts = 2;
function Kr(r) {
  return Bt(r, []);
}
function Bt(r, e) {
  switch (typeof r) {
    case "string":
      return JSON.stringify(r);
    case "function":
      return r.name ? `[function ${r.name}]` : "[function]";
    case "object":
      return Ao(r, e);
    default:
      return String(r);
  }
}
function Ao(r, e) {
  if (r === null)
    return "null";
  if (e.includes(r))
    return "[Circular]";
  const t = [...e, r];
  if (No(r)) {
    const n = r.toJSON();
    if (n !== r)
      return typeof n == "string" ? n : Bt(n, t);
  } else if (Array.isArray(r))
    return Mo(r, t);
  return Co(r, t);
}
function No(r) {
  return typeof r.toJSON == "function";
}
function Co(r, e) {
  const t = Object.entries(r);
  return t.length === 0 ? "{}" : e.length > ts ? "[" + Ro(r) + "]" : "{ " + t.map(
    ([i, s]) => i + ": " + Bt(s, e)
  ).join(", ") + " }";
}
function Mo(r, e) {
  if (r.length === 0)
    return "[]";
  if (e.length > ts)
    return "[Array]";
  const t = Math.min(ko, r.length), n = r.length - t, i = [];
  for (let s = 0; s < t; ++s)
    i.push(Bt(r[s], e));
  return n === 1 ? i.push("... 1 more item") : n > 1 && i.push(`... ${n} more items`), "[" + i.join(", ") + "]";
}
function Ro(r) {
  const e = Object.prototype.toString.call(r).replace(/^\[object /, "").replace(/]$/, "");
  if (e === "Object" && typeof r.constructor == "function") {
    const t = r.constructor.name;
    if (typeof t == "string" && t !== "")
      return t;
  }
  return e;
}
const Po = process.env.NODE_ENV === "production" ? function(e, t) {
  return e instanceof t;
} : function(e, t) {
  if (e instanceof t)
    return !0;
  if (typeof e == "object" && e !== null) {
    var n;
    const i = t.prototype[Symbol.toStringTag], s = Symbol.toStringTag in e ? e[Symbol.toStringTag] : (n = e.constructor) === null || n === void 0 ? void 0 : n.name;
    if (i === s) {
      const o = Kr(e);
      throw new Error(`Cannot use ${i} "${o}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
    }
  }
  return !1;
};
class en {
  constructor(e, t = "GraphQL request", n = {
    line: 1,
    column: 1
  }) {
    typeof e == "string" || It(!1, `Body must be a string. Received: ${Kr(e)}.`), this.body = e, this.name = t, this.locationOffset = n, this.locationOffset.line > 0 || It(
      !1,
      "line in locationOffset is 1-indexed and must be positive."
    ), this.locationOffset.column > 0 || It(
      !1,
      "column in locationOffset is 1-indexed and must be positive."
    );
  }
  get [Symbol.toStringTag]() {
    return "Source";
  }
}
function Fo(r) {
  return Po(r, en);
}
function Lo(r, e) {
  return new jo(r, e).parseDocument();
}
class jo {
  constructor(e, t = {}) {
    const n = Fo(e) ? e : new en(e);
    this._lexer = new go(n), this._options = t, this._tokenCounter = 0;
  }
  parseName() {
    const e = this.expectToken(m.NAME);
    return this.node(e, {
      kind: O.NAME,
      value: e.value
    });
  }
  parseDocument() {
    return this.node(this._lexer.token, {
      kind: O.DOCUMENT,
      definitions: this.many(
        m.SOF,
        this.parseDefinition,
        m.EOF
      )
    });
  }
  parseDefinition() {
    if (this.peek(m.BRACE_L))
      return this.parseOperationDefinition();
    const e = this.peekDescription(), t = e ? this._lexer.lookahead() : this._lexer.token;
    if (t.kind === m.NAME) {
      switch (t.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
      if (e)
        throw U(
          this._lexer.source,
          this._lexer.token.start,
          "Unexpected description, descriptions are supported only on type definitions."
        );
      switch (t.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
        case "extend":
          return this.parseTypeSystemExtension();
      }
    }
    throw this.unexpected(t);
  }
  parseOperationDefinition() {
    const e = this._lexer.token;
    if (this.peek(m.BRACE_L))
      return this.node(e, {
        kind: O.OPERATION_DEFINITION,
        operation: Ne.QUERY,
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet()
      });
    const t = this.parseOperationType();
    let n;
    return this.peek(m.NAME) && (n = this.parseName()), this.node(e, {
      kind: O.OPERATION_DEFINITION,
      operation: t,
      name: n,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  parseOperationType() {
    const e = this.expectToken(m.NAME);
    switch (e.value) {
      case "query":
        return Ne.QUERY;
      case "mutation":
        return Ne.MUTATION;
      case "subscription":
        return Ne.SUBSCRIPTION;
    }
    throw this.unexpected(e);
  }
  parseVariableDefinitions() {
    return this.optionalMany(
      m.PAREN_L,
      this.parseVariableDefinition,
      m.PAREN_R
    );
  }
  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: O.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(m.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(m.EQUALS) ? this.parseConstValueLiteral() : void 0,
      directives: this.parseConstDirectives()
    });
  }
  parseVariable() {
    const e = this._lexer.token;
    return this.expectToken(m.DOLLAR), this.node(e, {
      kind: O.VARIABLE,
      name: this.parseName()
    });
  }
  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: O.SELECTION_SET,
      selections: this.many(
        m.BRACE_L,
        this.parseSelection,
        m.BRACE_R
      )
    });
  }
  parseSelection() {
    return this.peek(m.SPREAD) ? this.parseFragment() : this.parseField();
  }
  parseField() {
    const e = this._lexer.token, t = this.parseName();
    let n, i;
    return this.expectOptionalToken(m.COLON) ? (n = t, i = this.parseName()) : i = t, this.node(e, {
      kind: O.FIELD,
      alias: n,
      name: i,
      arguments: this.parseArguments(!1),
      directives: this.parseDirectives(!1),
      selectionSet: this.peek(m.BRACE_L) ? this.parseSelectionSet() : void 0
    });
  }
  parseArguments(e) {
    const t = e ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(m.PAREN_L, t, m.PAREN_R);
  }
  parseArgument(e = !1) {
    const t = this._lexer.token, n = this.parseName();
    return this.expectToken(m.COLON), this.node(t, {
      kind: O.ARGUMENT,
      name: n,
      value: this.parseValueLiteral(e)
    });
  }
  parseConstArgument() {
    return this.parseArgument(!0);
  }
  parseFragment() {
    const e = this._lexer.token;
    this.expectToken(m.SPREAD);
    const t = this.expectOptionalKeyword("on");
    return !t && this.peek(m.NAME) ? this.node(e, {
      kind: O.FRAGMENT_SPREAD,
      name: this.parseFragmentName(),
      directives: this.parseDirectives(!1)
    }) : this.node(e, {
      kind: O.INLINE_FRAGMENT,
      typeCondition: t ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  parseFragmentDefinition() {
    const e = this._lexer.token;
    return this.expectKeyword("fragment"), this._options.allowLegacyFragmentVariables === !0 ? this.node(e, {
      kind: O.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      variableDefinitions: this.parseVariableDefinitions(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    }) : this.node(e, {
      kind: O.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  parseFragmentName() {
    if (this._lexer.token.value === "on")
      throw this.unexpected();
    return this.parseName();
  }
  parseValueLiteral(e) {
    const t = this._lexer.token;
    switch (t.kind) {
      case m.BRACKET_L:
        return this.parseList(e);
      case m.BRACE_L:
        return this.parseObject(e);
      case m.INT:
        return this.advanceLexer(), this.node(t, {
          kind: O.INT,
          value: t.value
        });
      case m.FLOAT:
        return this.advanceLexer(), this.node(t, {
          kind: O.FLOAT,
          value: t.value
        });
      case m.STRING:
      case m.BLOCK_STRING:
        return this.parseStringLiteral();
      case m.NAME:
        switch (this.advanceLexer(), t.value) {
          case "true":
            return this.node(t, {
              kind: O.BOOLEAN,
              value: !0
            });
          case "false":
            return this.node(t, {
              kind: O.BOOLEAN,
              value: !1
            });
          case "null":
            return this.node(t, {
              kind: O.NULL
            });
          default:
            return this.node(t, {
              kind: O.ENUM,
              value: t.value
            });
        }
      case m.DOLLAR:
        if (e)
          if (this.expectToken(m.DOLLAR), this._lexer.token.kind === m.NAME) {
            const n = this._lexer.token.value;
            throw U(
              this._lexer.source,
              t.start,
              `Unexpected variable "$${n}" in constant value.`
            );
          } else
            throw this.unexpected(t);
        return this.parseVariable();
      default:
        throw this.unexpected();
    }
  }
  parseConstValueLiteral() {
    return this.parseValueLiteral(!0);
  }
  parseStringLiteral() {
    const e = this._lexer.token;
    return this.advanceLexer(), this.node(e, {
      kind: O.STRING,
      value: e.value,
      block: e.kind === m.BLOCK_STRING
    });
  }
  parseList(e) {
    const t = () => this.parseValueLiteral(e);
    return this.node(this._lexer.token, {
      kind: O.LIST,
      values: this.any(m.BRACKET_L, t, m.BRACKET_R)
    });
  }
  parseObject(e) {
    const t = () => this.parseObjectField(e);
    return this.node(this._lexer.token, {
      kind: O.OBJECT,
      fields: this.any(m.BRACE_L, t, m.BRACE_R)
    });
  }
  parseObjectField(e) {
    const t = this._lexer.token, n = this.parseName();
    return this.expectToken(m.COLON), this.node(t, {
      kind: O.OBJECT_FIELD,
      name: n,
      value: this.parseValueLiteral(e)
    });
  }
  parseDirectives(e) {
    const t = [];
    for (; this.peek(m.AT); )
      t.push(this.parseDirective(e));
    return t;
  }
  parseConstDirectives() {
    return this.parseDirectives(!0);
  }
  parseDirective(e) {
    const t = this._lexer.token;
    return this.expectToken(m.AT), this.node(t, {
      kind: O.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(e)
    });
  }
  parseTypeReference() {
    const e = this._lexer.token;
    let t;
    if (this.expectOptionalToken(m.BRACKET_L)) {
      const n = this.parseTypeReference();
      this.expectToken(m.BRACKET_R), t = this.node(e, {
        kind: O.LIST_TYPE,
        type: n
      });
    } else
      t = this.parseNamedType();
    return this.expectOptionalToken(m.BANG) ? this.node(e, {
      kind: O.NON_NULL_TYPE,
      type: t
    }) : t;
  }
  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: O.NAMED_TYPE,
      name: this.parseName()
    });
  }
  peekDescription() {
    return this.peek(m.STRING) || this.peek(m.BLOCK_STRING);
  }
  parseDescription() {
    if (this.peekDescription())
      return this.parseStringLiteral();
  }
  parseSchemaDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("schema");
    const n = this.parseConstDirectives(), i = this.many(
      m.BRACE_L,
      this.parseOperationTypeDefinition,
      m.BRACE_R
    );
    return this.node(e, {
      kind: O.SCHEMA_DEFINITION,
      description: t,
      directives: n,
      operationTypes: i
    });
  }
  parseOperationTypeDefinition() {
    const e = this._lexer.token, t = this.parseOperationType();
    this.expectToken(m.COLON);
    const n = this.parseNamedType();
    return this.node(e, {
      kind: O.OPERATION_TYPE_DEFINITION,
      operation: t,
      type: n
    });
  }
  parseScalarTypeDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("scalar");
    const n = this.parseName(), i = this.parseConstDirectives();
    return this.node(e, {
      kind: O.SCALAR_TYPE_DEFINITION,
      description: t,
      name: n,
      directives: i
    });
  }
  parseObjectTypeDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("type");
    const n = this.parseName(), i = this.parseImplementsInterfaces(), s = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    return this.node(e, {
      kind: O.OBJECT_TYPE_DEFINITION,
      description: t,
      name: n,
      interfaces: i,
      directives: s,
      fields: o
    });
  }
  parseImplementsInterfaces() {
    return this.expectOptionalKeyword("implements") ? this.delimitedMany(m.AMP, this.parseNamedType) : [];
  }
  parseFieldsDefinition() {
    return this.optionalMany(
      m.BRACE_L,
      this.parseFieldDefinition,
      m.BRACE_R
    );
  }
  parseFieldDefinition() {
    const e = this._lexer.token, t = this.parseDescription(), n = this.parseName(), i = this.parseArgumentDefs();
    this.expectToken(m.COLON);
    const s = this.parseTypeReference(), o = this.parseConstDirectives();
    return this.node(e, {
      kind: O.FIELD_DEFINITION,
      description: t,
      name: n,
      arguments: i,
      type: s,
      directives: o
    });
  }
  parseArgumentDefs() {
    return this.optionalMany(
      m.PAREN_L,
      this.parseInputValueDef,
      m.PAREN_R
    );
  }
  parseInputValueDef() {
    const e = this._lexer.token, t = this.parseDescription(), n = this.parseName();
    this.expectToken(m.COLON);
    const i = this.parseTypeReference();
    let s;
    this.expectOptionalToken(m.EQUALS) && (s = this.parseConstValueLiteral());
    const o = this.parseConstDirectives();
    return this.node(e, {
      kind: O.INPUT_VALUE_DEFINITION,
      description: t,
      name: n,
      type: i,
      defaultValue: s,
      directives: o
    });
  }
  parseInterfaceTypeDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("interface");
    const n = this.parseName(), i = this.parseImplementsInterfaces(), s = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    return this.node(e, {
      kind: O.INTERFACE_TYPE_DEFINITION,
      description: t,
      name: n,
      interfaces: i,
      directives: s,
      fields: o
    });
  }
  parseUnionTypeDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("union");
    const n = this.parseName(), i = this.parseConstDirectives(), s = this.parseUnionMemberTypes();
    return this.node(e, {
      kind: O.UNION_TYPE_DEFINITION,
      description: t,
      name: n,
      directives: i,
      types: s
    });
  }
  parseUnionMemberTypes() {
    return this.expectOptionalToken(m.EQUALS) ? this.delimitedMany(m.PIPE, this.parseNamedType) : [];
  }
  parseEnumTypeDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("enum");
    const n = this.parseName(), i = this.parseConstDirectives(), s = this.parseEnumValuesDefinition();
    return this.node(e, {
      kind: O.ENUM_TYPE_DEFINITION,
      description: t,
      name: n,
      directives: i,
      values: s
    });
  }
  parseEnumValuesDefinition() {
    return this.optionalMany(
      m.BRACE_L,
      this.parseEnumValueDefinition,
      m.BRACE_R
    );
  }
  parseEnumValueDefinition() {
    const e = this._lexer.token, t = this.parseDescription(), n = this.parseEnumValueName(), i = this.parseConstDirectives();
    return this.node(e, {
      kind: O.ENUM_VALUE_DEFINITION,
      description: t,
      name: n,
      directives: i
    });
  }
  parseEnumValueName() {
    if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null")
      throw U(
        this._lexer.source,
        this._lexer.token.start,
        `${St(
          this._lexer.token
        )} is reserved and cannot be used for an enum value.`
      );
    return this.parseName();
  }
  parseInputObjectTypeDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("input");
    const n = this.parseName(), i = this.parseConstDirectives(), s = this.parseInputFieldsDefinition();
    return this.node(e, {
      kind: O.INPUT_OBJECT_TYPE_DEFINITION,
      description: t,
      name: n,
      directives: i,
      fields: s
    });
  }
  parseInputFieldsDefinition() {
    return this.optionalMany(
      m.BRACE_L,
      this.parseInputValueDef,
      m.BRACE_R
    );
  }
  parseTypeSystemExtension() {
    const e = this._lexer.lookahead();
    if (e.kind === m.NAME)
      switch (e.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
      }
    throw this.unexpected(e);
  }
  parseSchemaExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("schema");
    const t = this.parseConstDirectives(), n = this.optionalMany(
      m.BRACE_L,
      this.parseOperationTypeDefinition,
      m.BRACE_R
    );
    if (t.length === 0 && n.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: O.SCHEMA_EXTENSION,
      directives: t,
      operationTypes: n
    });
  }
  parseScalarTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("scalar");
    const t = this.parseName(), n = this.parseConstDirectives();
    if (n.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: O.SCALAR_TYPE_EXTENSION,
      name: t,
      directives: n
    });
  }
  parseObjectTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("type");
    const t = this.parseName(), n = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), s = this.parseFieldsDefinition();
    if (n.length === 0 && i.length === 0 && s.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: O.OBJECT_TYPE_EXTENSION,
      name: t,
      interfaces: n,
      directives: i,
      fields: s
    });
  }
  parseInterfaceTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("interface");
    const t = this.parseName(), n = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), s = this.parseFieldsDefinition();
    if (n.length === 0 && i.length === 0 && s.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: O.INTERFACE_TYPE_EXTENSION,
      name: t,
      interfaces: n,
      directives: i,
      fields: s
    });
  }
  parseUnionTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("union");
    const t = this.parseName(), n = this.parseConstDirectives(), i = this.parseUnionMemberTypes();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: O.UNION_TYPE_EXTENSION,
      name: t,
      directives: n,
      types: i
    });
  }
  parseEnumTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("enum");
    const t = this.parseName(), n = this.parseConstDirectives(), i = this.parseEnumValuesDefinition();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: O.ENUM_TYPE_EXTENSION,
      name: t,
      directives: n,
      values: i
    });
  }
  parseInputObjectTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("input");
    const t = this.parseName(), n = this.parseConstDirectives(), i = this.parseInputFieldsDefinition();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: O.INPUT_OBJECT_TYPE_EXTENSION,
      name: t,
      directives: n,
      fields: i
    });
  }
  parseDirectiveDefinition() {
    const e = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("directive"), this.expectToken(m.AT);
    const n = this.parseName(), i = this.parseArgumentDefs(), s = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    const o = this.parseDirectiveLocations();
    return this.node(e, {
      kind: O.DIRECTIVE_DEFINITION,
      description: t,
      name: n,
      arguments: i,
      repeatable: s,
      locations: o
    });
  }
  parseDirectiveLocations() {
    return this.delimitedMany(m.PIPE, this.parseDirectiveLocation);
  }
  parseDirectiveLocation() {
    const e = this._lexer.token, t = this.parseName();
    if (Object.prototype.hasOwnProperty.call(Tr, t.value))
      return t;
    throw this.unexpected(e);
  }
  node(e, t) {
    return this._options.noLocation !== !0 && (t.loc = new fo(
      e,
      this._lexer.lastToken,
      this._lexer.source
    )), t;
  }
  peek(e) {
    return this._lexer.token.kind === e;
  }
  expectToken(e) {
    const t = this._lexer.token;
    if (t.kind === e)
      return this.advanceLexer(), t;
    throw U(
      this._lexer.source,
      t.start,
      `Expected ${rs(e)}, found ${St(t)}.`
    );
  }
  expectOptionalToken(e) {
    return this._lexer.token.kind === e ? (this.advanceLexer(), !0) : !1;
  }
  expectKeyword(e) {
    const t = this._lexer.token;
    if (t.kind === m.NAME && t.value === e)
      this.advanceLexer();
    else
      throw U(
        this._lexer.source,
        t.start,
        `Expected "${e}", found ${St(t)}.`
      );
  }
  expectOptionalKeyword(e) {
    const t = this._lexer.token;
    return t.kind === m.NAME && t.value === e ? (this.advanceLexer(), !0) : !1;
  }
  unexpected(e) {
    const t = e != null ? e : this._lexer.token;
    return U(
      this._lexer.source,
      t.start,
      `Unexpected ${St(t)}.`
    );
  }
  any(e, t, n) {
    this.expectToken(e);
    const i = [];
    for (; !this.expectOptionalToken(n); )
      i.push(t.call(this));
    return i;
  }
  optionalMany(e, t, n) {
    if (this.expectOptionalToken(e)) {
      const i = [];
      do
        i.push(t.call(this));
      while (!this.expectOptionalToken(n));
      return i;
    }
    return [];
  }
  many(e, t, n) {
    this.expectToken(e);
    const i = [];
    do
      i.push(t.call(this));
    while (!this.expectOptionalToken(n));
    return i;
  }
  delimitedMany(e, t) {
    this.expectOptionalToken(e);
    const n = [];
    do
      n.push(t.call(this));
    while (this.expectOptionalToken(e));
    return n;
  }
  advanceLexer() {
    const { maxTokens: e } = this._options, t = this._lexer.advance();
    if (e !== void 0 && t.kind !== m.EOF && (++this._tokenCounter, this._tokenCounter > e))
      throw U(
        this._lexer.source,
        t.start,
        `Document contains more that ${e} tokens. Parsing aborted.`
      );
  }
}
function St(r) {
  const e = r.value;
  return rs(r.kind) + (e != null ? ` "${e}"` : "");
}
function rs(r) {
  return bo(r) ? `"${r}"` : r;
}
function Vo(r) {
  return `"${r.replace(Qo, $o)}"`;
}
const Qo = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function $o(r) {
  return qo[r.charCodeAt(0)];
}
const qo = [
  "\\u0000",
  "\\u0001",
  "\\u0002",
  "\\u0003",
  "\\u0004",
  "\\u0005",
  "\\u0006",
  "\\u0007",
  "\\b",
  "\\t",
  "\\n",
  "\\u000B",
  "\\f",
  "\\r",
  "\\u000E",
  "\\u000F",
  "\\u0010",
  "\\u0011",
  "\\u0012",
  "\\u0013",
  "\\u0014",
  "\\u0015",
  "\\u0016",
  "\\u0017",
  "\\u0018",
  "\\u0019",
  "\\u001A",
  "\\u001B",
  "\\u001C",
  "\\u001D",
  "\\u001E",
  "\\u001F",
  "",
  "",
  '\\"',
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\\\",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\u007F",
  "\\u0080",
  "\\u0081",
  "\\u0082",
  "\\u0083",
  "\\u0084",
  "\\u0085",
  "\\u0086",
  "\\u0087",
  "\\u0088",
  "\\u0089",
  "\\u008A",
  "\\u008B",
  "\\u008C",
  "\\u008D",
  "\\u008E",
  "\\u008F",
  "\\u0090",
  "\\u0091",
  "\\u0092",
  "\\u0093",
  "\\u0094",
  "\\u0095",
  "\\u0096",
  "\\u0097",
  "\\u0098",
  "\\u0099",
  "\\u009A",
  "\\u009B",
  "\\u009C",
  "\\u009D",
  "\\u009E",
  "\\u009F"
], tn = Object.freeze({});
function ie(r, e, t = Ji) {
  const n = /* @__PURE__ */ new Map();
  for (const E of Object.values(O))
    n.set(E, Uo(e, E));
  let i, s = Array.isArray(r), o = [r], a = -1, c = [], u = r, l, f;
  const h = [], p = [];
  do {
    a++;
    const E = a === o.length, T = E && c.length !== 0;
    if (E) {
      if (l = p.length === 0 ? void 0 : h[h.length - 1], u = f, f = p.pop(), T)
        if (s) {
          u = u.slice();
          let S = 0;
          for (const [x, k] of c) {
            const D = x - S;
            k === null ? (u.splice(D, 1), S++) : u[D] = k;
          }
        } else {
          u = Object.defineProperties(
            {},
            Object.getOwnPropertyDescriptors(u)
          );
          for (const [S, x] of c)
            u[S] = x;
        }
      a = i.index, o = i.keys, c = i.edits, s = i.inArray, i = i.prev;
    } else if (f) {
      if (l = s ? a : o[a], u = f[l], u == null)
        continue;
      h.push(l);
    }
    let b;
    if (!Array.isArray(u)) {
      var d, v;
      qn(u) || It(!1, `Invalid AST Node: ${Kr(u)}.`);
      const S = E ? (d = n.get(u.kind)) === null || d === void 0 ? void 0 : d.leave : (v = n.get(u.kind)) === null || v === void 0 ? void 0 : v.enter;
      if (b = S == null ? void 0 : S.call(e, u, l, f, h, p), b === tn)
        break;
      if (b === !1) {
        if (!E) {
          h.pop();
          continue;
        }
      } else if (b !== void 0 && (c.push([l, b]), !E))
        if (qn(b))
          u = b;
        else {
          h.pop();
          continue;
        }
    }
    if (b === void 0 && T && c.push([l, u]), E)
      h.pop();
    else {
      var g;
      i = {
        inArray: s,
        index: a,
        keys: o,
        edits: c,
        prev: i
      }, s = Array.isArray(u), o = s ? u : (g = t[u.kind]) !== null && g !== void 0 ? g : [], a = -1, c = [], f && p.push(f), f = u;
    }
  } while (i !== void 0);
  return c.length !== 0 ? c[c.length - 1][1] : r;
}
function Uo(r, e) {
  const t = r[e];
  return typeof t == "object" ? t : typeof t == "function" ? {
    enter: t,
    leave: void 0
  } : {
    enter: r.enter,
    leave: r.leave
  };
}
function zo(r) {
  return ie(r, Ho);
}
const Bo = 80, Ho = {
  Name: {
    leave: (r) => r.value
  },
  Variable: {
    leave: (r) => "$" + r.name
  },
  Document: {
    leave: (r) => w(r.definitions, `

`)
  },
  OperationDefinition: {
    leave(r) {
      const e = A("(", w(r.variableDefinitions, ", "), ")"), t = w(
        [
          r.operation,
          w([r.name, e]),
          w(r.directives, " ")
        ],
        " "
      );
      return (t === "query" ? "" : t + " ") + r.selectionSet;
    }
  },
  VariableDefinition: {
    leave: ({ variable: r, type: e, defaultValue: t, directives: n }) => r + ": " + e + A(" = ", t) + A(" ", w(n, " "))
  },
  SelectionSet: {
    leave: ({ selections: r }) => Z(r)
  },
  Field: {
    leave({ alias: r, name: e, arguments: t, directives: n, selectionSet: i }) {
      const s = A("", r, ": ") + e;
      let o = s + A("(", w(t, ", "), ")");
      return o.length > Bo && (o = s + A(`(
`, xt(w(t, `
`)), `
)`)), w([o, w(n, " "), i], " ");
    }
  },
  Argument: {
    leave: ({ name: r, value: e }) => r + ": " + e
  },
  FragmentSpread: {
    leave: ({ name: r, directives: e }) => "..." + r + A(" ", w(e, " "))
  },
  InlineFragment: {
    leave: ({ typeCondition: r, directives: e, selectionSet: t }) => w(
      [
        "...",
        A("on ", r),
        w(e, " "),
        t
      ],
      " "
    )
  },
  FragmentDefinition: {
    leave: ({ name: r, typeCondition: e, variableDefinitions: t, directives: n, selectionSet: i }) => `fragment ${r}${A("(", w(t, ", "), ")")} on ${e} ${A("", w(n, " "), " ")}` + i
  },
  IntValue: {
    leave: ({ value: r }) => r
  },
  FloatValue: {
    leave: ({ value: r }) => r
  },
  StringValue: {
    leave: ({ value: r, block: e }) => e ? mo(r) : Vo(r)
  },
  BooleanValue: {
    leave: ({ value: r }) => r ? "true" : "false"
  },
  NullValue: {
    leave: () => "null"
  },
  EnumValue: {
    leave: ({ value: r }) => r
  },
  ListValue: {
    leave: ({ values: r }) => "[" + w(r, ", ") + "]"
  },
  ObjectValue: {
    leave: ({ fields: r }) => "{" + w(r, ", ") + "}"
  },
  ObjectField: {
    leave: ({ name: r, value: e }) => r + ": " + e
  },
  Directive: {
    leave: ({ name: r, arguments: e }) => "@" + r + A("(", w(e, ", "), ")")
  },
  NamedType: {
    leave: ({ name: r }) => r
  },
  ListType: {
    leave: ({ type: r }) => "[" + r + "]"
  },
  NonNullType: {
    leave: ({ type: r }) => r + "!"
  },
  SchemaDefinition: {
    leave: ({ description: r, directives: e, operationTypes: t }) => A("", r, `
`) + w(["schema", w(e, " "), Z(t)], " ")
  },
  OperationTypeDefinition: {
    leave: ({ operation: r, type: e }) => r + ": " + e
  },
  ScalarTypeDefinition: {
    leave: ({ description: r, name: e, directives: t }) => A("", r, `
`) + w(["scalar", e, w(t, " ")], " ")
  },
  ObjectTypeDefinition: {
    leave: ({ description: r, name: e, interfaces: t, directives: n, fields: i }) => A("", r, `
`) + w(
      [
        "type",
        e,
        A("implements ", w(t, " & ")),
        w(n, " "),
        Z(i)
      ],
      " "
    )
  },
  FieldDefinition: {
    leave: ({ description: r, name: e, arguments: t, type: n, directives: i }) => A("", r, `
`) + e + (zn(t) ? A(`(
`, xt(w(t, `
`)), `
)`) : A("(", w(t, ", "), ")")) + ": " + n + A(" ", w(i, " "))
  },
  InputValueDefinition: {
    leave: ({ description: r, name: e, type: t, defaultValue: n, directives: i }) => A("", r, `
`) + w(
      [e + ": " + t, A("= ", n), w(i, " ")],
      " "
    )
  },
  InterfaceTypeDefinition: {
    leave: ({ description: r, name: e, interfaces: t, directives: n, fields: i }) => A("", r, `
`) + w(
      [
        "interface",
        e,
        A("implements ", w(t, " & ")),
        w(n, " "),
        Z(i)
      ],
      " "
    )
  },
  UnionTypeDefinition: {
    leave: ({ description: r, name: e, directives: t, types: n }) => A("", r, `
`) + w(
      ["union", e, w(t, " "), A("= ", w(n, " | "))],
      " "
    )
  },
  EnumTypeDefinition: {
    leave: ({ description: r, name: e, directives: t, values: n }) => A("", r, `
`) + w(["enum", e, w(t, " "), Z(n)], " ")
  },
  EnumValueDefinition: {
    leave: ({ description: r, name: e, directives: t }) => A("", r, `
`) + w([e, w(t, " ")], " ")
  },
  InputObjectTypeDefinition: {
    leave: ({ description: r, name: e, directives: t, fields: n }) => A("", r, `
`) + w(["input", e, w(t, " "), Z(n)], " ")
  },
  DirectiveDefinition: {
    leave: ({ description: r, name: e, arguments: t, repeatable: n, locations: i }) => A("", r, `
`) + "directive @" + e + (zn(t) ? A(`(
`, xt(w(t, `
`)), `
)`) : A("(", w(t, ", "), ")")) + (n ? " repeatable" : "") + " on " + w(i, " | ")
  },
  SchemaExtension: {
    leave: ({ directives: r, operationTypes: e }) => w(
      ["extend schema", w(r, " "), Z(e)],
      " "
    )
  },
  ScalarTypeExtension: {
    leave: ({ name: r, directives: e }) => w(["extend scalar", r, w(e, " ")], " ")
  },
  ObjectTypeExtension: {
    leave: ({ name: r, interfaces: e, directives: t, fields: n }) => w(
      [
        "extend type",
        r,
        A("implements ", w(e, " & ")),
        w(t, " "),
        Z(n)
      ],
      " "
    )
  },
  InterfaceTypeExtension: {
    leave: ({ name: r, interfaces: e, directives: t, fields: n }) => w(
      [
        "extend interface",
        r,
        A("implements ", w(e, " & ")),
        w(t, " "),
        Z(n)
      ],
      " "
    )
  },
  UnionTypeExtension: {
    leave: ({ name: r, directives: e, types: t }) => w(
      [
        "extend union",
        r,
        w(e, " "),
        A("= ", w(t, " | "))
      ],
      " "
    )
  },
  EnumTypeExtension: {
    leave: ({ name: r, directives: e, values: t }) => w(["extend enum", r, w(e, " "), Z(t)], " ")
  },
  InputObjectTypeExtension: {
    leave: ({ name: r, directives: e, fields: t }) => w(["extend input", r, w(e, " "), Z(t)], " ")
  }
};
function w(r, e = "") {
  var t;
  return (t = r == null ? void 0 : r.filter((n) => n).join(e)) !== null && t !== void 0 ? t : "";
}
function Z(r) {
  return A(`{
`, xt(w(r, `
`)), `
}`);
}
function A(r, e, t = "") {
  return e != null && e !== "" ? r + e + t : "";
}
function xt(r) {
  return A("  ", r.replace(/\n/g, `
  `));
}
function zn(r) {
  var e;
  return (e = r == null ? void 0 : r.some((t) => t.includes(`
`))) !== null && e !== void 0 ? e : !1;
}
function Wo() {
  return Vn();
}
function Go() {
  __DEV__ ? _(typeof tr == "boolean", tr) : _(typeof tr == "boolean", 38);
}
Wo();
Go();
function Ht(r, e) {
  var t = r.directives;
  return !t || !t.length ? !0 : Zo(t).every(function(n) {
    var i = n.directive, s = n.ifArgument, o = !1;
    return s.value.kind === "Variable" ? (o = e && e[s.value.name.value], __DEV__ ? _(o !== void 0, "Invalid variable referenced in @".concat(i.name.value, " directive.")) : _(o !== void 0, 39)) : o = s.value.value, i.name.value === "skip" ? !o : o;
  });
}
function rn(r, e, t) {
  var n = new Set(r), i = n.size;
  return ie(e, {
    Directive: function(s) {
      if (n.delete(s.name.value) && (!t || !n.size))
        return tn;
    }
  }), t ? !n.size : n.size < i;
}
function Yo(r) {
  return r && rn(["client", "export"], r, !0);
}
function Jo(r) {
  var e = r.name.value;
  return e === "skip" || e === "include";
}
function Zo(r) {
  var e = [];
  return r && r.length && r.forEach(function(t) {
    if (!!Jo(t)) {
      var n = t.arguments, i = t.name.value;
      __DEV__ ? _(n && n.length === 1, "Incorrect number of arguments for the @".concat(i, " directive.")) : _(n && n.length === 1, 40);
      var s = n[0];
      __DEV__ ? _(s.name && s.name.value === "if", "Invalid argument for the @".concat(i, " directive.")) : _(s.name && s.name.value === "if", 41);
      var o = s.value;
      __DEV__ ? _(o && (o.kind === "Variable" || o.kind === "BooleanValue"), "Argument for the @".concat(i, " directive must be a variable or a boolean value.")) : _(o && (o.kind === "Variable" || o.kind === "BooleanValue"), 42), e.push({ directive: t, ifArgument: s });
    }
  }), e;
}
function Xo(r, e) {
  var t = e, n = [];
  r.definitions.forEach(function(s) {
    if (s.kind === "OperationDefinition")
      throw __DEV__ ? new N("Found a ".concat(s.operation, " operation").concat(s.name ? " named '".concat(s.name.value, "'") : "", ". ") + "No operations are allowed when using a fragment as a query. Only fragments are allowed.") : new N(43);
    s.kind === "FragmentDefinition" && n.push(s);
  }), typeof t > "u" && (__DEV__ ? _(n.length === 1, "Found ".concat(n.length, " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.")) : _(n.length === 1, 44), t = n[0].name.value);
  var i = y(y({}, r), { definitions: Rt([
    {
      kind: "OperationDefinition",
      operation: "query",
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: t
            }
          }
        ]
      }
    }
  ], r.definitions, !0) });
  return i;
}
function nn(r) {
  r === void 0 && (r = []);
  var e = {};
  return r.forEach(function(t) {
    e[t.name.value] = t;
  }), e;
}
function sn(r, e) {
  switch (r.kind) {
    case "InlineFragment":
      return r;
    case "FragmentSpread": {
      var t = r.name.value;
      if (typeof e == "function")
        return e(t);
      var n = e && e[t];
      return __DEV__ ? _(n, "No fragment named ".concat(t)) : _(n, 45), n || null;
    }
    default:
      return null;
  }
}
function P(r) {
  return r !== null && typeof r == "object";
}
function Re(r) {
  return { __ref: String(r) };
}
function C(r) {
  return Boolean(r && typeof r == "object" && typeof r.__ref == "string");
}
function Ko(r) {
  return P(r) && r.kind === "Document" && Array.isArray(r.definitions);
}
function ea(r) {
  return r.kind === "StringValue";
}
function ta(r) {
  return r.kind === "BooleanValue";
}
function ra(r) {
  return r.kind === "IntValue";
}
function na(r) {
  return r.kind === "FloatValue";
}
function ia(r) {
  return r.kind === "Variable";
}
function sa(r) {
  return r.kind === "ObjectValue";
}
function oa(r) {
  return r.kind === "ListValue";
}
function aa(r) {
  return r.kind === "EnumValue";
}
function ua(r) {
  return r.kind === "NullValue";
}
function Qe(r, e, t, n) {
  if (ra(t) || na(t))
    r[e.value] = Number(t.value);
  else if (ta(t) || ea(t))
    r[e.value] = t.value;
  else if (sa(t)) {
    var i = {};
    t.fields.map(function(o) {
      return Qe(i, o.name, o.value, n);
    }), r[e.value] = i;
  } else if (ia(t)) {
    var s = (n || {})[t.name.value];
    r[e.value] = s;
  } else if (oa(t))
    r[e.value] = t.values.map(function(o) {
      var a = {};
      return Qe(a, e, o, n), a[e.value];
    });
  else if (aa(t))
    r[e.value] = t.value;
  else if (ua(t))
    r[e.value] = null;
  else
    throw __DEV__ ? new N('The inline argument "'.concat(e.value, '" of kind "').concat(t.kind, '"') + "is not supported. Use variables instead of inline arguments to overcome this limitation.") : new N(54);
}
function ca(r, e) {
  var t = null;
  r.directives && (t = {}, r.directives.forEach(function(i) {
    t[i.name.value] = {}, i.arguments && i.arguments.forEach(function(s) {
      var o = s.name, a = s.value;
      return Qe(t[i.name.value], o, a, e);
    });
  }));
  var n = null;
  return r.arguments && r.arguments.length && (n = {}, r.arguments.forEach(function(i) {
    var s = i.name, o = i.value;
    return Qe(n, s, o, e);
  })), on(r.name.value, n, t);
}
var la = [
  "connection",
  "include",
  "skip",
  "client",
  "rest",
  "export"
], on = Object.assign(function(r, e, t) {
  if (e && t && t.connection && t.connection.key)
    if (t.connection.filter && t.connection.filter.length > 0) {
      var n = t.connection.filter ? t.connection.filter : [];
      n.sort();
      var i = {};
      return n.forEach(function(a) {
        i[a] = e[a];
      }), "".concat(t.connection.key, "(").concat(Ye(i), ")");
    } else
      return t.connection.key;
  var s = r;
  if (e) {
    var o = Ye(e);
    s += "(".concat(o, ")");
  }
  return t && Object.keys(t).forEach(function(a) {
    la.indexOf(a) === -1 && (t[a] && Object.keys(t[a]).length ? s += "@".concat(a, "(").concat(Ye(t[a]), ")") : s += "@".concat(a));
  }), s;
}, {
  setStringify: function(r) {
    var e = Ye;
    return Ye = r, e;
  }
}), Ye = function(e) {
  return JSON.stringify(e, fa);
};
function fa(r, e) {
  return P(e) && !Array.isArray(e) && (e = Object.keys(e).sort().reduce(function(t, n) {
    return t[n] = e[n], t;
  }, {})), e;
}
function Wt(r, e) {
  if (r.arguments && r.arguments.length) {
    var t = {};
    return r.arguments.forEach(function(n) {
      var i = n.name, s = n.value;
      return Qe(t, i, s, e);
    }), t;
  }
  return null;
}
function we(r) {
  return r.alias ? r.alias.value : r.name.value;
}
function xr(r, e, t) {
  if (typeof r.__typename == "string")
    return r.__typename;
  for (var n = 0, i = e.selections; n < i.length; n++) {
    var s = i[n];
    if (oe(s)) {
      if (s.name.value === "__typename")
        return r[we(s)];
    } else {
      var o = xr(r, sn(s, t).selectionSet, t);
      if (typeof o == "string")
        return o;
    }
  }
}
function oe(r) {
  return r.kind === "Field";
}
function ns(r) {
  return r.kind === "InlineFragment";
}
function Gt(r) {
  __DEV__ ? _(r && r.kind === "Document", 'Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a "gql" tag? http://docs.apollostack.com/apollo-client/core.html#gql') : _(r && r.kind === "Document", 46);
  var e = r.definitions.filter(function(t) {
    return t.kind !== "FragmentDefinition";
  }).map(function(t) {
    if (t.kind !== "OperationDefinition")
      throw __DEV__ ? new N('Schema type definitions not allowed in queries. Found: "'.concat(t.kind, '"')) : new N(47);
    return t;
  });
  return __DEV__ ? _(e.length <= 1, "Ambiguous GraphQL document: contains ".concat(e.length, " operations")) : _(e.length <= 1, 48), r;
}
function gt(r) {
  return Gt(r), r.definitions.filter(function(e) {
    return e.kind === "OperationDefinition";
  })[0];
}
function kr(r) {
  return r.definitions.filter(function(e) {
    return e.kind === "OperationDefinition" && e.name;
  }).map(function(e) {
    return e.name.value;
  })[0] || null;
}
function an(r) {
  return r.definitions.filter(function(e) {
    return e.kind === "FragmentDefinition";
  });
}
function is(r) {
  var e = gt(r);
  return __DEV__ ? _(e && e.operation === "query", "Must contain a query definition.") : _(e && e.operation === "query", 49), e;
}
function ha(r) {
  __DEV__ ? _(r.kind === "Document", 'Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a "gql" tag? http://docs.apollostack.com/apollo-client/core.html#gql') : _(r.kind === "Document", 50), __DEV__ ? _(r.definitions.length <= 1, "Fragment must have exactly one definition.") : _(r.definitions.length <= 1, 51);
  var e = r.definitions[0];
  return __DEV__ ? _(e.kind === "FragmentDefinition", "Must be a fragment definition.") : _(e.kind === "FragmentDefinition", 52), e;
}
function un(r) {
  Gt(r);
  for (var e, t = 0, n = r.definitions; t < n.length; t++) {
    var i = n[t];
    if (i.kind === "OperationDefinition") {
      var s = i.operation;
      if (s === "query" || s === "mutation" || s === "subscription")
        return i;
    }
    i.kind === "FragmentDefinition" && !e && (e = i);
  }
  if (e)
    return e;
  throw __DEV__ ? new N("Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment.") : new N(53);
}
function cn(r) {
  var e = /* @__PURE__ */ Object.create(null), t = r && r.variableDefinitions;
  return t && t.length && t.forEach(function(n) {
    n.defaultValue && Qe(e, n.variable.name, n.defaultValue);
  }), e;
}
function Bn(r, e, t) {
  var n = 0;
  return r.forEach(function(i, s) {
    e.call(this, i, s, r) && (r[n++] = i);
  }, t), r.length = n, r;
}
var Hn = {
  kind: "Field",
  name: {
    kind: "Name",
    value: "__typename"
  }
};
function ss(r, e) {
  return !r || r.selectionSet.selections.every(function(t) {
    return t.kind === "FragmentSpread" && ss(e[t.name.value], e);
  });
}
function ln(r) {
  return ss(gt(r) || ha(r), nn(an(r))) ? null : r;
}
function Wn(r) {
  return function(t) {
    return r.some(function(n) {
      return n.name && n.name === t.name.value || n.test && n.test(t);
    });
  };
}
function os(r, e) {
  var t = /* @__PURE__ */ Object.create(null), n = [], i = /* @__PURE__ */ Object.create(null), s = [], o = ln(ie(e, {
    Variable: {
      enter: function(a, c, u) {
        u.kind !== "VariableDefinition" && (t[a.name.value] = !0);
      }
    },
    Field: {
      enter: function(a) {
        if (r && a.directives) {
          var c = r.some(function(u) {
            return u.remove;
          });
          if (c && a.directives && a.directives.some(Wn(r)))
            return a.arguments && a.arguments.forEach(function(u) {
              u.value.kind === "Variable" && n.push({
                name: u.value.name.value
              });
            }), a.selectionSet && as(a.selectionSet).forEach(function(u) {
              s.push({
                name: u.name.value
              });
            }), null;
        }
      }
    },
    FragmentSpread: {
      enter: function(a) {
        i[a.name.value] = !0;
      }
    },
    Directive: {
      enter: function(a) {
        if (Wn(r)(a))
          return null;
      }
    }
  }));
  return o && Bn(n, function(a) {
    return !!a.name && !t[a.name];
  }).length && (o = ya(n, o)), o && Bn(s, function(a) {
    return !!a.name && !i[a.name];
  }).length && (o = ma(s, o)), o;
}
var fn = Object.assign(function(r) {
  return ie(r, {
    SelectionSet: {
      enter: function(e, t, n) {
        if (!(n && n.kind === "OperationDefinition")) {
          var i = e.selections;
          if (!!i) {
            var s = i.some(function(a) {
              return oe(a) && (a.name.value === "__typename" || a.name.value.lastIndexOf("__", 0) === 0);
            });
            if (!s) {
              var o = n;
              if (!(oe(o) && o.directives && o.directives.some(function(a) {
                return a.name.value === "export";
              })))
                return y(y({}, e), { selections: Rt(Rt([], i, !0), [Hn], !1) });
            }
          }
        }
      }
    }
  });
}, {
  added: function(r) {
    return r === Hn;
  }
}), pa = {
  test: function(r) {
    var e = r.name.value === "connection";
    return e && (!r.arguments || !r.arguments.some(function(t) {
      return t.name.value === "key";
    })) && __DEV__ && _.warn("Removing an @connection directive even though it does not have a key. You may want to use the key parameter to specify a store key."), e;
  }
};
function da(r) {
  return os([pa], Gt(r));
}
function va(r) {
  return function(t) {
    return r.some(function(n) {
      return t.value && t.value.kind === "Variable" && t.value.name && (n.name === t.value.name.value || n.test && n.test(t));
    });
  };
}
function ya(r, e) {
  var t = va(r);
  return ln(ie(e, {
    OperationDefinition: {
      enter: function(n) {
        return y(y({}, n), { variableDefinitions: n.variableDefinitions ? n.variableDefinitions.filter(function(i) {
          return !r.some(function(s) {
            return s.name === i.variable.name.value;
          });
        }) : [] });
      }
    },
    Field: {
      enter: function(n) {
        var i = r.some(function(o) {
          return o.remove;
        });
        if (i) {
          var s = 0;
          if (n.arguments && n.arguments.forEach(function(o) {
            t(o) && (s += 1);
          }), s === 1)
            return null;
        }
      }
    },
    Argument: {
      enter: function(n) {
        if (t(n))
          return null;
      }
    }
  }));
}
function ma(r, e) {
  function t(n) {
    if (r.some(function(i) {
      return i.name === n.name.value;
    }))
      return null;
  }
  return ln(ie(e, {
    FragmentSpread: { enter: t },
    FragmentDefinition: { enter: t }
  }));
}
function as(r) {
  var e = [];
  return r.selections.forEach(function(t) {
    (oe(t) || ns(t)) && t.selectionSet ? as(t.selectionSet).forEach(function(n) {
      return e.push(n);
    }) : t.kind === "FragmentSpread" && e.push(t);
  }), e;
}
function ga(r) {
  var e = un(r), t = e.operation;
  if (t === "query")
    return r;
  var n = ie(r, {
    OperationDefinition: {
      enter: function(i) {
        return y(y({}, i), { operation: "query" });
      }
    }
  });
  return n;
}
function ba(r) {
  Gt(r);
  var e = os([
    {
      test: function(t) {
        return t.name.value === "client";
      },
      remove: !0
    }
  ], r);
  return e && (e = ie(e, {
    FragmentDefinition: {
      enter: function(t) {
        if (t.selectionSet) {
          var n = t.selectionSet.selections.every(function(i) {
            return oe(i) && i.name.value === "__typename";
          });
          if (n)
            return null;
        }
      }
    }
  })), e;
}
var Ea = Object.prototype.hasOwnProperty;
function Gn() {
  for (var r = [], e = 0; e < arguments.length; e++)
    r[e] = arguments[e];
  return hn(r);
}
function hn(r) {
  var e = r[0] || {}, t = r.length;
  if (t > 1)
    for (var n = new Se(), i = 1; i < t; ++i)
      e = n.merge(e, r[i]);
  return e;
}
var _a = function(r, e, t) {
  return this.merge(r[t], e[t]);
}, Se = function() {
  function r(e) {
    e === void 0 && (e = _a), this.reconciler = e, this.isObject = P, this.pastCopies = /* @__PURE__ */ new Set();
  }
  return r.prototype.merge = function(e, t) {
    for (var n = this, i = [], s = 2; s < arguments.length; s++)
      i[s - 2] = arguments[s];
    return P(t) && P(e) ? (Object.keys(t).forEach(function(o) {
      if (Ea.call(e, o)) {
        var a = e[o];
        if (t[o] !== a) {
          var c = n.reconciler.apply(n, Rt([e, t, o], i, !1));
          c !== a && (e = n.shallowCopyForMerge(e), e[o] = c);
        }
      } else
        e = n.shallowCopyForMerge(e), e[o] = t[o];
    }), e) : t;
  }, r.prototype.shallowCopyForMerge = function(e) {
    return P(e) && (this.pastCopies.has(e) || (Array.isArray(e) ? e = e.slice(0) : e = y({ __proto__: Object.getPrototypeOf(e) }, e), this.pastCopies.add(e))), e;
  }, r;
}();
function wa(r, e) {
  var t = typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
  if (t)
    return (t = t.call(r)).next.bind(t);
  if (Array.isArray(r) || (t = Sa(r)) || e && r && typeof r.length == "number") {
    t && (r = t);
    var n = 0;
    return function() {
      return n >= r.length ? { done: !0 } : { done: !1, value: r[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Sa(r, e) {
  if (!!r) {
    if (typeof r == "string")
      return Yn(r, e);
    var t = Object.prototype.toString.call(r).slice(8, -1);
    if (t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set")
      return Array.from(r);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return Yn(r, e);
  }
}
function Yn(r, e) {
  (e == null || e > r.length) && (e = r.length);
  for (var t = 0, n = new Array(e); t < e; t++)
    n[t] = r[t];
  return n;
}
function Jn(r, e) {
  for (var t = 0; t < e.length; t++) {
    var n = e[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(r, n.key, n);
  }
}
function pn(r, e, t) {
  return e && Jn(r.prototype, e), t && Jn(r, t), Object.defineProperty(r, "prototype", { writable: !1 }), r;
}
var dn = function() {
  return typeof Symbol == "function";
}, vn = function(r) {
  return dn() && Boolean(Symbol[r]);
}, yn = function(r) {
  return vn(r) ? Symbol[r] : "@@" + r;
};
dn() && !vn("observable") && (Symbol.observable = Symbol("observable"));
var Oa = yn("iterator"), Ar = yn("observable"), us = yn("species");
function Pt(r, e) {
  var t = r[e];
  if (t != null) {
    if (typeof t != "function")
      throw new TypeError(t + " is not a function");
    return t;
  }
}
function Je(r) {
  var e = r.constructor;
  return e !== void 0 && (e = e[us], e === null && (e = void 0)), e !== void 0 ? e : R;
}
function Da(r) {
  return r instanceof R;
}
function $e(r) {
  $e.log ? $e.log(r) : setTimeout(function() {
    throw r;
  });
}
function kt(r) {
  Promise.resolve().then(function() {
    try {
      r();
    } catch (e) {
      $e(e);
    }
  });
}
function cs(r) {
  var e = r._cleanup;
  if (e !== void 0 && (r._cleanup = void 0, !!e))
    try {
      if (typeof e == "function")
        e();
      else {
        var t = Pt(e, "unsubscribe");
        t && t.call(e);
      }
    } catch (n) {
      $e(n);
    }
}
function Nr(r) {
  r._observer = void 0, r._queue = void 0, r._state = "closed";
}
function Ta(r) {
  var e = r._queue;
  if (!!e) {
    r._queue = void 0, r._state = "ready";
    for (var t = 0; t < e.length && (ls(r, e[t].type, e[t].value), r._state !== "closed"); ++t)
      ;
  }
}
function ls(r, e, t) {
  r._state = "running";
  var n = r._observer;
  try {
    var i = Pt(n, e);
    switch (e) {
      case "next":
        i && i.call(n, t);
        break;
      case "error":
        if (Nr(r), i)
          i.call(n, t);
        else
          throw t;
        break;
      case "complete":
        Nr(r), i && i.call(n);
        break;
    }
  } catch (s) {
    $e(s);
  }
  r._state === "closed" ? cs(r) : r._state === "running" && (r._state = "ready");
}
function nr(r, e, t) {
  if (r._state !== "closed") {
    if (r._state === "buffering") {
      r._queue.push({
        type: e,
        value: t
      });
      return;
    }
    if (r._state !== "ready") {
      r._state = "buffering", r._queue = [{
        type: e,
        value: t
      }], kt(function() {
        return Ta(r);
      });
      return;
    }
    ls(r, e, t);
  }
}
var Ia = /* @__PURE__ */ function() {
  function r(t, n) {
    this._cleanup = void 0, this._observer = t, this._queue = void 0, this._state = "initializing";
    var i = new xa(this);
    try {
      this._cleanup = n.call(void 0, i);
    } catch (s) {
      i.error(s);
    }
    this._state === "initializing" && (this._state = "ready");
  }
  var e = r.prototype;
  return e.unsubscribe = function() {
    this._state !== "closed" && (Nr(this), cs(this));
  }, pn(r, [{
    key: "closed",
    get: function() {
      return this._state === "closed";
    }
  }]), r;
}(), xa = /* @__PURE__ */ function() {
  function r(t) {
    this._subscription = t;
  }
  var e = r.prototype;
  return e.next = function(n) {
    nr(this._subscription, "next", n);
  }, e.error = function(n) {
    nr(this._subscription, "error", n);
  }, e.complete = function() {
    nr(this._subscription, "complete");
  }, pn(r, [{
    key: "closed",
    get: function() {
      return this._subscription._state === "closed";
    }
  }]), r;
}(), R = /* @__PURE__ */ function() {
  function r(t) {
    if (!(this instanceof r))
      throw new TypeError("Observable cannot be called as a function");
    if (typeof t != "function")
      throw new TypeError("Observable initializer must be a function");
    this._subscriber = t;
  }
  var e = r.prototype;
  return e.subscribe = function(n) {
    return (typeof n != "object" || n === null) && (n = {
      next: n,
      error: arguments[1],
      complete: arguments[2]
    }), new Ia(n, this._subscriber);
  }, e.forEach = function(n) {
    var i = this;
    return new Promise(function(s, o) {
      if (typeof n != "function") {
        o(new TypeError(n + " is not a function"));
        return;
      }
      function a() {
        c.unsubscribe(), s();
      }
      var c = i.subscribe({
        next: function(u) {
          try {
            n(u, a);
          } catch (l) {
            o(l), c.unsubscribe();
          }
        },
        error: o,
        complete: s
      });
    });
  }, e.map = function(n) {
    var i = this;
    if (typeof n != "function")
      throw new TypeError(n + " is not a function");
    var s = Je(this);
    return new s(function(o) {
      return i.subscribe({
        next: function(a) {
          try {
            a = n(a);
          } catch (c) {
            return o.error(c);
          }
          o.next(a);
        },
        error: function(a) {
          o.error(a);
        },
        complete: function() {
          o.complete();
        }
      });
    });
  }, e.filter = function(n) {
    var i = this;
    if (typeof n != "function")
      throw new TypeError(n + " is not a function");
    var s = Je(this);
    return new s(function(o) {
      return i.subscribe({
        next: function(a) {
          try {
            if (!n(a))
              return;
          } catch (c) {
            return o.error(c);
          }
          o.next(a);
        },
        error: function(a) {
          o.error(a);
        },
        complete: function() {
          o.complete();
        }
      });
    });
  }, e.reduce = function(n) {
    var i = this;
    if (typeof n != "function")
      throw new TypeError(n + " is not a function");
    var s = Je(this), o = arguments.length > 1, a = !1, c = arguments[1], u = c;
    return new s(function(l) {
      return i.subscribe({
        next: function(f) {
          var h = !a;
          if (a = !0, !h || o)
            try {
              u = n(u, f);
            } catch (p) {
              return l.error(p);
            }
          else
            u = f;
        },
        error: function(f) {
          l.error(f);
        },
        complete: function() {
          if (!a && !o)
            return l.error(new TypeError("Cannot reduce an empty sequence"));
          l.next(u), l.complete();
        }
      });
    });
  }, e.concat = function() {
    for (var n = this, i = arguments.length, s = new Array(i), o = 0; o < i; o++)
      s[o] = arguments[o];
    var a = Je(this);
    return new a(function(c) {
      var u, l = 0;
      function f(h) {
        u = h.subscribe({
          next: function(p) {
            c.next(p);
          },
          error: function(p) {
            c.error(p);
          },
          complete: function() {
            l === s.length ? (u = void 0, c.complete()) : f(a.from(s[l++]));
          }
        });
      }
      return f(n), function() {
        u && (u.unsubscribe(), u = void 0);
      };
    });
  }, e.flatMap = function(n) {
    var i = this;
    if (typeof n != "function")
      throw new TypeError(n + " is not a function");
    var s = Je(this);
    return new s(function(o) {
      var a = [], c = i.subscribe({
        next: function(l) {
          if (n)
            try {
              l = n(l);
            } catch (h) {
              return o.error(h);
            }
          var f = s.from(l).subscribe({
            next: function(h) {
              o.next(h);
            },
            error: function(h) {
              o.error(h);
            },
            complete: function() {
              var h = a.indexOf(f);
              h >= 0 && a.splice(h, 1), u();
            }
          });
          a.push(f);
        },
        error: function(l) {
          o.error(l);
        },
        complete: function() {
          u();
        }
      });
      function u() {
        c.closed && a.length === 0 && o.complete();
      }
      return function() {
        a.forEach(function(l) {
          return l.unsubscribe();
        }), c.unsubscribe();
      };
    });
  }, e[Ar] = function() {
    return this;
  }, r.from = function(n) {
    var i = typeof this == "function" ? this : r;
    if (n == null)
      throw new TypeError(n + " is not an object");
    var s = Pt(n, Ar);
    if (s) {
      var o = s.call(n);
      if (Object(o) !== o)
        throw new TypeError(o + " is not an object");
      return Da(o) && o.constructor === i ? o : new i(function(a) {
        return o.subscribe(a);
      });
    }
    if (vn("iterator") && (s = Pt(n, Oa), s))
      return new i(function(a) {
        kt(function() {
          if (!a.closed) {
            for (var c = wa(s.call(n)), u; !(u = c()).done; ) {
              var l = u.value;
              if (a.next(l), a.closed)
                return;
            }
            a.complete();
          }
        });
      });
    if (Array.isArray(n))
      return new i(function(a) {
        kt(function() {
          if (!a.closed) {
            for (var c = 0; c < n.length; ++c)
              if (a.next(n[c]), a.closed)
                return;
            a.complete();
          }
        });
      });
    throw new TypeError(n + " is not observable");
  }, r.of = function() {
    for (var n = arguments.length, i = new Array(n), s = 0; s < n; s++)
      i[s] = arguments[s];
    var o = typeof this == "function" ? this : r;
    return new o(function(a) {
      kt(function() {
        if (!a.closed) {
          for (var c = 0; c < i.length; ++c)
            if (a.next(i[c]), a.closed)
              return;
          a.complete();
        }
      });
    });
  }, pn(r, null, [{
    key: us,
    get: function() {
      return this;
    }
  }]), r;
}();
dn() && Object.defineProperty(R, Symbol("extensions"), {
  value: {
    symbol: Ar,
    hostReportError: $e
  },
  configurable: !0
});
function ka(r) {
  var e, t = r.Symbol;
  if (typeof t == "function")
    if (t.observable)
      e = t.observable;
    else {
      typeof t.for == "function" ? e = t.for("https://github.com/benlesh/symbol-observable") : e = t("https://github.com/benlesh/symbol-observable");
      try {
        t.observable = e;
      } catch {
      }
    }
  else
    e = "@@observable";
  return e;
}
var ke;
typeof self < "u" ? ke = self : typeof window < "u" ? ke = window : typeof global < "u" ? ke = global : typeof module < "u" ? ke = module : ke = Function("return this")();
ka(ke);
var Zn = R.prototype, Xn = "@@observable";
Zn[Xn] || (Zn[Xn] = function() {
  return this;
});
var Aa = Object.prototype.toString;
function mn(r) {
  return Cr(r);
}
function Cr(r, e) {
  switch (Aa.call(r)) {
    case "[object Array]": {
      if (e = e || /* @__PURE__ */ new Map(), e.has(r))
        return e.get(r);
      var t = r.slice(0);
      return e.set(r, t), t.forEach(function(i, s) {
        t[s] = Cr(i, e);
      }), t;
    }
    case "[object Object]": {
      if (e = e || /* @__PURE__ */ new Map(), e.has(r))
        return e.get(r);
      var n = Object.create(Object.getPrototypeOf(r));
      return e.set(r, n), Object.keys(r).forEach(function(i) {
        n[i] = Cr(r[i], e);
      }), n;
    }
    default:
      return r;
  }
}
function Na(r) {
  var e = /* @__PURE__ */ new Set([r]);
  return e.forEach(function(t) {
    P(t) && Ca(t) === t && Object.getOwnPropertyNames(t).forEach(function(n) {
      P(t[n]) && e.add(t[n]);
    });
  }), r;
}
function Ca(r) {
  if (__DEV__ && !Object.isFrozen(r))
    try {
      Object.freeze(r);
    } catch (e) {
      if (e instanceof TypeError)
        return null;
      throw e;
    }
  return r;
}
function Mr(r) {
  return __DEV__ && Na(r), r;
}
function it(r, e, t) {
  var n = [];
  r.forEach(function(i) {
    return i[e] && n.push(i);
  }), n.forEach(function(i) {
    return i[e](t);
  });
}
function ir(r, e, t) {
  return new R(function(n) {
    var i = n.next, s = n.error, o = n.complete, a = 0, c = !1, u = {
      then: function(p) {
        return new Promise(function(d) {
          return d(p());
        });
      }
    };
    function l(p, d) {
      return p ? function(v) {
        ++a;
        var g = function() {
          return p(v);
        };
        u = u.then(g, g).then(function(E) {
          --a, i && i.call(n, E), c && f.complete();
        }, function(E) {
          throw --a, E;
        }).catch(function(E) {
          s && s.call(n, E);
        });
      } : function(v) {
        return d && d.call(n, v);
      };
    }
    var f = {
      next: l(e, i),
      error: l(t, s),
      complete: function() {
        c = !0, a || o && o.call(n);
      }
    }, h = r.subscribe(f);
    return function() {
      return h.unsubscribe();
    };
  });
}
var Oe = typeof WeakMap == "function" && Y(function() {
  return navigator.product;
}) !== "ReactNative", Ma = typeof WeakSet == "function", fs = typeof Symbol == "function" && typeof Symbol.for == "function", Yt = fs && Symbol.asyncIterator;
Y(function() {
  return window.document.createElement;
});
Y(function() {
  return navigator.userAgent.indexOf("jsdom") >= 0;
});
function hs(r) {
  function e(t) {
    Object.defineProperty(r, t, { value: R });
  }
  return fs && Symbol.species && e(Symbol.species), e("@@species"), r;
}
function Kn(r) {
  return r && typeof r.then == "function";
}
var rt = function(r) {
  K(e, r);
  function e(t) {
    var n = r.call(this, function(i) {
      return n.addObserver(i), function() {
        return n.removeObserver(i);
      };
    }) || this;
    return n.observers = /* @__PURE__ */ new Set(), n.promise = new Promise(function(i, s) {
      n.resolve = i, n.reject = s;
    }), n.handlers = {
      next: function(i) {
        n.sub !== null && (n.latest = ["next", i], n.notify("next", i), it(n.observers, "next", i));
      },
      error: function(i) {
        var s = n.sub;
        s !== null && (s && setTimeout(function() {
          return s.unsubscribe();
        }), n.sub = null, n.latest = ["error", i], n.reject(i), n.notify("error", i), it(n.observers, "error", i));
      },
      complete: function() {
        var i = n.sub;
        if (i !== null) {
          var s = n.sources.shift();
          s ? Kn(s) ? s.then(function(o) {
            return n.sub = o.subscribe(n.handlers);
          }) : n.sub = s.subscribe(n.handlers) : (i && setTimeout(function() {
            return i.unsubscribe();
          }), n.sub = null, n.latest && n.latest[0] === "next" ? n.resolve(n.latest[1]) : n.resolve(), n.notify("complete"), it(n.observers, "complete"));
        }
      }
    }, n.nextResultListeners = /* @__PURE__ */ new Set(), n.cancel = function(i) {
      n.reject(i), n.sources = [], n.handlers.complete();
    }, n.promise.catch(function(i) {
    }), typeof t == "function" && (t = [new R(t)]), Kn(t) ? t.then(function(i) {
      return n.start(i);
    }, n.handlers.error) : n.start(t), n;
  }
  return e.prototype.start = function(t) {
    this.sub === void 0 && (this.sources = Array.from(t), this.handlers.complete());
  }, e.prototype.deliverLastMessage = function(t) {
    if (this.latest) {
      var n = this.latest[0], i = t[n];
      i && i.call(t, this.latest[1]), this.sub === null && n === "next" && t.complete && t.complete();
    }
  }, e.prototype.addObserver = function(t) {
    this.observers.has(t) || (this.deliverLastMessage(t), this.observers.add(t));
  }, e.prototype.removeObserver = function(t) {
    this.observers.delete(t) && this.observers.size < 1 && this.handlers.complete();
  }, e.prototype.notify = function(t, n) {
    var i = this.nextResultListeners;
    i.size && (this.nextResultListeners = /* @__PURE__ */ new Set(), i.forEach(function(s) {
      return s(t, n);
    }));
  }, e.prototype.beforeNext = function(t) {
    var n = !1;
    this.nextResultListeners.add(function(i, s) {
      n || (n = !0, t(i, s));
    });
  }, e;
}(R);
hs(rt);
function ne(r) {
  return Array.isArray(r) && r.length > 0;
}
function At(r) {
  return r.errors && r.errors.length > 0 || !1;
}
function Jt() {
  for (var r = [], e = 0; e < arguments.length; e++)
    r[e] = arguments[e];
  var t = /* @__PURE__ */ Object.create(null);
  return r.forEach(function(n) {
    !n || Object.keys(n).forEach(function(i) {
      var s = n[i];
      s !== void 0 && (t[i] = s);
    });
  }), t;
}
var ei = /* @__PURE__ */ new Map();
function Rr(r) {
  var e = ei.get(r) || 1;
  return ei.set(r, e + 1), "".concat(r, ":").concat(e, ":").concat(Math.random().toString(36).slice(2));
}
function Ra(r) {
  var e = Rr("stringifyForDisplay");
  return JSON.stringify(r, function(t, n) {
    return n === void 0 ? e : n;
  }).split(JSON.stringify(e)).join("<undefined>");
}
function sr(r, e) {
  return Jt(r, e, e.variables && {
    variables: y(y({}, r && r.variables), e.variables)
  });
}
function ti(r) {
  return new R(function(e) {
    e.error(r);
  });
}
var Pr = function(r, e, t) {
  var n = new Error(t);
  throw n.name = "ServerError", n.response = r, n.statusCode = r.status, n.result = e, n;
};
function Pa(r) {
  for (var e = [
    "query",
    "operationName",
    "variables",
    "extensions",
    "context"
  ], t = 0, n = Object.keys(r); t < n.length; t++) {
    var i = n[t];
    if (e.indexOf(i) < 0)
      throw __DEV__ ? new N("illegal argument: ".concat(i)) : new N(26);
  }
  return r;
}
function Fa(r, e) {
  var t = y({}, r), n = function(s) {
    typeof s == "function" ? t = y(y({}, t), s(t)) : t = y(y({}, t), s);
  }, i = function() {
    return y({}, t);
  };
  return Object.defineProperty(e, "setContext", {
    enumerable: !1,
    value: n
  }), Object.defineProperty(e, "getContext", {
    enumerable: !1,
    value: i
  }), e;
}
function La(r) {
  var e = {
    variables: r.variables || {},
    extensions: r.extensions || {},
    operationName: r.operationName,
    query: r.query
  };
  return e.operationName || (e.operationName = typeof e.query != "string" ? kr(e.query) || void 0 : ""), e;
}
function ri(r, e) {
  return e ? e(r) : R.of();
}
function Ze(r) {
  return typeof r == "function" ? new De(r) : r;
}
function Ot(r) {
  return r.request.length <= 1;
}
var ja = function(r) {
  K(e, r);
  function e(t, n) {
    var i = r.call(this, t) || this;
    return i.link = n, i;
  }
  return e;
}(Error), De = function() {
  function r(e) {
    e && (this.request = e);
  }
  return r.empty = function() {
    return new r(function() {
      return R.of();
    });
  }, r.from = function(e) {
    return e.length === 0 ? r.empty() : e.map(Ze).reduce(function(t, n) {
      return t.concat(n);
    });
  }, r.split = function(e, t, n) {
    var i = Ze(t), s = Ze(n || new r(ri));
    return Ot(i) && Ot(s) ? new r(function(o) {
      return e(o) ? i.request(o) || R.of() : s.request(o) || R.of();
    }) : new r(function(o, a) {
      return e(o) ? i.request(o, a) || R.of() : s.request(o, a) || R.of();
    });
  }, r.execute = function(e, t) {
    return e.request(Fa(t.context, La(Pa(t)))) || R.of();
  }, r.concat = function(e, t) {
    var n = Ze(e);
    if (Ot(n))
      return __DEV__ && _.warn(new ja("You are calling concat on a terminating link, which will have no effect", n)), n;
    var i = Ze(t);
    return Ot(i) ? new r(function(s) {
      return n.request(s, function(o) {
        return i.request(o) || R.of();
      }) || R.of();
    }) : new r(function(s, o) {
      return n.request(s, function(a) {
        return i.request(a, o) || R.of();
      }) || R.of();
    });
  }, r.prototype.split = function(e, t, n) {
    return this.concat(r.split(e, t, n || new r(ri)));
  }, r.prototype.concat = function(e) {
    return r.concat(this, e);
  }, r.prototype.request = function(e, t) {
    throw __DEV__ ? new N("request is not implemented") : new N(21);
  }, r.prototype.onError = function(e, t) {
    if (t && t.error)
      return t.error(e), !1;
    throw e;
  }, r.prototype.setOnError = function(e) {
    return this.onError = e, this;
  }, r;
}(), Va = De.concat, Fr = De.execute, Qa = "3.7.1";
function $a(r) {
  return !!r.body;
}
function qa(r) {
  return !!r.getReader;
}
function Ua(r) {
  return !!(Yt && r[Symbol.asyncIterator]);
}
function za(r) {
  return !!r.stream;
}
function Ba(r) {
  return !!r.arrayBuffer;
}
function Ha(r) {
  return !!r.pipe;
}
function Wa(r) {
  var e, t = r[Symbol.asyncIterator]();
  return e = {
    next: function() {
      return t.next();
    }
  }, e[Symbol.asyncIterator] = function() {
    return this;
  }, e;
}
function Ga(r) {
  var e = null, t = null, n = !1, i = [], s = [];
  function o(f) {
    if (!t) {
      if (s.length) {
        var h = s.shift();
        if (Array.isArray(h) && h[0])
          return h[0]({ value: f, done: !1 });
      }
      i.push(f);
    }
  }
  function a(f) {
    t = f;
    var h = s.slice();
    h.forEach(function(p) {
      p[1](f);
    }), !e || e();
  }
  function c() {
    n = !0;
    var f = s.slice();
    f.forEach(function(h) {
      h[0]({ value: void 0, done: !0 });
    }), !e || e();
  }
  e = function() {
    e = null, r.removeListener("data", o), r.removeListener("error", a), r.removeListener("end", c), r.removeListener("finish", c), r.removeListener("close", c);
  }, r.on("data", o), r.on("error", a), r.on("end", c), r.on("finish", c), r.on("close", c);
  function u() {
    return new Promise(function(f, h) {
      if (t)
        return h(t);
      if (i.length)
        return f({ value: i.shift(), done: !1 });
      if (n)
        return f({ value: void 0, done: !0 });
      s.push([f, h]);
    });
  }
  var l = {
    next: function() {
      return u();
    }
  };
  return Yt && (l[Symbol.asyncIterator] = function() {
    return this;
  }), l;
}
function Ya(r) {
  var e = !1, t = {
    next: function() {
      return e ? Promise.resolve({
        value: void 0,
        done: !0
      }) : (e = !0, new Promise(function(n, i) {
        r.then(function(s) {
          n({ value: s, done: !1 });
        }).catch(i);
      }));
    }
  };
  return Yt && (t[Symbol.asyncIterator] = function() {
    return this;
  }), t;
}
function ni(r) {
  var e = {
    next: function() {
      return r.read();
    }
  };
  return Yt && (e[Symbol.asyncIterator] = function() {
    return this;
  }), e;
}
function Ja(r) {
  var e = r;
  if ($a(r) && (e = r.body), Ua(e))
    return Wa(e);
  if (qa(e))
    return ni(e.getReader());
  if (za(e))
    return ni(e.stream().getReader());
  if (Ba(e))
    return Ya(e.arrayBuffer());
  if (Ha(e))
    return Ga(e);
  throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}
var ii = Object.prototype.hasOwnProperty;
function Za(r, e) {
  var t, n, i;
  return ce(this, void 0, void 0, function() {
    var s, o, a, c, u, l, f, h, p, d, v, g, E, T, b, S, x, k, D, I;
    return le(this, function(F) {
      switch (F.label) {
        case 0:
          if (TextDecoder === void 0)
            throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
          s = new TextDecoder("utf-8"), o = (t = r.headers) === null || t === void 0 ? void 0 : t.get("content-type"), a = "boundary=", c = o != null && o.includes(a) ? o == null ? void 0 : o.substring((o == null ? void 0 : o.indexOf(a)) + a.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-", u = "--".concat(c), l = "", f = Ja(r), h = !0, F.label = 1;
        case 1:
          return h ? [4, f.next()] : [3, 3];
        case 2:
          for (p = F.sent(), d = p.value, v = p.done, g = typeof d == "string" ? d : s.decode(d), h = !v, l += g, E = l.indexOf(u); E > -1; ) {
            if (T = void 0, I = [
              l.slice(0, E),
              l.slice(E + u.length)
            ], T = I[0], l = I[1], T.trim()) {
              if (b = T.indexOf(`\r
\r
`), S = Xa(T.slice(0, b)), x = S["content-type"], x && x.toLowerCase().indexOf("application/json") === -1)
                throw new Error("Unsupported patch content type: application/json is required.");
              k = T.slice(b);
              try {
                D = ps(r, k.replace(`\r
`, "")), (Object.keys(D).length > 1 || "data" in D || "incremental" in D || "errors" in D) && ((n = e.next) === null || n === void 0 || n.call(e, D));
              } catch (j) {
                gn(j, e);
              }
            }
            E = l.indexOf(u);
          }
          return [3, 1];
        case 3:
          return (i = e.complete) === null || i === void 0 || i.call(e), [2];
      }
    });
  });
}
function Xa(r) {
  var e = {};
  return r.split(`
`).forEach(function(t) {
    var n = t.indexOf(":");
    if (n > -1) {
      var i = t.slice(0, n).trim().toLowerCase(), s = t.slice(n + 1).trim();
      e[i] = s;
    }
  }), e;
}
function ps(r, e) {
  if (r.status >= 300) {
    var t = function() {
      try {
        return JSON.parse(e);
      } catch {
        return e;
      }
    };
    Pr(r, t(), "Response not successful: Received status code ".concat(r.status));
  }
  try {
    return JSON.parse(e);
  } catch (i) {
    var n = i;
    throw n.name = "ServerParseError", n.response = r, n.statusCode = r.status, n.bodyText = e, n;
  }
}
function gn(r, e) {
  var t, n;
  r.name !== "AbortError" && (r.result && r.result.errors && r.result.data && ((t = e.next) === null || t === void 0 || t.call(e, r.result)), (n = e.error) === null || n === void 0 || n.call(e, r));
}
function Ka(r, e, t) {
  eu(e)(r).then(function(n) {
    var i, s;
    (i = t.next) === null || i === void 0 || i.call(t, n), (s = t.complete) === null || s === void 0 || s.call(t);
  }).catch(function(n) {
    return gn(n, t);
  });
}
function eu(r) {
  return function(e) {
    return e.text().then(function(t) {
      return ps(e, t);
    }).then(function(t) {
      return e.status >= 300 && Pr(e, t, "Response not successful: Received status code ".concat(e.status)), !Array.isArray(t) && !ii.call(t, "data") && !ii.call(t, "errors") && Pr(e, t, "Server response was missing for query '".concat(Array.isArray(r) ? r.map(function(n) {
        return n.operationName;
      }) : r.operationName, "'.")), t;
    });
  };
}
var Lr = function(r, e) {
  var t;
  try {
    t = JSON.stringify(r);
  } catch (i) {
    var n = __DEV__ ? new N("Network request failed. ".concat(e, " is not serializable: ").concat(i.message)) : new N(23);
    throw n.parseError = i, n;
  }
  return t;
}, tu = {
  includeQuery: !0,
  includeExtensions: !1,
  preserveHeaderCase: !1
}, ru = {
  accept: "*/*",
  "content-type": "application/json"
}, nu = {
  method: "POST"
}, iu = {
  http: tu,
  headers: ru,
  options: nu
}, su = function(r, e) {
  return e(r);
};
function ou(r, e) {
  for (var t = [], n = 2; n < arguments.length; n++)
    t[n - 2] = arguments[n];
  var i = {}, s = {};
  t.forEach(function(f) {
    i = y(y(y({}, i), f.options), { headers: y(y({}, i.headers), f.headers) }), f.credentials && (i.credentials = f.credentials), s = y(y({}, s), f.http);
  }), i.headers = au(i.headers, s.preserveHeaderCase);
  var o = r.operationName, a = r.extensions, c = r.variables, u = r.query, l = { operationName: o, variables: c };
  return s.includeExtensions && (l.extensions = a), s.includeQuery && (l.query = e(u, zo)), {
    options: i,
    body: l
  };
}
function au(r, e) {
  if (!e) {
    var t = /* @__PURE__ */ Object.create(null);
    return Object.keys(Object(r)).forEach(function(s) {
      t[s.toLowerCase()] = r[s];
    }), t;
  }
  var n = /* @__PURE__ */ Object.create(null);
  Object.keys(Object(r)).forEach(function(s) {
    n[s.toLowerCase()] = { originalName: s, value: r[s] };
  });
  var i = /* @__PURE__ */ Object.create(null);
  return Object.keys(n).forEach(function(s) {
    i[n[s].originalName] = n[s].value;
  }), i;
}
var uu = function(r) {
  if (!r && typeof fetch > "u")
    throw __DEV__ ? new N(`
"fetch" has not been found globally and no fetcher has been configured. To fix this, install a fetch package (like https://www.npmjs.com/package/cross-fetch), instantiate the fetcher, and pass it into your HttpLink constructor. For example:

import fetch from 'cross-fetch';
import { ApolloClient, HttpLink } from '@apollo/client';
const client = new ApolloClient({
  link: new HttpLink({ uri: '/graphql', fetch })
});
    `) : new N(22);
}, cu = function() {
  if (typeof AbortController > "u")
    return { controller: !1, signal: !1 };
  var r = new AbortController(), e = r.signal;
  return { controller: r, signal: e };
}, lu = function(r, e) {
  var t = r.getContext(), n = t.uri;
  return n || (typeof e == "function" ? e(r) : e || "/graphql");
};
function fu(r, e) {
  var t = [], n = function(f, h) {
    t.push("".concat(f, "=").concat(encodeURIComponent(h)));
  };
  if ("query" in e && n("query", e.query), e.operationName && n("operationName", e.operationName), e.variables) {
    var i = void 0;
    try {
      i = Lr(e.variables, "Variables map");
    } catch (f) {
      return { parseError: f };
    }
    n("variables", i);
  }
  if (e.extensions) {
    var s = void 0;
    try {
      s = Lr(e.extensions, "Extensions map");
    } catch (f) {
      return { parseError: f };
    }
    n("extensions", s);
  }
  var o = "", a = r, c = r.indexOf("#");
  c !== -1 && (o = r.substr(c), a = r.substr(0, c));
  var u = a.indexOf("?") === -1 ? "?" : "&", l = a + u + t.join("&") + o;
  return { newURI: l };
}
var si = Y(function() {
  return fetch;
}), hu = function(r) {
  r === void 0 && (r = {});
  var e = r.uri, t = e === void 0 ? "/graphql" : e, n = r.fetch, i = r.print, s = i === void 0 ? su : i, o = r.includeExtensions, a = r.preserveHeaderCase, c = r.useGETForQueries, u = r.includeUnusedVariables, l = u === void 0 ? !1 : u, f = Ve(r, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]);
  __DEV__ && uu(n || si);
  var h = {
    http: { includeExtensions: o, preserveHeaderCase: a },
    options: f.fetchOptions,
    credentials: f.credentials,
    headers: f.headers
  };
  return new De(function(p) {
    var d = lu(p, t), v = p.getContext(), g = {};
    if (v.clientAwareness) {
      var E = v.clientAwareness, T = E.name, b = E.version;
      T && (g["apollographql-client-name"] = T), b && (g["apollographql-client-version"] = b);
    }
    var S = y(y({}, g), v.headers), x = {
      http: v.http,
      options: v.fetchOptions,
      credentials: v.credentials,
      headers: S
    }, k = ou(p, s, iu, h, x), D = k.options, I = k.body;
    if (I.variables && !l) {
      var F = new Set(Object.keys(I.variables));
      ie(p.query, {
        Variable: function(G, Nn, se) {
          se && se.kind !== "VariableDefinition" && F.delete(G.name.value);
        }
      }), F.size && (I.variables = y({}, I.variables), F.forEach(function(G) {
        delete I.variables[G];
      }));
    }
    var j;
    if (!D.signal) {
      var ye = cu(), Te = ye.controller, W = ye.signal;
      j = Te, j && (D.signal = W);
    }
    var Ie = function(G) {
      return G.kind === "OperationDefinition" && G.operation === "mutation";
    };
    if (c && !p.query.definitions.some(Ie) && (D.method = "GET"), rn(["defer"], p.query) && (D.headers.accept = "multipart/mixed; deferSpec=20220824, application/json"), D.method === "GET") {
      var kn = fu(d, I), Js = kn.newURI, An = kn.parseError;
      if (An)
        return ti(An);
      d = Js;
    } else
      try {
        D.body = Lr(I, "Payload");
      } catch (G) {
        return ti(G);
      }
    return new R(function(G) {
      var Nn = n || Y(function() {
        return fetch;
      }) || si;
      return Nn(d, D).then(function(se) {
        var Kt;
        p.setContext({ response: se });
        var Cn = (Kt = se.headers) === null || Kt === void 0 ? void 0 : Kt.get("content-type");
        return Cn !== null && /^multipart\/mixed/i.test(Cn) ? Za(se, G) : Ka(se, p, G);
      }).catch(function(se) {
        return gn(se, G);
      }), function() {
        j && j.abort();
      };
    });
  });
}, ds = function(r) {
  K(e, r);
  function e(t) {
    t === void 0 && (t = {});
    var n = r.call(this, hu(t).request) || this;
    return n.options = t, n;
  }
  return e;
}(De), vs = Object.prototype, oi = vs.toString, pu = vs.hasOwnProperty, ai = Function.prototype.toString, jr = /* @__PURE__ */ new Map();
function Q(r, e) {
  try {
    return Vr(r, e);
  } finally {
    jr.clear();
  }
}
function Vr(r, e) {
  if (r === e)
    return !0;
  var t = oi.call(r), n = oi.call(e);
  if (t !== n)
    return !1;
  switch (t) {
    case "[object Array]":
      if (r.length !== e.length)
        return !1;
    case "[object Object]": {
      if (ci(r, e))
        return !0;
      var i = ui(r), s = ui(e), o = i.length;
      if (o !== s.length)
        return !1;
      for (var a = 0; a < o; ++a)
        if (!pu.call(e, i[a]))
          return !1;
      for (var a = 0; a < o; ++a) {
        var c = i[a];
        if (!Vr(r[c], e[c]))
          return !1;
      }
      return !0;
    }
    case "[object Error]":
      return r.name === e.name && r.message === e.message;
    case "[object Number]":
      if (r !== r)
        return e !== e;
    case "[object Boolean]":
    case "[object Date]":
      return +r == +e;
    case "[object RegExp]":
    case "[object String]":
      return r == "".concat(e);
    case "[object Map]":
    case "[object Set]": {
      if (r.size !== e.size)
        return !1;
      if (ci(r, e))
        return !0;
      for (var u = r.entries(), l = t === "[object Map]"; ; ) {
        var f = u.next();
        if (f.done)
          break;
        var h = f.value, p = h[0], d = h[1];
        if (!e.has(p) || l && !Vr(d, e.get(p)))
          return !1;
      }
      return !0;
    }
    case "[object Uint16Array]":
    case "[object Uint8Array]":
    case "[object Uint32Array]":
    case "[object Int32Array]":
    case "[object Int8Array]":
    case "[object Int16Array]":
    case "[object ArrayBuffer]":
      r = new Uint8Array(r), e = new Uint8Array(e);
    case "[object DataView]": {
      var v = r.byteLength;
      if (v === e.byteLength)
        for (; v-- && r[v] === e[v]; )
          ;
      return v === -1;
    }
    case "[object AsyncFunction]":
    case "[object GeneratorFunction]":
    case "[object AsyncGeneratorFunction]":
    case "[object Function]": {
      var g = ai.call(r);
      return g !== ai.call(e) ? !1 : !yu(g, vu);
    }
  }
  return !1;
}
function ui(r) {
  return Object.keys(r).filter(du, r);
}
function du(r) {
  return this[r] !== void 0;
}
var vu = "{ [native code] }";
function yu(r, e) {
  var t = r.length - e.length;
  return t >= 0 && r.indexOf(e, t) === t;
}
function ci(r, e) {
  var t = jr.get(r);
  if (t) {
    if (t.has(e))
      return !0;
  } else
    jr.set(r, t = /* @__PURE__ */ new Set());
  return t.add(e), !1;
}
function mu(r) {
  return !!r.incremental;
}
var gu = function() {
  return /* @__PURE__ */ Object.create(null);
}, ys = Array.prototype, bu = ys.forEach, Eu = ys.slice, bt = function() {
  function r(e, t) {
    e === void 0 && (e = !0), t === void 0 && (t = gu), this.weakness = e, this.makeData = t;
  }
  return r.prototype.lookup = function() {
    for (var e = [], t = 0; t < arguments.length; t++)
      e[t] = arguments[t];
    return this.lookupArray(e);
  }, r.prototype.lookupArray = function(e) {
    var t = this;
    return bu.call(e, function(n) {
      return t = t.getChildTrie(n);
    }), t.data || (t.data = this.makeData(Eu.call(e)));
  }, r.prototype.getChildTrie = function(e) {
    var t = this.weakness && _u(e) ? this.weak || (this.weak = /* @__PURE__ */ new WeakMap()) : this.strong || (this.strong = /* @__PURE__ */ new Map()), n = t.get(e);
    return n || t.set(e, n = new r(this.weakness, this.makeData)), n;
  }, r;
}();
function _u(r) {
  switch (typeof r) {
    case "object":
      if (r === null)
        break;
    case "function":
      return !0;
  }
  return !1;
}
var z = null, li = {}, wu = 1, Su = function() {
  return function() {
    function r() {
      this.id = [
        "slot",
        wu++,
        Date.now(),
        Math.random().toString(36).slice(2)
      ].join(":");
    }
    return r.prototype.hasValue = function() {
      for (var e = z; e; e = e.parent)
        if (this.id in e.slots) {
          var t = e.slots[this.id];
          if (t === li)
            break;
          return e !== z && (z.slots[this.id] = t), !0;
        }
      return z && (z.slots[this.id] = li), !1;
    }, r.prototype.getValue = function() {
      if (this.hasValue())
        return z.slots[this.id];
    }, r.prototype.withValue = function(e, t, n, i) {
      var s, o = (s = {
        __proto__: null
      }, s[this.id] = e, s), a = z;
      z = { parent: a, slots: o };
      try {
        return t.apply(i, n);
      } finally {
        z = a;
      }
    }, r.bind = function(e) {
      var t = z;
      return function() {
        var n = z;
        try {
          return z = t, e.apply(this, arguments);
        } finally {
          z = n;
        }
      };
    }, r.noContext = function(e, t, n) {
      if (z) {
        var i = z;
        try {
          return z = null, e.apply(n, t);
        } finally {
          z = i;
        }
      } else
        return e.apply(n, t);
    }, r;
  }();
}, or = "@wry/context:Slot", ar = Array, bn = ar[or] || function() {
  var r = Su();
  try {
    Object.defineProperty(ar, or, {
      value: ar[or] = r,
      enumerable: !1,
      writable: !1,
      configurable: !1
    });
  } finally {
    return r;
  }
}();
bn.bind;
bn.noContext;
function Ou() {
}
var Du = function() {
  function r(e, t) {
    e === void 0 && (e = 1 / 0), t === void 0 && (t = Ou), this.max = e, this.dispose = t, this.map = /* @__PURE__ */ new Map(), this.newest = null, this.oldest = null;
  }
  return r.prototype.has = function(e) {
    return this.map.has(e);
  }, r.prototype.get = function(e) {
    var t = this.getNode(e);
    return t && t.value;
  }, r.prototype.getNode = function(e) {
    var t = this.map.get(e);
    if (t && t !== this.newest) {
      var n = t.older, i = t.newer;
      i && (i.older = n), n && (n.newer = i), t.older = this.newest, t.older.newer = t, t.newer = null, this.newest = t, t === this.oldest && (this.oldest = i);
    }
    return t;
  }, r.prototype.set = function(e, t) {
    var n = this.getNode(e);
    return n ? n.value = t : (n = {
      key: e,
      value: t,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = n), this.newest = n, this.oldest = this.oldest || n, this.map.set(e, n), n.value);
  }, r.prototype.clean = function() {
    for (; this.oldest && this.map.size > this.max; )
      this.delete(this.oldest.key);
  }, r.prototype.delete = function(e) {
    var t = this.map.get(e);
    return t ? (t === this.newest && (this.newest = t.older), t === this.oldest && (this.oldest = t.newer), t.newer && (t.newer.older = t.older), t.older && (t.older.newer = t.newer), this.map.delete(e), this.dispose(t.value, e), !0) : !1;
  }, r;
}(), Zt = new bn(), ur, Tu = Object.prototype.hasOwnProperty, En = (ur = Array.from, ur === void 0 ? function(r) {
  var e = [];
  return r.forEach(function(t) {
    return e.push(t);
  }), e;
} : ur);
function Ft(r) {
  var e = r.unsubscribe;
  typeof e == "function" && (r.unsubscribe = void 0, e());
}
var lt = [], Iu = 100;
function qe(r, e) {
  if (!r)
    throw new Error(e || "assertion failure");
}
function xu(r, e) {
  var t = r.length;
  return t > 0 && t === e.length && r[t - 1] === e[t - 1];
}
function ms(r) {
  switch (r.length) {
    case 0:
      throw new Error("unknown value");
    case 1:
      return r[0];
    case 2:
      throw r[1];
  }
}
function ku(r) {
  return r.slice(0);
}
var Au = function() {
  function r(e) {
    this.fn = e, this.parents = /* @__PURE__ */ new Set(), this.childValues = /* @__PURE__ */ new Map(), this.dirtyChildren = null, this.dirty = !0, this.recomputing = !1, this.value = [], this.deps = null, ++r.count;
  }
  return r.prototype.peek = function() {
    if (this.value.length === 1 && !de(this))
      return fi(this), this.value[0];
  }, r.prototype.recompute = function(e) {
    return qe(!this.recomputing, "already recomputing"), fi(this), de(this) ? Nu(this, e) : ms(this.value);
  }, r.prototype.setDirty = function() {
    this.dirty || (this.dirty = !0, this.value.length = 0, gs(this), Ft(this));
  }, r.prototype.dispose = function() {
    var e = this;
    this.setDirty(), Ss(this), _n(this, function(t, n) {
      t.setDirty(), Os(t, e);
    });
  }, r.prototype.forget = function() {
    this.dispose();
  }, r.prototype.dependOn = function(e) {
    e.add(this), this.deps || (this.deps = lt.pop() || /* @__PURE__ */ new Set()), this.deps.add(e);
  }, r.prototype.forgetDeps = function() {
    var e = this;
    this.deps && (En(this.deps).forEach(function(t) {
      return t.delete(e);
    }), this.deps.clear(), lt.push(this.deps), this.deps = null);
  }, r.count = 0, r;
}();
function fi(r) {
  var e = Zt.getValue();
  if (e)
    return r.parents.add(e), e.childValues.has(r) || e.childValues.set(r, []), de(r) ? Es(e, r) : _s(e, r), e;
}
function Nu(r, e) {
  return Ss(r), Zt.withValue(r, Cu, [r, e]), Ru(r, e) && Mu(r), ms(r.value);
}
function Cu(r, e) {
  r.recomputing = !0, r.value.length = 0;
  try {
    r.value[0] = r.fn.apply(null, e);
  } catch (t) {
    r.value[1] = t;
  }
  r.recomputing = !1;
}
function de(r) {
  return r.dirty || !!(r.dirtyChildren && r.dirtyChildren.size);
}
function Mu(r) {
  r.dirty = !1, !de(r) && bs(r);
}
function gs(r) {
  _n(r, Es);
}
function bs(r) {
  _n(r, _s);
}
function _n(r, e) {
  var t = r.parents.size;
  if (t)
    for (var n = En(r.parents), i = 0; i < t; ++i)
      e(n[i], r);
}
function Es(r, e) {
  qe(r.childValues.has(e)), qe(de(e));
  var t = !de(r);
  if (!r.dirtyChildren)
    r.dirtyChildren = lt.pop() || /* @__PURE__ */ new Set();
  else if (r.dirtyChildren.has(e))
    return;
  r.dirtyChildren.add(e), t && gs(r);
}
function _s(r, e) {
  qe(r.childValues.has(e)), qe(!de(e));
  var t = r.childValues.get(e);
  t.length === 0 ? r.childValues.set(e, ku(e.value)) : xu(t, e.value) || r.setDirty(), ws(r, e), !de(r) && bs(r);
}
function ws(r, e) {
  var t = r.dirtyChildren;
  t && (t.delete(e), t.size === 0 && (lt.length < Iu && lt.push(t), r.dirtyChildren = null));
}
function Ss(r) {
  r.childValues.size > 0 && r.childValues.forEach(function(e, t) {
    Os(r, t);
  }), r.forgetDeps(), qe(r.dirtyChildren === null);
}
function Os(r, e) {
  e.parents.delete(r), r.childValues.delete(e), ws(r, e);
}
function Ru(r, e) {
  if (typeof r.subscribe == "function")
    try {
      Ft(r), r.unsubscribe = r.subscribe.apply(null, e);
    } catch {
      return r.setDirty(), !1;
    }
  return !0;
}
var Pu = {
  setDirty: !0,
  dispose: !0,
  forget: !0
};
function Ds(r) {
  var e = /* @__PURE__ */ new Map(), t = r && r.subscribe;
  function n(i) {
    var s = Zt.getValue();
    if (s) {
      var o = e.get(i);
      o || e.set(i, o = /* @__PURE__ */ new Set()), s.dependOn(o), typeof t == "function" && (Ft(o), o.unsubscribe = t(i));
    }
  }
  return n.dirty = function(s, o) {
    var a = e.get(s);
    if (a) {
      var c = o && Tu.call(Pu, o) ? o : "setDirty";
      En(a).forEach(function(u) {
        return u[c]();
      }), e.delete(s), Ft(a);
    }
  }, n;
}
function Ts() {
  var r = new bt(typeof WeakMap == "function");
  return function() {
    return r.lookupArray(arguments);
  };
}
Ts();
var cr = /* @__PURE__ */ new Set();
function Lt(r, e) {
  e === void 0 && (e = /* @__PURE__ */ Object.create(null));
  var t = new Du(e.max || Math.pow(2, 16), function(u) {
    return u.dispose();
  }), n = e.keyArgs, i = e.makeCacheKey || Ts(), s = function() {
    var u = i.apply(null, n ? n.apply(null, arguments) : arguments);
    if (u === void 0)
      return r.apply(null, arguments);
    var l = t.get(u);
    l || (t.set(u, l = new Au(r)), l.subscribe = e.subscribe, l.forget = function() {
      return t.delete(u);
    });
    var f = l.recompute(Array.prototype.slice.call(arguments));
    return t.set(u, l), cr.add(t), Zt.hasValue() || (cr.forEach(function(h) {
      return h.clean();
    }), cr.clear()), f;
  };
  Object.defineProperty(s, "size", {
    get: function() {
      return t.map.size;
    },
    configurable: !1,
    enumerable: !1
  });
  function o(u) {
    var l = t.get(u);
    l && l.setDirty();
  }
  s.dirtyKey = o, s.dirty = function() {
    o(i.apply(null, arguments));
  };
  function a(u) {
    var l = t.get(u);
    if (l)
      return l.peek();
  }
  s.peekKey = a, s.peek = function() {
    return a(i.apply(null, arguments));
  };
  function c(u) {
    return t.delete(u);
  }
  return s.forgetKey = c, s.forget = function() {
    return c(i.apply(null, arguments));
  }, s.makeCacheKey = i, s.getKey = n ? function() {
    return i.apply(null, n.apply(null, arguments));
  } : i, Object.freeze(s);
}
var Fu = function() {
  function r() {
    this.getFragmentDoc = Lt(Xo);
  }
  return r.prototype.batch = function(e) {
    var t = this, n = typeof e.optimistic == "string" ? e.optimistic : e.optimistic === !1 ? null : void 0, i;
    return this.performTransaction(function() {
      return i = e.update(t);
    }, n), i;
  }, r.prototype.recordOptimisticTransaction = function(e, t) {
    this.performTransaction(e, t);
  }, r.prototype.transformDocument = function(e) {
    return e;
  }, r.prototype.transformForLink = function(e) {
    return e;
  }, r.prototype.identify = function(e) {
  }, r.prototype.gc = function() {
    return [];
  }, r.prototype.modify = function(e) {
    return !1;
  }, r.prototype.readQuery = function(e, t) {
    return t === void 0 && (t = !!e.optimistic), this.read(y(y({}, e), { rootId: e.id || "ROOT_QUERY", optimistic: t }));
  }, r.prototype.readFragment = function(e, t) {
    return t === void 0 && (t = !!e.optimistic), this.read(y(y({}, e), { query: this.getFragmentDoc(e.fragment, e.fragmentName), rootId: e.id, optimistic: t }));
  }, r.prototype.writeQuery = function(e) {
    var t = e.id, n = e.data, i = Ve(e, ["id", "data"]);
    return this.write(Object.assign(i, {
      dataId: t || "ROOT_QUERY",
      result: n
    }));
  }, r.prototype.writeFragment = function(e) {
    var t = e.id, n = e.data, i = e.fragment, s = e.fragmentName, o = Ve(e, ["id", "data", "fragment", "fragmentName"]);
    return this.write(Object.assign(o, {
      query: this.getFragmentDoc(i, s),
      dataId: t,
      result: n
    }));
  }, r.prototype.updateQuery = function(e, t) {
    return this.batch({
      update: function(n) {
        var i = n.readQuery(e), s = t(i);
        return s == null ? i : (n.writeQuery(y(y({}, e), { data: s })), s);
      }
    });
  }, r.prototype.updateFragment = function(e, t) {
    return this.batch({
      update: function(n) {
        var i = n.readFragment(e), s = t(i);
        return s == null ? i : (n.writeFragment(y(y({}, e), { data: s })), s);
      }
    });
  }, r;
}(), Is = function(r) {
  K(e, r);
  function e(t, n, i, s) {
    var o, a = r.call(this, t) || this;
    if (a.message = t, a.path = n, a.query = i, a.variables = s, Array.isArray(a.path)) {
      a.missing = a.message;
      for (var c = a.path.length - 1; c >= 0; --c)
        a.missing = (o = {}, o[a.path[c]] = a.missing, o);
    } else
      a.missing = a.path;
    return a.__proto__ = e.prototype, a;
  }
  return e;
}(Error), q = Object.prototype.hasOwnProperty;
function Xe(r) {
  return r == null;
}
var L = Array.isArray;
function xs(r, e) {
  var t = r.__typename, n = r.id, i = r._id;
  if (typeof t == "string" && (e && (e.keyObject = Xe(n) ? Xe(i) ? void 0 : { _id: i } : { id: n }), Xe(n) && !Xe(i) && (n = i), !Xe(n)))
    return "".concat(t, ":").concat(typeof n == "number" || typeof n == "string" ? n : JSON.stringify(n));
}
var ks = {
  dataIdFromObject: xs,
  addTypename: !0,
  resultCaching: !0,
  canonizeResults: !1
};
function Lu(r) {
  return Jt(ks, r);
}
function As(r) {
  var e = r.canonizeResults;
  return e === void 0 ? ks.canonizeResults : e;
}
function ju(r, e) {
  return C(e) ? r.get(e.__ref, "__typename") : e && e.__typename;
}
var Ns = /^[_a-z][_0-9a-z]*/i;
function ve(r) {
  var e = r.match(Ns);
  return e ? e[0] : r;
}
function Qr(r, e, t) {
  return P(e) ? L(e) ? e.every(function(n) {
    return Qr(r, n, t);
  }) : r.selections.every(function(n) {
    if (oe(n) && Ht(n, t)) {
      var i = we(n);
      return q.call(e, i) && (!n.selectionSet || Qr(n.selectionSet, e[i], t));
    }
    return !0;
  }) : !1;
}
function Ce(r) {
  return P(r) && !C(r) && !L(r);
}
function Vu() {
  return new Se();
}
function Cs(r, e) {
  var t = nn(an(r));
  return {
    fragmentMap: t,
    lookupFragment: function(n) {
      var i = t[n];
      return !i && e && (i = e.lookup(n)), i || null;
    }
  };
}
var Nt = /* @__PURE__ */ Object.create(null), lr = function() {
  return Nt;
}, hi = /* @__PURE__ */ Object.create(null), ft = function() {
  function r(e, t) {
    var n = this;
    this.policies = e, this.group = t, this.data = /* @__PURE__ */ Object.create(null), this.rootIds = /* @__PURE__ */ Object.create(null), this.refs = /* @__PURE__ */ Object.create(null), this.getFieldValue = function(i, s) {
      return Mr(C(i) ? n.get(i.__ref, s) : i && i[s]);
    }, this.canRead = function(i) {
      return C(i) ? n.has(i.__ref) : typeof i == "object";
    }, this.toReference = function(i, s) {
      if (typeof i == "string")
        return Re(i);
      if (C(i))
        return i;
      var o = n.policies.identify(i)[0];
      if (o) {
        var a = Re(o);
        return s && n.merge(o, i), a;
      }
    };
  }
  return r.prototype.toObject = function() {
    return y({}, this.data);
  }, r.prototype.has = function(e) {
    return this.lookup(e, !0) !== void 0;
  }, r.prototype.get = function(e, t) {
    if (this.group.depend(e, t), q.call(this.data, e)) {
      var n = this.data[e];
      if (n && q.call(n, t))
        return n[t];
    }
    if (t === "__typename" && q.call(this.policies.rootTypenamesById, e))
      return this.policies.rootTypenamesById[e];
    if (this instanceof ue)
      return this.parent.get(e, t);
  }, r.prototype.lookup = function(e, t) {
    if (t && this.group.depend(e, "__exists"), q.call(this.data, e))
      return this.data[e];
    if (this instanceof ue)
      return this.parent.lookup(e, t);
    if (this.policies.rootTypenamesById[e])
      return /* @__PURE__ */ Object.create(null);
  }, r.prototype.merge = function(e, t) {
    var n = this, i;
    C(e) && (e = e.__ref), C(t) && (t = t.__ref);
    var s = typeof e == "string" ? this.lookup(i = e) : e, o = typeof t == "string" ? this.lookup(i = t) : t;
    if (!!o) {
      __DEV__ ? _(typeof i == "string", "store.merge expects a string ID") : _(typeof i == "string", 1);
      var a = new Se($u).merge(s, o);
      if (this.data[i] = a, a !== s && (delete this.refs[i], this.group.caching)) {
        var c = /* @__PURE__ */ Object.create(null);
        s || (c.__exists = 1), Object.keys(o).forEach(function(u) {
          if (!s || s[u] !== a[u]) {
            c[u] = 1;
            var l = ve(u);
            l !== u && !n.policies.hasKeyArgs(a.__typename, l) && (c[l] = 1), a[u] === void 0 && !(n instanceof ue) && delete a[u];
          }
        }), c.__typename && !(s && s.__typename) && this.policies.rootTypenamesById[i] === a.__typename && delete c.__typename, Object.keys(c).forEach(function(u) {
          return n.group.dirty(i, u);
        });
      }
    }
  }, r.prototype.modify = function(e, t) {
    var n = this, i = this.lookup(e);
    if (i) {
      var s = /* @__PURE__ */ Object.create(null), o = !1, a = !0, c = {
        DELETE: Nt,
        INVALIDATE: hi,
        isReference: C,
        toReference: this.toReference,
        canRead: this.canRead,
        readField: function(u, l) {
          return n.policies.readField(typeof u == "string" ? {
            fieldName: u,
            from: l || Re(e)
          } : u, { store: n });
        }
      };
      if (Object.keys(i).forEach(function(u) {
        var l = ve(u), f = i[u];
        if (f !== void 0) {
          var h = typeof t == "function" ? t : t[u] || t[l];
          if (h) {
            var p = h === lr ? Nt : h(Mr(f), y(y({}, c), { fieldName: l, storeFieldName: u, storage: n.getStorage(e, u) }));
            p === hi ? n.group.dirty(e, u) : (p === Nt && (p = void 0), p !== f && (s[u] = p, o = !0, f = p));
          }
          f !== void 0 && (a = !1);
        }
      }), o)
        return this.merge(e, s), a && (this instanceof ue ? this.data[e] = void 0 : delete this.data[e], this.group.dirty(e, "__exists")), !0;
    }
    return !1;
  }, r.prototype.delete = function(e, t, n) {
    var i, s = this.lookup(e);
    if (s) {
      var o = this.getFieldValue(s, "__typename"), a = t && n ? this.policies.getStoreFieldName({ typename: o, fieldName: t, args: n }) : t;
      return this.modify(e, a ? (i = {}, i[a] = lr, i) : lr);
    }
    return !1;
  }, r.prototype.evict = function(e, t) {
    var n = !1;
    return e.id && (q.call(this.data, e.id) && (n = this.delete(e.id, e.fieldName, e.args)), this instanceof ue && this !== t && (n = this.parent.evict(e, t) || n), (e.fieldName || n) && this.group.dirty(e.id, e.fieldName || "__exists")), n;
  }, r.prototype.clear = function() {
    this.replace(null);
  }, r.prototype.extract = function() {
    var e = this, t = this.toObject(), n = [];
    return this.getRootIdSet().forEach(function(i) {
      q.call(e.policies.rootTypenamesById, i) || n.push(i);
    }), n.length && (t.__META = { extraRootIds: n.sort() }), t;
  }, r.prototype.replace = function(e) {
    var t = this;
    if (Object.keys(this.data).forEach(function(s) {
      e && q.call(e, s) || t.delete(s);
    }), e) {
      var n = e.__META, i = Ve(e, ["__META"]);
      Object.keys(i).forEach(function(s) {
        t.merge(s, i[s]);
      }), n && n.extraRootIds.forEach(this.retain, this);
    }
  }, r.prototype.retain = function(e) {
    return this.rootIds[e] = (this.rootIds[e] || 0) + 1;
  }, r.prototype.release = function(e) {
    if (this.rootIds[e] > 0) {
      var t = --this.rootIds[e];
      return t || delete this.rootIds[e], t;
    }
    return 0;
  }, r.prototype.getRootIdSet = function(e) {
    return e === void 0 && (e = /* @__PURE__ */ new Set()), Object.keys(this.rootIds).forEach(e.add, e), this instanceof ue ? this.parent.getRootIdSet(e) : Object.keys(this.policies.rootTypenamesById).forEach(e.add, e), e;
  }, r.prototype.gc = function() {
    var e = this, t = this.getRootIdSet(), n = this.toObject();
    t.forEach(function(o) {
      q.call(n, o) && (Object.keys(e.findChildRefIds(o)).forEach(t.add, t), delete n[o]);
    });
    var i = Object.keys(n);
    if (i.length) {
      for (var s = this; s instanceof ue; )
        s = s.parent;
      i.forEach(function(o) {
        return s.delete(o);
      });
    }
    return i;
  }, r.prototype.findChildRefIds = function(e) {
    if (!q.call(this.refs, e)) {
      var t = this.refs[e] = /* @__PURE__ */ Object.create(null), n = this.data[e];
      if (!n)
        return t;
      var i = /* @__PURE__ */ new Set([n]);
      i.forEach(function(s) {
        C(s) && (t[s.__ref] = !0), P(s) && Object.keys(s).forEach(function(o) {
          var a = s[o];
          P(a) && i.add(a);
        });
      });
    }
    return this.refs[e];
  }, r.prototype.makeCacheKey = function() {
    return this.group.keyMaker.lookupArray(arguments);
  }, r;
}(), Ms = function() {
  function r(e, t) {
    t === void 0 && (t = null), this.caching = e, this.parent = t, this.d = null, this.resetCaching();
  }
  return r.prototype.resetCaching = function() {
    this.d = this.caching ? Ds() : null, this.keyMaker = new bt(Oe);
  }, r.prototype.depend = function(e, t) {
    if (this.d) {
      this.d(fr(e, t));
      var n = ve(t);
      n !== t && this.d(fr(e, n)), this.parent && this.parent.depend(e, t);
    }
  }, r.prototype.dirty = function(e, t) {
    this.d && this.d.dirty(fr(e, t), t === "__exists" ? "forget" : "setDirty");
  }, r;
}();
function fr(r, e) {
  return e + "#" + r;
}
function pi(r, e) {
  st(r) && r.group.depend(e, "__exists");
}
(function(r) {
  var e = function(t) {
    K(n, t);
    function n(i) {
      var s = i.policies, o = i.resultCaching, a = o === void 0 ? !0 : o, c = i.seed, u = t.call(this, s, new Ms(a)) || this;
      return u.stump = new Qu(u), u.storageTrie = new bt(Oe), c && u.replace(c), u;
    }
    return n.prototype.addLayer = function(i, s) {
      return this.stump.addLayer(i, s);
    }, n.prototype.removeLayer = function() {
      return this;
    }, n.prototype.getStorage = function() {
      return this.storageTrie.lookupArray(arguments);
    }, n;
  }(r);
  r.Root = e;
})(ft || (ft = {}));
var ue = function(r) {
  K(e, r);
  function e(t, n, i, s) {
    var o = r.call(this, n.policies, s) || this;
    return o.id = t, o.parent = n, o.replay = i, o.group = s, i(o), o;
  }
  return e.prototype.addLayer = function(t, n) {
    return new e(t, this, n, this.group);
  }, e.prototype.removeLayer = function(t) {
    var n = this, i = this.parent.removeLayer(t);
    return t === this.id ? (this.group.caching && Object.keys(this.data).forEach(function(s) {
      var o = n.data[s], a = i.lookup(s);
      a ? o ? o !== a && Object.keys(o).forEach(function(c) {
        Q(o[c], a[c]) || n.group.dirty(s, c);
      }) : (n.group.dirty(s, "__exists"), Object.keys(a).forEach(function(c) {
        n.group.dirty(s, c);
      })) : n.delete(s);
    }), i) : i === this.parent ? this : i.addLayer(this.id, this.replay);
  }, e.prototype.toObject = function() {
    return y(y({}, this.parent.toObject()), this.data);
  }, e.prototype.findChildRefIds = function(t) {
    var n = this.parent.findChildRefIds(t);
    return q.call(this.data, t) ? y(y({}, n), r.prototype.findChildRefIds.call(this, t)) : n;
  }, e.prototype.getStorage = function() {
    for (var t = this.parent; t.parent; )
      t = t.parent;
    return t.getStorage.apply(t, arguments);
  }, e;
}(ft), Qu = function(r) {
  K(e, r);
  function e(t) {
    return r.call(this, "EntityStore.Stump", t, function() {
    }, new Ms(t.group.caching, t.group)) || this;
  }
  return e.prototype.removeLayer = function() {
    return this;
  }, e.prototype.merge = function() {
    return this.parent.merge.apply(this.parent, arguments);
  }, e;
}(ue);
function $u(r, e, t) {
  var n = r[t], i = e[t];
  return Q(n, i) ? n : i;
}
function st(r) {
  return !!(r instanceof ft && r.group.caching);
}
function qu(r) {
  return P(r) ? L(r) ? r.slice(0) : y({ __proto__: Object.getPrototypeOf(r) }, r) : r;
}
var $r = function() {
  function r() {
    this.known = new (Ma ? WeakSet : Set)(), this.pool = new bt(Oe), this.passes = /* @__PURE__ */ new WeakMap(), this.keysByJSON = /* @__PURE__ */ new Map(), this.empty = this.admit({});
  }
  return r.prototype.isKnown = function(e) {
    return P(e) && this.known.has(e);
  }, r.prototype.pass = function(e) {
    if (P(e)) {
      var t = qu(e);
      return this.passes.set(t, e), t;
    }
    return e;
  }, r.prototype.admit = function(e) {
    var t = this;
    if (P(e)) {
      var n = this.passes.get(e);
      if (n)
        return n;
      var i = Object.getPrototypeOf(e);
      switch (i) {
        case Array.prototype: {
          if (this.known.has(e))
            return e;
          var s = e.map(this.admit, this), o = this.pool.lookupArray(s);
          return o.array || (this.known.add(o.array = s), __DEV__ && Object.freeze(s)), o.array;
        }
        case null:
        case Object.prototype: {
          if (this.known.has(e))
            return e;
          var a = Object.getPrototypeOf(e), c = [a], u = this.sortedKeys(e);
          c.push(u.json);
          var l = c.length;
          u.sorted.forEach(function(p) {
            c.push(t.admit(e[p]));
          });
          var o = this.pool.lookupArray(c);
          if (!o.object) {
            var f = o.object = Object.create(a);
            this.known.add(f), u.sorted.forEach(function(p, d) {
              f[p] = c[l + d];
            }), __DEV__ && Object.freeze(f);
          }
          return o.object;
        }
      }
    }
    return e;
  }, r.prototype.sortedKeys = function(e) {
    var t = Object.keys(e), n = this.pool.lookupArray(t);
    if (!n.keys) {
      t.sort();
      var i = JSON.stringify(t);
      (n.keys = this.keysByJSON.get(i)) || this.keysByJSON.set(i, n.keys = { sorted: t, json: i });
    }
    return n.keys;
  }, r;
}(), Ee = Object.assign(function(r) {
  if (P(r)) {
    qr === void 0 && di();
    var e = qr.admit(r), t = Ur.get(e);
    return t === void 0 && Ur.set(e, t = JSON.stringify(e)), t;
  }
  return JSON.stringify(r);
}, {
  reset: di
}), qr, Ur;
function di() {
  qr = new $r(), Ur = new (Oe ? WeakMap : Map)();
}
function vi(r) {
  return [
    r.selectionSet,
    r.objectOrReference,
    r.context,
    r.context.canonizeResults
  ];
}
var Uu = function() {
  function r(e) {
    var t = this;
    this.knownResults = new (Oe ? WeakMap : Map)(), this.config = Jt(e, {
      addTypename: e.addTypename !== !1,
      canonizeResults: As(e)
    }), this.canon = e.canon || new $r(), this.executeSelectionSet = Lt(function(n) {
      var i, s = n.context.canonizeResults, o = vi(n);
      o[3] = !s;
      var a = (i = t.executeSelectionSet).peek.apply(i, o);
      return a ? s ? y(y({}, a), { result: t.canon.admit(a.result) }) : a : (pi(n.context.store, n.enclosingRef.__ref), t.execSelectionSetImpl(n));
    }, {
      max: this.config.resultCacheMaxSize,
      keyArgs: vi,
      makeCacheKey: function(n, i, s, o) {
        if (st(s.store))
          return s.store.makeCacheKey(n, C(i) ? i.__ref : i, s.varString, o);
      }
    }), this.executeSubSelectedArray = Lt(function(n) {
      return pi(n.context.store, n.enclosingRef.__ref), t.execSubSelectedArrayImpl(n);
    }, {
      max: this.config.resultCacheMaxSize,
      makeCacheKey: function(n) {
        var i = n.field, s = n.array, o = n.context;
        if (st(o.store))
          return o.store.makeCacheKey(i, s, o.varString);
      }
    });
  }
  return r.prototype.resetCanon = function() {
    this.canon = new $r();
  }, r.prototype.diffQueryAgainstStore = function(e) {
    var t = e.store, n = e.query, i = e.rootId, s = i === void 0 ? "ROOT_QUERY" : i, o = e.variables, a = e.returnPartialData, c = a === void 0 ? !0 : a, u = e.canonizeResults, l = u === void 0 ? this.config.canonizeResults : u, f = this.config.cache.policies;
    o = y(y({}, cn(is(n))), o);
    var h = Re(s), p = this.executeSelectionSet({
      selectionSet: un(n).selectionSet,
      objectOrReference: h,
      enclosingRef: h,
      context: y({ store: t, query: n, policies: f, variables: o, varString: Ee(o), canonizeResults: l }, Cs(n, this.config.fragments))
    }), d;
    if (p.missing && (d = [new Is(zu(p.missing), p.missing, n, o)], !c))
      throw d[0];
    return {
      result: p.result,
      complete: !d,
      missing: d
    };
  }, r.prototype.isFresh = function(e, t, n, i) {
    if (st(i.store) && this.knownResults.get(e) === n) {
      var s = this.executeSelectionSet.peek(n, t, i, this.canon.isKnown(e));
      if (s && e === s.result)
        return !0;
    }
    return !1;
  }, r.prototype.execSelectionSetImpl = function(e) {
    var t = this, n = e.selectionSet, i = e.objectOrReference, s = e.enclosingRef, o = e.context;
    if (C(i) && !o.policies.rootTypenamesById[i.__ref] && !o.store.has(i.__ref))
      return {
        result: this.canon.empty,
        missing: "Dangling reference to missing ".concat(i.__ref, " object")
      };
    var a = o.variables, c = o.policies, u = o.store, l = u.getFieldValue(i, "__typename"), f = [], h, p = new Se();
    this.config.addTypename && typeof l == "string" && !c.rootIdsByTypename[l] && f.push({ __typename: l });
    function d(b, S) {
      var x;
      return b.missing && (h = p.merge(h, (x = {}, x[S] = b.missing, x))), b.result;
    }
    var v = new Set(n.selections);
    v.forEach(function(b) {
      var S, x;
      if (!!Ht(b, a))
        if (oe(b)) {
          var k = c.readField({
            fieldName: b.name.value,
            field: b,
            variables: o.variables,
            from: i
          }, o), D = we(b);
          k === void 0 ? fn.added(b) || (h = p.merge(h, (S = {}, S[D] = "Can't find field '".concat(b.name.value, "' on ").concat(C(i) ? i.__ref + " object" : "object " + JSON.stringify(i, null, 2)), S))) : L(k) ? k = d(t.executeSubSelectedArray({
            field: b,
            array: k,
            enclosingRef: s,
            context: o
          }), D) : b.selectionSet ? k != null && (k = d(t.executeSelectionSet({
            selectionSet: b.selectionSet,
            objectOrReference: k,
            enclosingRef: C(k) ? k : s,
            context: o
          }), D)) : o.canonizeResults && (k = t.canon.pass(k)), k !== void 0 && f.push((x = {}, x[D] = k, x));
        } else {
          var I = sn(b, o.lookupFragment);
          if (!I && b.kind === O.FRAGMENT_SPREAD)
            throw __DEV__ ? new N("No fragment named ".concat(b.name.value)) : new N(5);
          I && c.fragmentMatches(I, l) && I.selectionSet.selections.forEach(v.add, v);
        }
    });
    var g = hn(f), E = { result: g, missing: h }, T = o.canonizeResults ? this.canon.admit(E) : Mr(E);
    return T.result && this.knownResults.set(T.result, n), T;
  }, r.prototype.execSubSelectedArrayImpl = function(e) {
    var t = this, n = e.field, i = e.array, s = e.enclosingRef, o = e.context, a, c = new Se();
    function u(l, f) {
      var h;
      return l.missing && (a = c.merge(a, (h = {}, h[f] = l.missing, h))), l.result;
    }
    return n.selectionSet && (i = i.filter(o.store.canRead)), i = i.map(function(l, f) {
      return l === null ? null : L(l) ? u(t.executeSubSelectedArray({
        field: n,
        array: l,
        enclosingRef: s,
        context: o
      }), f) : n.selectionSet ? u(t.executeSelectionSet({
        selectionSet: n.selectionSet,
        objectOrReference: l,
        enclosingRef: C(l) ? l : s,
        context: o
      }), f) : (__DEV__ && Bu(o.store, n, l), l);
    }), {
      result: o.canonizeResults ? this.canon.admit(i) : i,
      missing: a
    };
  }, r;
}();
function zu(r) {
  try {
    JSON.stringify(r, function(e, t) {
      if (typeof t == "string")
        throw t;
      return t;
    });
  } catch (e) {
    return e;
  }
}
function Bu(r, e, t) {
  if (!e.selectionSet) {
    var n = /* @__PURE__ */ new Set([t]);
    n.forEach(function(i) {
      P(i) && (__DEV__ ? _(!C(i), "Missing selection set for object of type ".concat(ju(r, i), " returned for query field ").concat(e.name.value)) : _(!C(i), 6), Object.values(i).forEach(n.add, n));
    });
  }
}
var B = null, yi = {}, Hu = 1, Wu = function() {
  return function() {
    function r() {
      this.id = [
        "slot",
        Hu++,
        Date.now(),
        Math.random().toString(36).slice(2)
      ].join(":");
    }
    return r.prototype.hasValue = function() {
      for (var e = B; e; e = e.parent)
        if (this.id in e.slots) {
          var t = e.slots[this.id];
          if (t === yi)
            break;
          return e !== B && (B.slots[this.id] = t), !0;
        }
      return B && (B.slots[this.id] = yi), !1;
    }, r.prototype.getValue = function() {
      if (this.hasValue())
        return B.slots[this.id];
    }, r.prototype.withValue = function(e, t, n, i) {
      var s, o = (s = {
        __proto__: null
      }, s[this.id] = e, s), a = B;
      B = { parent: a, slots: o };
      try {
        return t.apply(i, n);
      } finally {
        B = a;
      }
    }, r.bind = function(e) {
      var t = B;
      return function() {
        var n = B;
        try {
          return B = t, e.apply(this, arguments);
        } finally {
          B = n;
        }
      };
    }, r.noContext = function(e, t, n) {
      if (B) {
        var i = B;
        try {
          return B = null, e.apply(n, t);
        } finally {
          B = i;
        }
      } else
        return e.apply(n, t);
    }, r;
  }();
};
function mi(r) {
  try {
    return r();
  } catch {
  }
}
var hr = "@wry/context:Slot", Gu = mi(function() {
  return globalThis;
}) || mi(function() {
  return global;
}) || /* @__PURE__ */ Object.create(null), gi = Gu, wn = gi[hr] || Array[hr] || function(r) {
  try {
    Object.defineProperty(gi, hr, {
      value: r,
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  } finally {
    return r;
  }
}(Wu());
wn.bind;
wn.noContext;
var Sn = new wn(), bi = /* @__PURE__ */ new WeakMap();
function ot(r) {
  var e = bi.get(r);
  return e || bi.set(r, e = {
    vars: /* @__PURE__ */ new Set(),
    dep: Ds()
  }), e;
}
function Ei(r) {
  ot(r).vars.forEach(function(e) {
    return e.forgetCache(r);
  });
}
function Yu(r) {
  ot(r).vars.forEach(function(e) {
    return e.attachCache(r);
  });
}
function Ju(r) {
  var e = /* @__PURE__ */ new Set(), t = /* @__PURE__ */ new Set(), n = function(s) {
    if (arguments.length > 0) {
      if (r !== s) {
        r = s, e.forEach(function(c) {
          ot(c).dep.dirty(n), Zu(c);
        });
        var o = Array.from(t);
        t.clear(), o.forEach(function(c) {
          return c(r);
        });
      }
    } else {
      var a = Sn.getValue();
      a && (i(a), ot(a).dep(n));
    }
    return r;
  };
  n.onNextChange = function(s) {
    return t.add(s), function() {
      t.delete(s);
    };
  };
  var i = n.attachCache = function(s) {
    return e.add(s), ot(s).vars.add(n), n;
  };
  return n.forgetCache = function(s) {
    return e.delete(s);
  }, n;
}
function Zu(r) {
  r.broadcastWatches && r.broadcastWatches();
}
var _i = /* @__PURE__ */ Object.create(null);
function On(r) {
  var e = JSON.stringify(r);
  return _i[e] || (_i[e] = /* @__PURE__ */ Object.create(null));
}
function wi(r) {
  var e = On(r);
  return e.keyFieldsFn || (e.keyFieldsFn = function(t, n) {
    var i = function(o, a) {
      return n.readField(a, o);
    }, s = n.keyObject = Dn(r, function(o) {
      var a = Pe(n.storeObject, o, i);
      return a === void 0 && t !== n.storeObject && q.call(t, o[0]) && (a = Pe(t, o, Ps)), __DEV__ ? _(a !== void 0, "Missing field '".concat(o.join("."), "' while extracting keyFields from ").concat(JSON.stringify(t))) : _(a !== void 0, 2), a;
    });
    return "".concat(n.typename, ":").concat(JSON.stringify(s));
  });
}
function Si(r) {
  var e = On(r);
  return e.keyArgsFn || (e.keyArgsFn = function(t, n) {
    var i = n.field, s = n.variables, o = n.fieldName, a = Dn(r, function(u) {
      var l = u[0], f = l.charAt(0);
      if (f === "@") {
        if (i && ne(i.directives)) {
          var h = l.slice(1), p = i.directives.find(function(E) {
            return E.name.value === h;
          }), d = p && Wt(p, s);
          return d && Pe(d, u.slice(1));
        }
        return;
      }
      if (f === "$") {
        var v = l.slice(1);
        if (s && q.call(s, v)) {
          var g = u.slice(0);
          return g[0] = v, Pe(s, g);
        }
        return;
      }
      if (t)
        return Pe(t, u);
    }), c = JSON.stringify(a);
    return (t || c !== "{}") && (o += ":" + c), o;
  });
}
function Dn(r, e) {
  var t = new Se();
  return Rs(r).reduce(function(n, i) {
    var s, o = e(i);
    if (o !== void 0) {
      for (var a = i.length - 1; a >= 0; --a)
        o = (s = {}, s[i[a]] = o, s);
      n = t.merge(n, o);
    }
    return n;
  }, /* @__PURE__ */ Object.create(null));
}
function Rs(r) {
  var e = On(r);
  if (!e.paths) {
    var t = e.paths = [], n = [];
    r.forEach(function(i, s) {
      L(i) ? (Rs(i).forEach(function(o) {
        return t.push(n.concat(o));
      }), n.length = 0) : (n.push(i), L(r[s + 1]) || (t.push(n.slice(0)), n.length = 0));
    });
  }
  return e.paths;
}
function Ps(r, e) {
  return r[e];
}
function Pe(r, e, t) {
  return t = t || Ps, Fs(e.reduce(function n(i, s) {
    return L(i) ? i.map(function(o) {
      return n(o, s);
    }) : i && t(i, s);
  }, r));
}
function Fs(r) {
  return P(r) ? L(r) ? r.map(Fs) : Dn(Object.keys(r).sort(), function(e) {
    return Pe(r, e);
  }) : r;
}
on.setStringify(Ee);
function zr(r) {
  return r.args !== void 0 ? r.args : r.field ? Wt(r.field, r.variables) : null;
}
var Xu = function() {
}, Oi = function(r, e) {
  return e.fieldName;
}, Di = function(r, e, t) {
  var n = t.mergeObjects;
  return n(r, e);
}, Ti = function(r, e) {
  return e;
}, Ku = function() {
  function r(e) {
    this.config = e, this.typePolicies = /* @__PURE__ */ Object.create(null), this.toBeAdded = /* @__PURE__ */ Object.create(null), this.supertypeMap = /* @__PURE__ */ new Map(), this.fuzzySubtypes = /* @__PURE__ */ new Map(), this.rootIdsByTypename = /* @__PURE__ */ Object.create(null), this.rootTypenamesById = /* @__PURE__ */ Object.create(null), this.usingPossibleTypes = !1, this.config = y({ dataIdFromObject: xs }, e), this.cache = this.config.cache, this.setRootTypename("Query"), this.setRootTypename("Mutation"), this.setRootTypename("Subscription"), e.possibleTypes && this.addPossibleTypes(e.possibleTypes), e.typePolicies && this.addTypePolicies(e.typePolicies);
  }
  return r.prototype.identify = function(e, t) {
    var n, i = this, s = t && (t.typename || ((n = t.storeObject) === null || n === void 0 ? void 0 : n.__typename)) || e.__typename;
    if (s === this.rootTypenamesById.ROOT_QUERY)
      return ["ROOT_QUERY"];
    for (var o = t && t.storeObject || e, a = y(y({}, t), { typename: s, storeObject: o, readField: t && t.readField || function() {
      var h = Tn(arguments, o);
      return i.readField(h, {
        store: i.cache.data,
        variables: h.variables
      });
    } }), c, u = s && this.getTypePolicy(s), l = u && u.keyFn || this.config.dataIdFromObject; l; ) {
      var f = l(e, a);
      if (L(f))
        l = wi(f);
      else {
        c = f;
        break;
      }
    }
    return c = c ? String(c) : void 0, a.keyObject ? [c, a.keyObject] : [c];
  }, r.prototype.addTypePolicies = function(e) {
    var t = this;
    Object.keys(e).forEach(function(n) {
      var i = e[n], s = i.queryType, o = i.mutationType, a = i.subscriptionType, c = Ve(i, ["queryType", "mutationType", "subscriptionType"]);
      s && t.setRootTypename("Query", n), o && t.setRootTypename("Mutation", n), a && t.setRootTypename("Subscription", n), q.call(t.toBeAdded, n) ? t.toBeAdded[n].push(c) : t.toBeAdded[n] = [c];
    });
  }, r.prototype.updateTypePolicy = function(e, t) {
    var n = this, i = this.getTypePolicy(e), s = t.keyFields, o = t.fields;
    function a(c, u) {
      c.merge = typeof u == "function" ? u : u === !0 ? Di : u === !1 ? Ti : c.merge;
    }
    a(i, t.merge), i.keyFn = s === !1 ? Xu : L(s) ? wi(s) : typeof s == "function" ? s : i.keyFn, o && Object.keys(o).forEach(function(c) {
      var u = n.getFieldPolicy(e, c, !0), l = o[c];
      if (typeof l == "function")
        u.read = l;
      else {
        var f = l.keyArgs, h = l.read, p = l.merge;
        u.keyFn = f === !1 ? Oi : L(f) ? Si(f) : typeof f == "function" ? f : u.keyFn, typeof h == "function" && (u.read = h), a(u, p);
      }
      u.read && u.merge && (u.keyFn = u.keyFn || Oi);
    });
  }, r.prototype.setRootTypename = function(e, t) {
    t === void 0 && (t = e);
    var n = "ROOT_" + e.toUpperCase(), i = this.rootTypenamesById[n];
    t !== i && (__DEV__ ? _(!i || i === e, "Cannot change root ".concat(e, " __typename more than once")) : _(!i || i === e, 3), i && delete this.rootIdsByTypename[i], this.rootIdsByTypename[t] = n, this.rootTypenamesById[n] = t);
  }, r.prototype.addPossibleTypes = function(e) {
    var t = this;
    this.usingPossibleTypes = !0, Object.keys(e).forEach(function(n) {
      t.getSupertypeSet(n, !0), e[n].forEach(function(i) {
        t.getSupertypeSet(i, !0).add(n);
        var s = i.match(Ns);
        (!s || s[0] !== i) && t.fuzzySubtypes.set(i, new RegExp(i));
      });
    });
  }, r.prototype.getTypePolicy = function(e) {
    var t = this;
    if (!q.call(this.typePolicies, e)) {
      var n = this.typePolicies[e] = /* @__PURE__ */ Object.create(null);
      n.fields = /* @__PURE__ */ Object.create(null);
      var i = this.supertypeMap.get(e);
      i && i.size && i.forEach(function(o) {
        var a = t.getTypePolicy(o), c = a.fields, u = Ve(a, ["fields"]);
        Object.assign(n, u), Object.assign(n.fields, c);
      });
    }
    var s = this.toBeAdded[e];
    return s && s.length && s.splice(0).forEach(function(o) {
      t.updateTypePolicy(e, o);
    }), this.typePolicies[e];
  }, r.prototype.getFieldPolicy = function(e, t, n) {
    if (e) {
      var i = this.getTypePolicy(e).fields;
      return i[t] || n && (i[t] = /* @__PURE__ */ Object.create(null));
    }
  }, r.prototype.getSupertypeSet = function(e, t) {
    var n = this.supertypeMap.get(e);
    return !n && t && this.supertypeMap.set(e, n = /* @__PURE__ */ new Set()), n;
  }, r.prototype.fragmentMatches = function(e, t, n, i) {
    var s = this;
    if (!e.typeCondition)
      return !0;
    if (!t)
      return !1;
    var o = e.typeCondition.name.value;
    if (t === o)
      return !0;
    if (this.usingPossibleTypes && this.supertypeMap.has(o))
      for (var a = this.getSupertypeSet(t, !0), c = [a], u = function(d) {
        var v = s.getSupertypeSet(d, !1);
        v && v.size && c.indexOf(v) < 0 && c.push(v);
      }, l = !!(n && this.fuzzySubtypes.size), f = !1, h = 0; h < c.length; ++h) {
        var p = c[h];
        if (p.has(o))
          return a.has(o) || (f && __DEV__ && _.warn("Inferring subtype ".concat(t, " of supertype ").concat(o)), a.add(o)), !0;
        p.forEach(u), l && h === c.length - 1 && Qr(e.selectionSet, n, i) && (l = !1, f = !0, this.fuzzySubtypes.forEach(function(d, v) {
          var g = t.match(d);
          g && g[0] === t && u(v);
        }));
      }
    return !1;
  }, r.prototype.hasKeyArgs = function(e, t) {
    var n = this.getFieldPolicy(e, t, !1);
    return !!(n && n.keyFn);
  }, r.prototype.getStoreFieldName = function(e) {
    var t = e.typename, n = e.fieldName, i = this.getFieldPolicy(t, n, !1), s, o = i && i.keyFn;
    if (o && t)
      for (var a = {
        typename: t,
        fieldName: n,
        field: e.field || null,
        variables: e.variables
      }, c = zr(e); o; ) {
        var u = o(c, a);
        if (L(u))
          o = Si(u);
        else {
          s = u || n;
          break;
        }
      }
    return s === void 0 && (s = e.field ? ca(e.field, e.variables) : on(n, zr(e))), s === !1 ? n : n === ve(s) ? s : n + ":" + s;
  }, r.prototype.readField = function(e, t) {
    var n = e.from;
    if (!!n) {
      var i = e.field || e.fieldName;
      if (!!i) {
        if (e.typename === void 0) {
          var s = t.store.getFieldValue(n, "__typename");
          s && (e.typename = s);
        }
        var o = this.getStoreFieldName(e), a = ve(o), c = t.store.getFieldValue(n, o), u = this.getFieldPolicy(e.typename, a, !1), l = u && u.read;
        if (l) {
          var f = Ii(this, n, e, t, t.store.getStorage(C(n) ? n.__ref : n, o));
          return Sn.withValue(this.cache, l, [c, f]);
        }
        return c;
      }
    }
  }, r.prototype.getReadFunction = function(e, t) {
    var n = this.getFieldPolicy(e, t, !1);
    return n && n.read;
  }, r.prototype.getMergeFunction = function(e, t, n) {
    var i = this.getFieldPolicy(e, t, !1), s = i && i.merge;
    return !s && n && (i = this.getTypePolicy(n), s = i && i.merge), s;
  }, r.prototype.runMergeFunction = function(e, t, n, i, s) {
    var o = n.field, a = n.typename, c = n.merge;
    return c === Di ? Ls(i.store)(e, t) : c === Ti ? t : (i.overwrite && (e = void 0), c(e, t, Ii(this, void 0, { typename: a, fieldName: o.name.value, field: o, variables: i.variables }, i, s || /* @__PURE__ */ Object.create(null))));
  }, r;
}();
function Ii(r, e, t, n, i) {
  var s = r.getStoreFieldName(t), o = ve(s), a = t.variables || n.variables, c = n.store, u = c.toReference, l = c.canRead;
  return {
    args: zr(t),
    field: t.field || null,
    fieldName: o,
    storeFieldName: s,
    variables: a,
    isReference: C,
    toReference: u,
    storage: i,
    cache: r.cache,
    canRead: l,
    readField: function() {
      return r.readField(Tn(arguments, e, a), n);
    },
    mergeObjects: Ls(n.store)
  };
}
function Tn(r, e, t) {
  var n = r[0], i = r[1], s = r.length, o;
  return typeof n == "string" ? o = {
    fieldName: n,
    from: s > 1 ? i : e
  } : (o = y({}, n), q.call(o, "from") || (o.from = e)), __DEV__ && o.from === void 0 && __DEV__ && _.warn("Undefined 'from' passed to readField with arguments ".concat(Ra(Array.from(r)))), o.variables === void 0 && (o.variables = t), o;
}
function Ls(r) {
  return function(t, n) {
    if (L(t) || L(n))
      throw __DEV__ ? new N("Cannot automatically merge arrays") : new N(4);
    if (P(t) && P(n)) {
      var i = r.getFieldValue(t, "__typename"), s = r.getFieldValue(n, "__typename"), o = i && s && i !== s;
      if (o)
        return n;
      if (C(t) && Ce(n))
        return r.merge(t.__ref, n), t;
      if (Ce(t) && C(n))
        return r.merge(t, n.__ref), n;
      if (Ce(t) && Ce(n))
        return y(y({}, t), n);
    }
    return n;
  };
}
function pr(r, e, t) {
  var n = "".concat(e).concat(t), i = r.flavors.get(n);
  return i || r.flavors.set(n, i = r.clientOnly === e && r.deferred === t ? r : y(y({}, r), { clientOnly: e, deferred: t })), i;
}
var ec = function() {
  function r(e, t, n) {
    this.cache = e, this.reader = t, this.fragments = n;
  }
  return r.prototype.writeToStore = function(e, t) {
    var n = this, i = t.query, s = t.result, o = t.dataId, a = t.variables, c = t.overwrite, u = gt(i), l = Vu();
    a = y(y({}, cn(u)), a);
    var f = y(y({ store: e, written: /* @__PURE__ */ Object.create(null), merge: function(p, d) {
      return l.merge(p, d);
    }, variables: a, varString: Ee(a) }, Cs(i, this.fragments)), { overwrite: !!c, incomingById: /* @__PURE__ */ new Map(), clientOnly: !1, deferred: !1, flavors: /* @__PURE__ */ new Map() }), h = this.processSelectionSet({
      result: s || /* @__PURE__ */ Object.create(null),
      dataId: o,
      selectionSet: u.selectionSet,
      mergeTree: { map: /* @__PURE__ */ new Map() },
      context: f
    });
    if (!C(h))
      throw __DEV__ ? new N("Could not identify object ".concat(JSON.stringify(s))) : new N(7);
    return f.incomingById.forEach(function(p, d) {
      var v = p.storeObject, g = p.mergeTree, E = p.fieldNodeSet, T = Re(d);
      if (g && g.map.size) {
        var b = n.applyMerges(g, T, v, f);
        if (C(b))
          return;
        v = b;
      }
      if (__DEV__ && !f.overwrite) {
        var S = /* @__PURE__ */ Object.create(null);
        E.forEach(function(D) {
          D.selectionSet && (S[D.name.value] = !0);
        });
        var x = function(D) {
          return S[ve(D)] === !0;
        }, k = function(D) {
          var I = g && g.map.get(D);
          return Boolean(I && I.info && I.info.merge);
        };
        Object.keys(v).forEach(function(D) {
          x(D) && !k(D) && tc(T, v, D, f.store);
        });
      }
      e.merge(d, v);
    }), e.retain(h.__ref), h;
  }, r.prototype.processSelectionSet = function(e) {
    var t = this, n = e.dataId, i = e.result, s = e.selectionSet, o = e.context, a = e.mergeTree, c = this.cache.policies, u = /* @__PURE__ */ Object.create(null), l = n && c.rootTypenamesById[n] || xr(i, s, o.fragmentMap) || n && o.store.get(n, "__typename");
    typeof l == "string" && (u.__typename = l);
    var f = function() {
      var b = Tn(arguments, u, o.variables);
      if (C(b.from)) {
        var S = o.incomingById.get(b.from.__ref);
        if (S) {
          var x = c.readField(y(y({}, b), { from: S.storeObject }), o);
          if (x !== void 0)
            return x;
        }
      }
      return c.readField(b, o);
    }, h = /* @__PURE__ */ new Set();
    this.flattenFields(s, i, o, l).forEach(function(b, S) {
      var x, k = we(S), D = i[k];
      if (h.add(S), D !== void 0) {
        var I = c.getStoreFieldName({
          typename: l,
          fieldName: S.name.value,
          field: S,
          variables: b.variables
        }), F = xi(a, I), j = t.processFieldValue(D, S, S.selectionSet ? pr(b, !1, !1) : b, F), ye = void 0;
        S.selectionSet && (C(j) || Ce(j)) && (ye = f("__typename", j));
        var Te = c.getMergeFunction(l, S.name.value, ye);
        Te ? F.info = {
          field: S,
          typename: l,
          merge: Te
        } : ki(a, I), u = b.merge(u, (x = {}, x[I] = j, x));
      } else
        __DEV__ && !b.clientOnly && !b.deferred && !fn.added(S) && !c.getReadFunction(l, S.name.value) && __DEV__ && _.error("Missing field '".concat(we(S), "' while writing result ").concat(JSON.stringify(i, null, 2)).substring(0, 1e3));
    });
    try {
      var p = c.identify(i, {
        typename: l,
        selectionSet: s,
        fragmentMap: o.fragmentMap,
        storeObject: u,
        readField: f
      }), d = p[0], v = p[1];
      n = n || d, v && (u = o.merge(u, v));
    } catch (b) {
      if (!n)
        throw b;
    }
    if (typeof n == "string") {
      var g = Re(n), E = o.written[n] || (o.written[n] = []);
      if (E.indexOf(s) >= 0 || (E.push(s), this.reader && this.reader.isFresh(i, g, s, o)))
        return g;
      var T = o.incomingById.get(n);
      return T ? (T.storeObject = o.merge(T.storeObject, u), T.mergeTree = Br(T.mergeTree, a), h.forEach(function(b) {
        return T.fieldNodeSet.add(b);
      })) : o.incomingById.set(n, {
        storeObject: u,
        mergeTree: jt(a) ? void 0 : a,
        fieldNodeSet: h
      }), g;
    }
    return u;
  }, r.prototype.processFieldValue = function(e, t, n, i) {
    var s = this;
    return !t.selectionSet || e === null ? __DEV__ ? mn(e) : e : L(e) ? e.map(function(o, a) {
      var c = s.processFieldValue(o, t, n, xi(i, a));
      return ki(i, a), c;
    }) : this.processSelectionSet({
      result: e,
      selectionSet: t.selectionSet,
      context: n,
      mergeTree: i
    });
  }, r.prototype.flattenFields = function(e, t, n, i) {
    i === void 0 && (i = xr(t, e, n.fragmentMap));
    var s = /* @__PURE__ */ new Map(), o = this.cache.policies, a = new bt(!1);
    return function c(u, l) {
      var f = a.lookup(u, l.clientOnly, l.deferred);
      f.visited || (f.visited = !0, u.selections.forEach(function(h) {
        if (!!Ht(h, n.variables)) {
          var p = l.clientOnly, d = l.deferred;
          if (!(p && d) && ne(h.directives) && h.directives.forEach(function(E) {
            var T = E.name.value;
            if (T === "client" && (p = !0), T === "defer") {
              var b = Wt(E, n.variables);
              (!b || b.if !== !1) && (d = !0);
            }
          }), oe(h)) {
            var v = s.get(h);
            v && (p = p && v.clientOnly, d = d && v.deferred), s.set(h, pr(n, p, d));
          } else {
            var g = sn(h, n.lookupFragment);
            if (!g && h.kind === O.FRAGMENT_SPREAD)
              throw __DEV__ ? new N("No fragment named ".concat(h.name.value)) : new N(8);
            g && o.fragmentMatches(g, i, t, n.variables) && c(g.selectionSet, pr(n, p, d));
          }
        }
      }));
    }(e, n), s;
  }, r.prototype.applyMerges = function(e, t, n, i, s) {
    var o, a = this;
    if (e.map.size && !C(n)) {
      var c = !L(n) && (C(t) || Ce(t)) ? t : void 0, u = n;
      c && !s && (s = [C(c) ? c.__ref : c]);
      var l, f = function(h, p) {
        return L(h) ? typeof p == "number" ? h[p] : void 0 : i.store.getFieldValue(h, String(p));
      };
      e.map.forEach(function(h, p) {
        var d = f(c, p), v = f(u, p);
        if (v !== void 0) {
          s && s.push(p);
          var g = a.applyMerges(h, d, v, i, s);
          g !== v && (l = l || /* @__PURE__ */ new Map(), l.set(p, g)), s && _(s.pop() === p);
        }
      }), l && (n = L(u) ? u.slice(0) : y({}, u), l.forEach(function(h, p) {
        n[p] = h;
      }));
    }
    return e.info ? this.cache.policies.runMergeFunction(t, n, e.info, i, s && (o = i.store).getStorage.apply(o, s)) : n;
  }, r;
}(), js = [];
function xi(r, e) {
  var t = r.map;
  return t.has(e) || t.set(e, js.pop() || { map: /* @__PURE__ */ new Map() }), t.get(e);
}
function Br(r, e) {
  if (r === e || !e || jt(e))
    return r;
  if (!r || jt(r))
    return e;
  var t = r.info && e.info ? y(y({}, r.info), e.info) : r.info || e.info, n = r.map.size && e.map.size, i = n ? /* @__PURE__ */ new Map() : r.map.size ? r.map : e.map, s = { info: t, map: i };
  if (n) {
    var o = new Set(e.map.keys());
    r.map.forEach(function(a, c) {
      s.map.set(c, Br(a, e.map.get(c))), o.delete(c);
    }), o.forEach(function(a) {
      s.map.set(a, Br(e.map.get(a), r.map.get(a)));
    });
  }
  return s;
}
function jt(r) {
  return !r || !(r.info || r.map.size);
}
function ki(r, e) {
  var t = r.map, n = t.get(e);
  n && jt(n) && (js.push(n), t.delete(e));
}
var Ai = /* @__PURE__ */ new Set();
function tc(r, e, t, n) {
  var i = function(f) {
    var h = n.getFieldValue(f, t);
    return typeof h == "object" && h;
  }, s = i(r);
  if (!!s) {
    var o = i(e);
    if (!!o && !C(s) && !Q(s, o) && !Object.keys(s).every(function(f) {
      return n.getFieldValue(o, f) !== void 0;
    })) {
      var a = n.getFieldValue(r, "__typename") || n.getFieldValue(e, "__typename"), c = ve(t), u = "".concat(a, ".").concat(c);
      if (!Ai.has(u)) {
        Ai.add(u);
        var l = [];
        !L(s) && !L(o) && [s, o].forEach(function(f) {
          var h = n.getFieldValue(f, "__typename");
          typeof h == "string" && !l.includes(h) && l.push(h);
        }), __DEV__ && _.warn("Cache data may be lost when replacing the ".concat(c, " field of a ").concat(a, ` object.

To address this problem (which is not a bug in Apollo Client), `).concat(l.length ? "either ensure all objects of type " + l.join(" and ") + " have an ID or a custom merge function, or " : "", "define a custom merge function for the ").concat(u, ` field, so InMemoryCache can safely merge these objects:

  existing: `).concat(JSON.stringify(s).slice(0, 1e3), `
  incoming: `).concat(JSON.stringify(o).slice(0, 1e3), `

For more information about these options, please refer to the documentation:

  * Ensuring entity objects have IDs: https://go.apollo.dev/c/generating-unique-identifiers
  * Defining custom merge functions: https://go.apollo.dev/c/merging-non-normalized-objects
`));
      }
    }
  }
}
var rc = function(r) {
  K(e, r);
  function e(t) {
    t === void 0 && (t = {});
    var n = r.call(this) || this;
    return n.watches = /* @__PURE__ */ new Set(), n.typenameDocumentCache = /* @__PURE__ */ new Map(), n.makeVar = Ju, n.txCount = 0, n.config = Lu(t), n.addTypename = !!n.config.addTypename, n.policies = new Ku({
      cache: n,
      dataIdFromObject: n.config.dataIdFromObject,
      possibleTypes: n.config.possibleTypes,
      typePolicies: n.config.typePolicies
    }), n.init(), n;
  }
  return e.prototype.init = function() {
    var t = this.data = new ft.Root({
      policies: this.policies,
      resultCaching: this.config.resultCaching
    });
    this.optimisticData = t.stump, this.resetResultCache();
  }, e.prototype.resetResultCache = function(t) {
    var n = this, i = this.storeReader, s = this.config.fragments;
    this.storeWriter = new ec(this, this.storeReader = new Uu({
      cache: this,
      addTypename: this.addTypename,
      resultCacheMaxSize: this.config.resultCacheMaxSize,
      canonizeResults: As(this.config),
      canon: t ? void 0 : i && i.canon,
      fragments: s
    }), s), this.maybeBroadcastWatch = Lt(function(o, a) {
      return n.broadcastWatch(o, a);
    }, {
      max: this.config.resultCacheMaxSize,
      makeCacheKey: function(o) {
        var a = o.optimistic ? n.optimisticData : n.data;
        if (st(a)) {
          var c = o.optimistic, u = o.id, l = o.variables;
          return a.makeCacheKey(o.query, o.callback, Ee({ optimistic: c, id: u, variables: l }));
        }
      }
    }), (/* @__PURE__ */ new Set([
      this.data.group,
      this.optimisticData.group
    ])).forEach(function(o) {
      return o.resetCaching();
    });
  }, e.prototype.restore = function(t) {
    return this.init(), t && this.data.replace(t), this;
  }, e.prototype.extract = function(t) {
    return t === void 0 && (t = !1), (t ? this.optimisticData : this.data).extract();
  }, e.prototype.read = function(t) {
    var n = t.returnPartialData, i = n === void 0 ? !1 : n;
    try {
      return this.storeReader.diffQueryAgainstStore(y(y({}, t), { store: t.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: i })).result || null;
    } catch (s) {
      if (s instanceof Is)
        return null;
      throw s;
    }
  }, e.prototype.write = function(t) {
    try {
      return ++this.txCount, this.storeWriter.writeToStore(this.data, t);
    } finally {
      !--this.txCount && t.broadcast !== !1 && this.broadcastWatches();
    }
  }, e.prototype.modify = function(t) {
    if (q.call(t, "id") && !t.id)
      return !1;
    var n = t.optimistic ? this.optimisticData : this.data;
    try {
      return ++this.txCount, n.modify(t.id || "ROOT_QUERY", t.fields);
    } finally {
      !--this.txCount && t.broadcast !== !1 && this.broadcastWatches();
    }
  }, e.prototype.diff = function(t) {
    return this.storeReader.diffQueryAgainstStore(y(y({}, t), { store: t.optimistic ? this.optimisticData : this.data, rootId: t.id || "ROOT_QUERY", config: this.config }));
  }, e.prototype.watch = function(t) {
    var n = this;
    return this.watches.size || Yu(this), this.watches.add(t), t.immediate && this.maybeBroadcastWatch(t), function() {
      n.watches.delete(t) && !n.watches.size && Ei(n), n.maybeBroadcastWatch.forget(t);
    };
  }, e.prototype.gc = function(t) {
    Ee.reset();
    var n = this.optimisticData.gc();
    return t && !this.txCount && (t.resetResultCache ? this.resetResultCache(t.resetResultIdentities) : t.resetResultIdentities && this.storeReader.resetCanon()), n;
  }, e.prototype.retain = function(t, n) {
    return (n ? this.optimisticData : this.data).retain(t);
  }, e.prototype.release = function(t, n) {
    return (n ? this.optimisticData : this.data).release(t);
  }, e.prototype.identify = function(t) {
    if (C(t))
      return t.__ref;
    try {
      return this.policies.identify(t)[0];
    } catch (n) {
      __DEV__ && _.warn(n);
    }
  }, e.prototype.evict = function(t) {
    if (!t.id) {
      if (q.call(t, "id"))
        return !1;
      t = y(y({}, t), { id: "ROOT_QUERY" });
    }
    try {
      return ++this.txCount, this.optimisticData.evict(t, this.data);
    } finally {
      !--this.txCount && t.broadcast !== !1 && this.broadcastWatches();
    }
  }, e.prototype.reset = function(t) {
    var n = this;
    return this.init(), Ee.reset(), t && t.discardWatches ? (this.watches.forEach(function(i) {
      return n.maybeBroadcastWatch.forget(i);
    }), this.watches.clear(), Ei(this)) : this.broadcastWatches(), Promise.resolve();
  }, e.prototype.removeOptimistic = function(t) {
    var n = this.optimisticData.removeLayer(t);
    n !== this.optimisticData && (this.optimisticData = n, this.broadcastWatches());
  }, e.prototype.batch = function(t) {
    var n = this, i = t.update, s = t.optimistic, o = s === void 0 ? !0 : s, a = t.removeOptimistic, c = t.onWatchUpdated, u, l = function(h) {
      var p = n, d = p.data, v = p.optimisticData;
      ++n.txCount, h && (n.data = n.optimisticData = h);
      try {
        return u = i(n);
      } finally {
        --n.txCount, n.data = d, n.optimisticData = v;
      }
    }, f = /* @__PURE__ */ new Set();
    return c && !this.txCount && this.broadcastWatches(y(y({}, t), { onWatchUpdated: function(h) {
      return f.add(h), !1;
    } })), typeof o == "string" ? this.optimisticData = this.optimisticData.addLayer(o, l) : o === !1 ? l(this.data) : l(), typeof a == "string" && (this.optimisticData = this.optimisticData.removeLayer(a)), c && f.size ? (this.broadcastWatches(y(y({}, t), { onWatchUpdated: function(h, p) {
      var d = c.call(this, h, p);
      return d !== !1 && f.delete(h), d;
    } })), f.size && f.forEach(function(h) {
      return n.maybeBroadcastWatch.dirty(h);
    })) : this.broadcastWatches(t), u;
  }, e.prototype.performTransaction = function(t, n) {
    return this.batch({
      update: t,
      optimistic: n || n !== null
    });
  }, e.prototype.transformDocument = function(t) {
    if (this.addTypename) {
      var n = this.typenameDocumentCache.get(t);
      return n || (n = fn(t), this.typenameDocumentCache.set(t, n), this.typenameDocumentCache.set(n, n)), n;
    }
    return t;
  }, e.prototype.transformForLink = function(t) {
    var n = this.config.fragments;
    return n ? n.transform(t) : t;
  }, e.prototype.broadcastWatches = function(t) {
    var n = this;
    this.txCount || this.watches.forEach(function(i) {
      return n.maybeBroadcastWatch(i, t);
    });
  }, e.prototype.broadcastWatch = function(t, n) {
    var i = t.lastDiff, s = this.diff(t);
    n && (t.optimistic && typeof n.optimistic == "string" && (s.fromOptimisticTransaction = !0), n.onWatchUpdated && n.onWatchUpdated.call(this, t, s, i) === !1) || (!i || !Q(i.result, s.result)) && t.callback(t.lastDiff = s, i);
  }, e;
}(Fu);
function nc(r) {
  return r.hasOwnProperty("graphQLErrors");
}
var ic = function(r) {
  var e = "";
  if (ne(r.graphQLErrors) || ne(r.clientErrors)) {
    var t = (r.graphQLErrors || []).concat(r.clientErrors || []);
    t.forEach(function(n) {
      var i = n ? n.message : "Error message not found.";
      e += "".concat(i, `
`);
    });
  }
  return r.networkError && (e += "".concat(r.networkError.message, `
`)), e = e.replace(/\n$/, ""), e;
}, xe = function(r) {
  K(e, r);
  function e(t) {
    var n = t.graphQLErrors, i = t.clientErrors, s = t.networkError, o = t.errorMessage, a = t.extraInfo, c = r.call(this, o) || this;
    return c.graphQLErrors = n || [], c.clientErrors = i || [], c.networkError = s || null, c.message = o || ic(c), c.extraInfo = a, c.__proto__ = e.prototype, c;
  }
  return e;
}(Error), M;
(function(r) {
  r[r.loading = 1] = "loading", r[r.setVariables = 2] = "setVariables", r[r.fetchMore = 3] = "fetchMore", r[r.refetch = 4] = "refetch", r[r.poll = 6] = "poll", r[r.ready = 7] = "ready", r[r.error = 8] = "error";
})(M || (M = {}));
function ht(r) {
  return r ? r < 7 : !1;
}
var sc = Object.assign, oc = Object.hasOwnProperty, Hr = function(r) {
  K(e, r);
  function e(t) {
    var n = t.queryManager, i = t.queryInfo, s = t.options, o = r.call(this, function(g) {
      try {
        var E = g._subscription._observer;
        E && !E.error && (E.error = ac);
      } catch {
      }
      var T = !o.observers.size;
      o.observers.add(g);
      var b = o.last;
      return b && b.error ? g.error && g.error(b.error) : b && b.result && g.next && g.next(b.result), T && o.reobserve().catch(function() {
      }), function() {
        o.observers.delete(g) && !o.observers.size && o.tearDownQuery();
      };
    }) || this;
    o.observers = /* @__PURE__ */ new Set(), o.subscriptions = /* @__PURE__ */ new Set(), o.queryInfo = i, o.queryManager = n, o.isTornDown = !1;
    var a = n.defaultOptions.watchQuery, c = a === void 0 ? {} : a, u = c.fetchPolicy, l = u === void 0 ? "cache-first" : u, f = s.fetchPolicy, h = f === void 0 ? l : f, p = s.initialFetchPolicy, d = p === void 0 ? h === "standby" ? l : h : p;
    o.options = y(y({}, s), { initialFetchPolicy: d, fetchPolicy: h }), o.queryId = i.queryId || n.generateQueryId();
    var v = gt(o.query);
    return o.queryName = v && v.name && v.name.value, o;
  }
  return Object.defineProperty(e.prototype, "query", {
    get: function() {
      return this.queryManager.transform(this.options.query).document;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e.prototype, "variables", {
    get: function() {
      return this.options.variables;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.result = function() {
    var t = this;
    return new Promise(function(n, i) {
      var s = {
        next: function(a) {
          n(a), t.observers.delete(s), t.observers.size || t.queryManager.removeQuery(t.queryId), setTimeout(function() {
            o.unsubscribe();
          }, 0);
        },
        error: i
      }, o = t.subscribe(s);
    });
  }, e.prototype.getCurrentResult = function(t) {
    t === void 0 && (t = !0);
    var n = this.getLastResult(!0), i = this.queryInfo.networkStatus || n && n.networkStatus || M.ready, s = y(y({}, n), { loading: ht(i), networkStatus: i }), o = this.options.fetchPolicy, a = o === void 0 ? "cache-first" : o;
    if (!(a === "network-only" || a === "no-cache" || a === "standby" || this.queryManager.transform(this.options.query).hasForcedResolvers)) {
      var c = this.queryInfo.getDiff();
      (c.complete || this.options.returnPartialData) && (s.data = c.result), Q(s.data, {}) && (s.data = void 0), c.complete ? (delete s.partial, c.complete && s.networkStatus === M.loading && (a === "cache-first" || a === "cache-only") && (s.networkStatus = M.ready, s.loading = !1)) : s.partial = !0, __DEV__ && !c.complete && !this.options.partialRefetch && !s.loading && !s.data && !s.error && Qs(c.missing);
    }
    return t && this.updateLastResult(s), s;
  }, e.prototype.isDifferentFromLastResult = function(t, n) {
    return !this.last || !Q(this.last.result, t) || n && !Q(this.last.variables, n);
  }, e.prototype.getLast = function(t, n) {
    var i = this.last;
    if (i && i[t] && (!n || Q(i.variables, this.variables)))
      return i[t];
  }, e.prototype.getLastResult = function(t) {
    return this.getLast("result", t);
  }, e.prototype.getLastError = function(t) {
    return this.getLast("error", t);
  }, e.prototype.resetLastResults = function() {
    delete this.last, this.isTornDown = !1;
  }, e.prototype.resetQueryStoreErrors = function() {
    this.queryManager.resetErrors(this.queryId);
  }, e.prototype.refetch = function(t) {
    var n, i = {
      pollInterval: 0
    }, s = this.options.fetchPolicy;
    if (s === "cache-and-network" ? i.fetchPolicy = s : s === "no-cache" ? i.fetchPolicy = "no-cache" : i.fetchPolicy = "network-only", __DEV__ && t && oc.call(t, "variables")) {
      var o = is(this.query), a = o.variableDefinitions;
      (!a || !a.some(function(c) {
        return c.variable.name.value === "variables";
      })) && __DEV__ && _.warn("Called refetch(".concat(JSON.stringify(t), ") for query ").concat(((n = o.name) === null || n === void 0 ? void 0 : n.value) || JSON.stringify(o), `, which does not declare a $variables variable.
Did you mean to call refetch(variables) instead of refetch({ variables })?`));
    }
    return t && !Q(this.options.variables, t) && (i.variables = this.options.variables = y(y({}, this.options.variables), t)), this.queryInfo.resetLastWrite(), this.reobserve(i, M.refetch);
  }, e.prototype.fetchMore = function(t) {
    var n = this, i = y(y({}, t.query ? t : y(y(y(y({}, this.options), { query: this.query }), t), { variables: y(y({}, this.options.variables), t.variables) })), { fetchPolicy: "no-cache" }), s = this.queryManager.generateQueryId(), o = this.queryInfo, a = o.networkStatus;
    o.networkStatus = M.fetchMore, i.notifyOnNetworkStatusChange && this.observe();
    var c = /* @__PURE__ */ new Set();
    return this.queryManager.fetchQuery(s, i, M.fetchMore).then(function(u) {
      return n.queryManager.removeQuery(s), o.networkStatus === M.fetchMore && (o.networkStatus = a), n.queryManager.cache.batch({
        update: function(l) {
          var f = t.updateQuery;
          f ? l.updateQuery({
            query: n.query,
            variables: n.variables,
            returnPartialData: !0,
            optimistic: !1
          }, function(h) {
            return f(h, {
              fetchMoreResult: u.data,
              variables: i.variables
            });
          }) : l.writeQuery({
            query: i.query,
            variables: i.variables,
            data: u.data
          });
        },
        onWatchUpdated: function(l) {
          c.add(l.query);
        }
      }), u;
    }).finally(function() {
      c.has(n.query) || Vs(n);
    });
  }, e.prototype.subscribeToMore = function(t) {
    var n = this, i = this.queryManager.startGraphQLSubscription({
      query: t.document,
      variables: t.variables,
      context: t.context
    }).subscribe({
      next: function(s) {
        var o = t.updateQuery;
        o && n.updateQuery(function(a, c) {
          var u = c.variables;
          return o(a, {
            subscriptionData: s,
            variables: u
          });
        });
      },
      error: function(s) {
        if (t.onError) {
          t.onError(s);
          return;
        }
        __DEV__ && _.error("Unhandled GraphQL subscription error", s);
      }
    });
    return this.subscriptions.add(i), function() {
      n.subscriptions.delete(i) && i.unsubscribe();
    };
  }, e.prototype.setOptions = function(t) {
    return this.reobserve(t);
  }, e.prototype.setVariables = function(t) {
    return Q(this.variables, t) ? this.observers.size ? this.result() : Promise.resolve() : (this.options.variables = t, this.observers.size ? this.reobserve({
      fetchPolicy: this.options.initialFetchPolicy,
      variables: t
    }, M.setVariables) : Promise.resolve());
  }, e.prototype.updateQuery = function(t) {
    var n = this.queryManager, i = n.cache.diff({
      query: this.options.query,
      variables: this.variables,
      returnPartialData: !0,
      optimistic: !1
    }).result, s = t(i, {
      variables: this.variables
    });
    s && (n.cache.writeQuery({
      query: this.options.query,
      data: s,
      variables: this.variables
    }), n.broadcastQueries());
  }, e.prototype.startPolling = function(t) {
    this.options.pollInterval = t, this.updatePolling();
  }, e.prototype.stopPolling = function() {
    this.options.pollInterval = 0, this.updatePolling();
  }, e.prototype.applyNextFetchPolicy = function(t, n) {
    if (n.nextFetchPolicy) {
      var i = n.fetchPolicy, s = i === void 0 ? "cache-first" : i, o = n.initialFetchPolicy, a = o === void 0 ? s : o;
      s === "standby" || (typeof n.nextFetchPolicy == "function" ? n.fetchPolicy = n.nextFetchPolicy(s, {
        reason: t,
        options: n,
        observable: this,
        initialFetchPolicy: a
      }) : t === "variables-changed" ? n.fetchPolicy = a : n.fetchPolicy = n.nextFetchPolicy);
    }
    return n.fetchPolicy;
  }, e.prototype.fetch = function(t, n) {
    return this.queryManager.setObservableQuery(this), this.queryManager.fetchQueryObservable(this.queryId, t, n);
  }, e.prototype.updatePolling = function() {
    var t = this;
    if (!this.queryManager.ssrMode) {
      var n = this, i = n.pollingInfo, s = n.options.pollInterval;
      if (!s) {
        i && (clearTimeout(i.timeout), delete this.pollingInfo);
        return;
      }
      if (!(i && i.interval === s)) {
        __DEV__ ? _(s, "Attempted to start a polling query without a polling interval.") : _(s, 12);
        var o = i || (this.pollingInfo = {});
        o.interval = s;
        var a = function() {
          t.pollingInfo && (ht(t.queryInfo.networkStatus) ? c() : t.reobserve({
            fetchPolicy: t.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
          }, M.poll).then(c, c));
        }, c = function() {
          var u = t.pollingInfo;
          u && (clearTimeout(u.timeout), u.timeout = setTimeout(a, u.interval));
        };
        c();
      }
    }
  }, e.prototype.updateLastResult = function(t, n) {
    return n === void 0 && (n = this.variables), this.last = y(y({}, this.last), { result: this.queryManager.assumeImmutableResults ? t : mn(t), variables: n }), ne(t.errors) || delete this.last.error, this.last;
  }, e.prototype.reobserve = function(t, n) {
    var i = this;
    this.isTornDown = !1;
    var s = n === M.refetch || n === M.fetchMore || n === M.poll, o = this.options.variables, a = this.options.fetchPolicy, c = Jt(this.options, t || {}), u = s ? c : sc(this.options, c);
    s || (this.updatePolling(), t && t.variables && !Q(t.variables, o) && u.fetchPolicy !== "standby" && u.fetchPolicy === a && (this.applyNextFetchPolicy("variables-changed", u), n === void 0 && (n = M.setVariables)));
    var l = u.variables && y({}, u.variables), f = this.fetch(u, n), h = {
      next: function(p) {
        i.reportResult(p, l);
      },
      error: function(p) {
        i.reportError(p, l);
      }
    };
    return s || (this.concast && this.observer && this.concast.removeObserver(this.observer), this.concast = f, this.observer = h), f.addObserver(h), f.promise;
  }, e.prototype.observe = function() {
    this.reportResult(this.getCurrentResult(!1), this.variables);
  }, e.prototype.reportResult = function(t, n) {
    var i = this.getLastError();
    (i || this.isDifferentFromLastResult(t, n)) && ((i || !t.partial || this.options.returnPartialData) && this.updateLastResult(t, n), it(this.observers, "next", t));
  }, e.prototype.reportError = function(t, n) {
    var i = y(y({}, this.getLastResult()), { error: t, errors: t.graphQLErrors, networkStatus: M.error, loading: !1 });
    this.updateLastResult(i, n), it(this.observers, "error", this.last.error = t);
  }, e.prototype.hasObservers = function() {
    return this.observers.size > 0;
  }, e.prototype.tearDownQuery = function() {
    this.isTornDown || (this.concast && this.observer && (this.concast.removeObserver(this.observer), delete this.concast, delete this.observer), this.stopPolling(), this.subscriptions.forEach(function(t) {
      return t.unsubscribe();
    }), this.subscriptions.clear(), this.queryManager.stopQuery(this.queryId), this.observers.clear(), this.isTornDown = !0);
  }, e;
}(R);
hs(Hr);
function Vs(r) {
  var e = r.options, t = e.fetchPolicy, n = e.nextFetchPolicy;
  return t === "cache-and-network" || t === "network-only" ? r.reobserve({
    fetchPolicy: "cache-first",
    nextFetchPolicy: function() {
      return this.nextFetchPolicy = n, typeof n == "function" ? n.apply(this, arguments) : t;
    }
  }) : r.reobserve();
}
function ac(r) {
  __DEV__ && _.error("Unhandled error", r.message, r.stack);
}
function Qs(r) {
  __DEV__ && r && __DEV__ && _.debug("Missing cache result fields: ".concat(JSON.stringify(r)), r);
}
var $s = function() {
  function r(e) {
    var t = e.cache, n = e.client, i = e.resolvers, s = e.fragmentMatcher;
    this.cache = t, n && (this.client = n), i && this.addResolvers(i), s && this.setFragmentMatcher(s);
  }
  return r.prototype.addResolvers = function(e) {
    var t = this;
    this.resolvers = this.resolvers || {}, Array.isArray(e) ? e.forEach(function(n) {
      t.resolvers = Gn(t.resolvers, n);
    }) : this.resolvers = Gn(this.resolvers, e);
  }, r.prototype.setResolvers = function(e) {
    this.resolvers = {}, this.addResolvers(e);
  }, r.prototype.getResolvers = function() {
    return this.resolvers || {};
  }, r.prototype.runResolvers = function(e) {
    var t = e.document, n = e.remoteResult, i = e.context, s = e.variables, o = e.onlyRunForcedResolvers, a = o === void 0 ? !1 : o;
    return ce(this, void 0, void 0, function() {
      return le(this, function(c) {
        return t ? [2, this.resolveDocument(t, n.data, i, s, this.fragmentMatcher, a).then(function(u) {
          return y(y({}, n), { data: u.result });
        })] : [2, n];
      });
    });
  }, r.prototype.setFragmentMatcher = function(e) {
    this.fragmentMatcher = e;
  }, r.prototype.getFragmentMatcher = function() {
    return this.fragmentMatcher;
  }, r.prototype.clientQuery = function(e) {
    return rn(["client"], e) && this.resolvers ? e : null;
  }, r.prototype.serverQuery = function(e) {
    return ba(e);
  }, r.prototype.prepareContext = function(e) {
    var t = this.cache;
    return y(y({}, e), { cache: t, getCacheKey: function(n) {
      return t.identify(n);
    } });
  }, r.prototype.addExportedVariables = function(e, t, n) {
    return t === void 0 && (t = {}), n === void 0 && (n = {}), ce(this, void 0, void 0, function() {
      return le(this, function(i) {
        return e ? [2, this.resolveDocument(e, this.buildRootValueFromCache(e, t) || {}, this.prepareContext(n), t).then(function(s) {
          return y(y({}, t), s.exportedVariables);
        })] : [2, y({}, t)];
      });
    });
  }, r.prototype.shouldForceResolvers = function(e) {
    var t = !1;
    return ie(e, {
      Directive: {
        enter: function(n) {
          if (n.name.value === "client" && n.arguments && (t = n.arguments.some(function(i) {
            return i.name.value === "always" && i.value.kind === "BooleanValue" && i.value.value === !0;
          }), t))
            return tn;
        }
      }
    }), t;
  }, r.prototype.buildRootValueFromCache = function(e, t) {
    return this.cache.diff({
      query: ga(e),
      variables: t,
      returnPartialData: !0,
      optimistic: !1
    }).result;
  }, r.prototype.resolveDocument = function(e, t, n, i, s, o) {
    return n === void 0 && (n = {}), i === void 0 && (i = {}), s === void 0 && (s = function() {
      return !0;
    }), o === void 0 && (o = !1), ce(this, void 0, void 0, function() {
      var a, c, u, l, f, h, p, d, v;
      return le(this, function(g) {
        return a = un(e), c = an(e), u = nn(c), l = a.operation, f = l ? l.charAt(0).toUpperCase() + l.slice(1) : "Query", h = this, p = h.cache, d = h.client, v = {
          fragmentMap: u,
          context: y(y({}, n), { cache: p, client: d }),
          variables: i,
          fragmentMatcher: s,
          defaultOperationType: f,
          exportedVariables: {},
          onlyRunForcedResolvers: o
        }, [2, this.resolveSelectionSet(a.selectionSet, t, v).then(function(E) {
          return {
            result: E,
            exportedVariables: v.exportedVariables
          };
        })];
      });
    });
  }, r.prototype.resolveSelectionSet = function(e, t, n) {
    return ce(this, void 0, void 0, function() {
      var i, s, o, a, c, u = this;
      return le(this, function(l) {
        return i = n.fragmentMap, s = n.context, o = n.variables, a = [t], c = function(f) {
          return ce(u, void 0, void 0, function() {
            var h, p;
            return le(this, function(d) {
              return Ht(f, o) ? oe(f) ? [2, this.resolveField(f, t, n).then(function(v) {
                var g;
                typeof v < "u" && a.push((g = {}, g[we(f)] = v, g));
              })] : (ns(f) ? h = f : (h = i[f.name.value], __DEV__ ? _(h, "No fragment named ".concat(f.name.value)) : _(h, 11)), h && h.typeCondition && (p = h.typeCondition.name.value, n.fragmentMatcher(t, p, s)) ? [2, this.resolveSelectionSet(h.selectionSet, t, n).then(function(v) {
                a.push(v);
              })] : [2]) : [2];
            });
          });
        }, [2, Promise.all(e.selections.map(c)).then(function() {
          return hn(a);
        })];
      });
    });
  }, r.prototype.resolveField = function(e, t, n) {
    return ce(this, void 0, void 0, function() {
      var i, s, o, a, c, u, l, f, h, p = this;
      return le(this, function(d) {
        return i = n.variables, s = e.name.value, o = we(e), a = s !== o, c = t[o] || t[s], u = Promise.resolve(c), (!n.onlyRunForcedResolvers || this.shouldForceResolvers(e)) && (l = t.__typename || n.defaultOperationType, f = this.resolvers && this.resolvers[l], f && (h = f[a ? s : o], h && (u = Promise.resolve(Sn.withValue(this.cache, h, [
          t,
          Wt(e, i),
          n.context,
          { field: e, fragmentMap: n.fragmentMap }
        ]))))), [2, u.then(function(v) {
          if (v === void 0 && (v = c), e.directives && e.directives.forEach(function(g) {
            g.name.value === "export" && g.arguments && g.arguments.forEach(function(E) {
              E.name.value === "as" && E.value.kind === "StringValue" && (n.exportedVariables[E.value.value] = v);
            });
          }), !e.selectionSet || v == null)
            return v;
          if (Array.isArray(v))
            return p.resolveSubSelectedArray(e, v, n);
          if (e.selectionSet)
            return p.resolveSelectionSet(e.selectionSet, v, n);
        })];
      });
    });
  }, r.prototype.resolveSubSelectedArray = function(e, t, n) {
    var i = this;
    return Promise.all(t.map(function(s) {
      if (s === null)
        return null;
      if (Array.isArray(s))
        return i.resolveSubSelectedArray(e, s, n);
      if (e.selectionSet)
        return i.resolveSelectionSet(e.selectionSet, s, n);
    }));
  }, r;
}(), Me = new (Oe ? WeakMap : Map)();
function dr(r, e) {
  var t = r[e];
  typeof t == "function" && (r[e] = function() {
    return Me.set(r, (Me.get(r) + 1) % 1e15), t.apply(this, arguments);
  });
}
function Ni(r) {
  r.notifyTimeout && (clearTimeout(r.notifyTimeout), r.notifyTimeout = void 0);
}
var vr = function() {
  function r(e, t) {
    t === void 0 && (t = e.generateQueryId()), this.queryId = t, this.listeners = /* @__PURE__ */ new Set(), this.document = null, this.lastRequestId = 1, this.subscriptions = /* @__PURE__ */ new Set(), this.stopped = !1, this.dirty = !1, this.observableQuery = null;
    var n = this.cache = e.cache;
    Me.has(n) || (Me.set(n, 0), dr(n, "evict"), dr(n, "modify"), dr(n, "reset"));
  }
  return r.prototype.init = function(e) {
    var t = e.networkStatus || M.loading;
    return this.variables && this.networkStatus !== M.loading && !Q(this.variables, e.variables) && (t = M.setVariables), Q(e.variables, this.variables) || (this.lastDiff = void 0), Object.assign(this, {
      document: e.document,
      variables: e.variables,
      networkError: null,
      graphQLErrors: this.graphQLErrors || [],
      networkStatus: t
    }), e.observableQuery && this.setObservableQuery(e.observableQuery), e.lastRequestId && (this.lastRequestId = e.lastRequestId), this;
  }, r.prototype.reset = function() {
    Ni(this), this.dirty = !1;
  }, r.prototype.getDiff = function(e) {
    e === void 0 && (e = this.variables);
    var t = this.getDiffOptions(e);
    if (this.lastDiff && Q(t, this.lastDiff.options))
      return this.lastDiff.diff;
    this.updateWatch(this.variables = e);
    var n = this.observableQuery;
    if (n && n.options.fetchPolicy === "no-cache")
      return { complete: !1 };
    var i = this.cache.diff(t);
    return this.updateLastDiff(i, t), i;
  }, r.prototype.updateLastDiff = function(e, t) {
    this.lastDiff = e ? {
      diff: e,
      options: t || this.getDiffOptions()
    } : void 0;
  }, r.prototype.getDiffOptions = function(e) {
    var t;
    return e === void 0 && (e = this.variables), {
      query: this.document,
      variables: e,
      returnPartialData: !0,
      optimistic: !0,
      canonizeResults: (t = this.observableQuery) === null || t === void 0 ? void 0 : t.options.canonizeResults
    };
  }, r.prototype.setDiff = function(e) {
    var t = this, n = this.lastDiff && this.lastDiff.diff;
    this.updateLastDiff(e), !this.dirty && !Q(n && n.result, e && e.result) && (this.dirty = !0, this.notifyTimeout || (this.notifyTimeout = setTimeout(function() {
      return t.notify();
    }, 0)));
  }, r.prototype.setObservableQuery = function(e) {
    var t = this;
    e !== this.observableQuery && (this.oqListener && this.listeners.delete(this.oqListener), this.observableQuery = e, e ? (e.queryInfo = this, this.listeners.add(this.oqListener = function() {
      var n = t.getDiff();
      n.fromOptimisticTransaction ? e.observe() : Vs(e);
    })) : delete this.oqListener);
  }, r.prototype.notify = function() {
    var e = this;
    Ni(this), this.shouldNotify() && this.listeners.forEach(function(t) {
      return t(e);
    }), this.dirty = !1;
  }, r.prototype.shouldNotify = function() {
    if (!this.dirty || !this.listeners.size)
      return !1;
    if (ht(this.networkStatus) && this.observableQuery) {
      var e = this.observableQuery.options.fetchPolicy;
      if (e !== "cache-only" && e !== "cache-and-network")
        return !1;
    }
    return !0;
  }, r.prototype.stop = function() {
    if (!this.stopped) {
      this.stopped = !0, this.reset(), this.cancel(), this.cancel = r.prototype.cancel, this.subscriptions.forEach(function(t) {
        return t.unsubscribe();
      });
      var e = this.observableQuery;
      e && e.stopPolling();
    }
  }, r.prototype.cancel = function() {
  }, r.prototype.updateWatch = function(e) {
    var t = this;
    e === void 0 && (e = this.variables);
    var n = this.observableQuery;
    if (!(n && n.options.fetchPolicy === "no-cache")) {
      var i = y(y({}, this.getDiffOptions(e)), { watcher: this, callback: function(s) {
        return t.setDiff(s);
      } });
      (!this.lastWatch || !Q(i, this.lastWatch)) && (this.cancel(), this.cancel = this.cache.watch(this.lastWatch = i));
    }
  }, r.prototype.resetLastWrite = function() {
    this.lastWrite = void 0;
  }, r.prototype.shouldWrite = function(e, t) {
    var n = this.lastWrite;
    return !(n && n.dmCount === Me.get(this.cache) && Q(t, n.variables) && Q(e.data, n.result.data));
  }, r.prototype.markResult = function(e, t, n, i) {
    var s = this, o = ne(e.errors) ? e.errors.slice(0) : [];
    if (this.reset(), "incremental" in e && ne(e.incremental)) {
      var a = this.getDiff().result, c = new Se();
      e.incremental.forEach(function(u) {
        for (var l = u.data, f = u.path, h = u.errors, p = f.length - 1; p >= 0; --p) {
          var d = f[p], v = !isNaN(+d), g = v ? [] : {};
          g[d] = l, l = g;
        }
        h && o.push.apply(o, h), a = c.merge(a, l);
      }), e.data = a;
    }
    this.graphQLErrors = o, n.fetchPolicy === "no-cache" ? this.updateLastDiff({ result: e.data, complete: !0 }, this.getDiffOptions(n.variables)) : i !== 0 && (Wr(e, n.errorPolicy) ? this.cache.performTransaction(function(u) {
      if (s.shouldWrite(e, n.variables))
        u.writeQuery({
          query: t,
          data: e.data,
          variables: n.variables,
          overwrite: i === 1
        }), s.lastWrite = {
          result: e,
          variables: n.variables,
          dmCount: Me.get(s.cache)
        };
      else if (s.lastDiff && s.lastDiff.diff.complete) {
        e.data = s.lastDiff.diff.result;
        return;
      }
      var l = s.getDiffOptions(n.variables), f = u.diff(l);
      s.stopped || s.updateWatch(n.variables), s.updateLastDiff(f, l), f.complete && (e.data = f.result);
    }) : this.lastWrite = void 0);
  }, r.prototype.markReady = function() {
    return this.networkError = null, this.networkStatus = M.ready;
  }, r.prototype.markError = function(e) {
    return this.networkStatus = M.error, this.lastWrite = void 0, this.reset(), e.graphQLErrors && (this.graphQLErrors = e.graphQLErrors), e.networkError && (this.networkError = e.networkError), e;
  }, r;
}();
function Wr(r, e) {
  e === void 0 && (e = "none");
  var t = e === "ignore" || e === "all", n = !At(r);
  return !n && t && r.data && (n = !0), n;
}
var uc = Object.prototype.hasOwnProperty, cc = function() {
  function r(e) {
    var t = e.cache, n = e.link, i = e.defaultOptions, s = e.queryDeduplication, o = s === void 0 ? !1 : s, a = e.onBroadcast, c = e.ssrMode, u = c === void 0 ? !1 : c, l = e.clientAwareness, f = l === void 0 ? {} : l, h = e.localState, p = e.assumeImmutableResults;
    this.clientAwareness = {}, this.queries = /* @__PURE__ */ new Map(), this.fetchCancelFns = /* @__PURE__ */ new Map(), this.transformCache = new (Oe ? WeakMap : Map)(), this.queryIdCounter = 1, this.requestIdCounter = 1, this.mutationIdCounter = 1, this.inFlightLinkObservables = /* @__PURE__ */ new Map(), this.cache = t, this.link = n, this.defaultOptions = i || /* @__PURE__ */ Object.create(null), this.queryDeduplication = o, this.clientAwareness = f, this.localState = h || new $s({ cache: t }), this.ssrMode = u, this.assumeImmutableResults = !!p, (this.onBroadcast = a) && (this.mutationStore = /* @__PURE__ */ Object.create(null));
  }
  return r.prototype.stop = function() {
    var e = this;
    this.queries.forEach(function(t, n) {
      e.stopQueryNoBroadcast(n);
    }), this.cancelPendingFetches(__DEV__ ? new N("QueryManager stopped while query was in flight") : new N(13));
  }, r.prototype.cancelPendingFetches = function(e) {
    this.fetchCancelFns.forEach(function(t) {
      return t(e);
    }), this.fetchCancelFns.clear();
  }, r.prototype.mutate = function(e) {
    var t, n, i = e.mutation, s = e.variables, o = e.optimisticResponse, a = e.updateQueries, c = e.refetchQueries, u = c === void 0 ? [] : c, l = e.awaitRefetchQueries, f = l === void 0 ? !1 : l, h = e.update, p = e.onQueryUpdated, d = e.fetchPolicy, v = d === void 0 ? ((t = this.defaultOptions.mutate) === null || t === void 0 ? void 0 : t.fetchPolicy) || "network-only" : d, g = e.errorPolicy, E = g === void 0 ? ((n = this.defaultOptions.mutate) === null || n === void 0 ? void 0 : n.errorPolicy) || "none" : g, T = e.keepRootFields, b = e.context;
    return ce(this, void 0, void 0, function() {
      var S, x, k, D, I, F;
      return le(this, function(j) {
        switch (j.label) {
          case 0:
            return __DEV__ ? _(i, "mutation option is required. You must specify your GraphQL document in the mutation option.") : _(i, 14), __DEV__ ? _(v === "network-only" || v === "no-cache", "Mutations support only 'network-only' or 'no-cache' fetchPolicy strings. The default `network-only` behavior automatically writes mutation results to the cache. Passing `no-cache` skips the cache write.") : _(v === "network-only" || v === "no-cache", 15), S = this.generateMutationId(), x = this.transform(i), k = x.document, D = x.hasClientExports, i = this.cache.transformForLink(k), s = this.getVariables(i, s), D ? [4, this.localState.addExportedVariables(i, s, b)] : [3, 2];
          case 1:
            s = j.sent(), j.label = 2;
          case 2:
            return I = this.mutationStore && (this.mutationStore[S] = {
              mutation: i,
              variables: s,
              loading: !0,
              error: null
            }), o && this.markMutationOptimistic(o, {
              mutationId: S,
              document: i,
              variables: s,
              fetchPolicy: v,
              errorPolicy: E,
              context: b,
              updateQueries: a,
              update: h,
              keepRootFields: T
            }), this.broadcastQueries(), F = this, [2, new Promise(function(ye, Te) {
              return ir(F.getObservableFromLink(i, y(y({}, b), { optimisticResponse: o }), s, !1), function(W) {
                if (At(W) && E === "none")
                  throw new xe({
                    graphQLErrors: W.errors
                  });
                I && (I.loading = !1, I.error = null);
                var Ie = y({}, W);
                return typeof u == "function" && (u = u(Ie)), E === "ignore" && At(Ie) && delete Ie.errors, F.markMutationResult({
                  mutationId: S,
                  result: Ie,
                  document: i,
                  variables: s,
                  fetchPolicy: v,
                  errorPolicy: E,
                  context: b,
                  update: h,
                  updateQueries: a,
                  awaitRefetchQueries: f,
                  refetchQueries: u,
                  removeOptimistic: o ? S : void 0,
                  onQueryUpdated: p,
                  keepRootFields: T
                });
              }).subscribe({
                next: function(W) {
                  F.broadcastQueries(), ye(W);
                },
                error: function(W) {
                  I && (I.loading = !1, I.error = W), o && F.cache.removeOptimistic(S), F.broadcastQueries(), Te(W instanceof xe ? W : new xe({
                    networkError: W
                  }));
                }
              });
            })];
        }
      });
    });
  }, r.prototype.markMutationResult = function(e, t) {
    var n = this;
    t === void 0 && (t = this.cache);
    var i = e.result, s = [], o = e.fetchPolicy === "no-cache";
    if (!o && Wr(i, e.errorPolicy)) {
      s.push({
        result: i.data,
        dataId: "ROOT_MUTATION",
        query: e.document,
        variables: e.variables
      });
      var a = e.updateQueries;
      a && this.queries.forEach(function(u, l) {
        var f = u.observableQuery, h = f && f.queryName;
        if (!(!h || !uc.call(a, h))) {
          var p = a[h], d = n.queries.get(l), v = d.document, g = d.variables, E = t.diff({
            query: v,
            variables: g,
            returnPartialData: !0,
            optimistic: !1
          }), T = E.result, b = E.complete;
          if (b && T) {
            var S = p(T, {
              mutationResult: i,
              queryName: v && kr(v) || void 0,
              queryVariables: g
            });
            S && s.push({
              result: S,
              dataId: "ROOT_QUERY",
              query: v,
              variables: g
            });
          }
        }
      });
    }
    if (s.length > 0 || e.refetchQueries || e.update || e.onQueryUpdated || e.removeOptimistic) {
      var c = [];
      if (this.refetchQueries({
        updateCache: function(u) {
          o || s.forEach(function(h) {
            return u.write(h);
          });
          var l = e.update;
          if (l) {
            if (!o) {
              var f = u.diff({
                id: "ROOT_MUTATION",
                query: n.transform(e.document).asQuery,
                variables: e.variables,
                optimistic: !1,
                returnPartialData: !0
              });
              f.complete && !mu(i) && (i = y(y({}, i), { data: f.result }));
            }
            l(u, i, {
              context: e.context,
              variables: e.variables
            });
          }
          !o && !e.keepRootFields && u.modify({
            id: "ROOT_MUTATION",
            fields: function(h, p) {
              var d = p.fieldName, v = p.DELETE;
              return d === "__typename" ? h : v;
            }
          });
        },
        include: e.refetchQueries,
        optimistic: !1,
        removeOptimistic: e.removeOptimistic,
        onQueryUpdated: e.onQueryUpdated || null
      }).forEach(function(u) {
        return c.push(u);
      }), e.awaitRefetchQueries || e.onQueryUpdated)
        return Promise.all(c).then(function() {
          return i;
        });
    }
    return Promise.resolve(i);
  }, r.prototype.markMutationOptimistic = function(e, t) {
    var n = this, i = typeof e == "function" ? e(t.variables) : e;
    return this.cache.recordOptimisticTransaction(function(s) {
      try {
        n.markMutationResult(y(y({}, t), { result: { data: i } }), s);
      } catch (o) {
        __DEV__ && _.error(o);
      }
    }, t.mutationId);
  }, r.prototype.fetchQuery = function(e, t, n) {
    return this.fetchQueryObservable(e, t, n).promise;
  }, r.prototype.getQueryStore = function() {
    var e = /* @__PURE__ */ Object.create(null);
    return this.queries.forEach(function(t, n) {
      e[n] = {
        variables: t.variables,
        networkStatus: t.networkStatus,
        networkError: t.networkError,
        graphQLErrors: t.graphQLErrors
      };
    }), e;
  }, r.prototype.resetErrors = function(e) {
    var t = this.queries.get(e);
    t && (t.networkError = void 0, t.graphQLErrors = []);
  }, r.prototype.transform = function(e) {
    var t = this.transformCache;
    if (!t.has(e)) {
      var n = this.cache.transformDocument(e), i = da(n), s = this.localState.clientQuery(n), o = i && this.localState.serverQuery(i), a = {
        document: n,
        hasClientExports: Yo(n),
        hasForcedResolvers: this.localState.shouldForceResolvers(n),
        clientQuery: s,
        serverQuery: o,
        defaultVars: cn(gt(n)),
        asQuery: y(y({}, n), { definitions: n.definitions.map(function(u) {
          return u.kind === "OperationDefinition" && u.operation !== "query" ? y(y({}, u), { operation: "query" }) : u;
        }) })
      }, c = function(u) {
        u && !t.has(u) && t.set(u, a);
      };
      c(e), c(n), c(s), c(o);
    }
    return t.get(e);
  }, r.prototype.getVariables = function(e, t) {
    return y(y({}, this.transform(e).defaultVars), t);
  }, r.prototype.watchQuery = function(e) {
    e = y(y({}, e), { variables: this.getVariables(e.query, e.variables) }), typeof e.notifyOnNetworkStatusChange > "u" && (e.notifyOnNetworkStatusChange = !1);
    var t = new vr(this), n = new Hr({
      queryManager: this,
      queryInfo: t,
      options: e
    });
    return this.queries.set(n.queryId, t), t.init({
      document: n.query,
      observableQuery: n,
      variables: n.variables
    }), n;
  }, r.prototype.query = function(e, t) {
    var n = this;
    return t === void 0 && (t = this.generateQueryId()), __DEV__ ? _(e.query, "query option is required. You must specify your GraphQL document in the query option.") : _(e.query, 16), __DEV__ ? _(e.query.kind === "Document", 'You must wrap the query string in a "gql" tag.') : _(e.query.kind === "Document", 17), __DEV__ ? _(!e.returnPartialData, "returnPartialData option only supported on watchQuery.") : _(!e.returnPartialData, 18), __DEV__ ? _(!e.pollInterval, "pollInterval option only supported on watchQuery.") : _(!e.pollInterval, 19), this.fetchQuery(t, e).finally(function() {
      return n.stopQuery(t);
    });
  }, r.prototype.generateQueryId = function() {
    return String(this.queryIdCounter++);
  }, r.prototype.generateRequestId = function() {
    return this.requestIdCounter++;
  }, r.prototype.generateMutationId = function() {
    return String(this.mutationIdCounter++);
  }, r.prototype.stopQueryInStore = function(e) {
    this.stopQueryInStoreNoBroadcast(e), this.broadcastQueries();
  }, r.prototype.stopQueryInStoreNoBroadcast = function(e) {
    var t = this.queries.get(e);
    t && t.stop();
  }, r.prototype.clearStore = function(e) {
    return e === void 0 && (e = {
      discardWatches: !0
    }), this.cancelPendingFetches(__DEV__ ? new N("Store reset while query was in flight (not completed in link chain)") : new N(20)), this.queries.forEach(function(t) {
      t.observableQuery ? t.networkStatus = M.loading : t.stop();
    }), this.mutationStore && (this.mutationStore = /* @__PURE__ */ Object.create(null)), this.cache.reset(e);
  }, r.prototype.getObservableQueries = function(e) {
    var t = this;
    e === void 0 && (e = "active");
    var n = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Set();
    return Array.isArray(e) && e.forEach(function(o) {
      typeof o == "string" ? i.set(o, !1) : Ko(o) ? i.set(t.transform(o).document, !1) : P(o) && o.query && s.add(o);
    }), this.queries.forEach(function(o, a) {
      var c = o.observableQuery, u = o.document;
      if (c) {
        if (e === "all") {
          n.set(a, c);
          return;
        }
        var l = c.queryName, f = c.options.fetchPolicy;
        if (f === "standby" || e === "active" && !c.hasObservers())
          return;
        (e === "active" || l && i.has(l) || u && i.has(u)) && (n.set(a, c), l && i.set(l, !0), u && i.set(u, !0));
      }
    }), s.size && s.forEach(function(o) {
      var a = Rr("legacyOneTimeQuery"), c = t.getQuery(a).init({
        document: o.query,
        variables: o.variables
      }), u = new Hr({
        queryManager: t,
        queryInfo: c,
        options: y(y({}, o), { fetchPolicy: "network-only" })
      });
      _(u.queryId === a), c.setObservableQuery(u), n.set(a, u);
    }), __DEV__ && i.size && i.forEach(function(o, a) {
      o || __DEV__ && _.warn("Unknown query ".concat(typeof a == "string" ? "named " : "").concat(JSON.stringify(a, null, 2), " requested in refetchQueries options.include array"));
    }), n;
  }, r.prototype.reFetchObservableQueries = function(e) {
    var t = this;
    e === void 0 && (e = !1);
    var n = [];
    return this.getObservableQueries(e ? "all" : "active").forEach(function(i, s) {
      var o = i.options.fetchPolicy;
      i.resetLastResults(), (e || o !== "standby" && o !== "cache-only") && n.push(i.refetch()), t.getQuery(s).setDiff(null);
    }), this.broadcastQueries(), Promise.all(n);
  }, r.prototype.setObservableQuery = function(e) {
    this.getQuery(e.queryId).setObservableQuery(e);
  }, r.prototype.startGraphQLSubscription = function(e) {
    var t = this, n = e.query, i = e.fetchPolicy, s = e.errorPolicy, o = e.variables, a = e.context, c = a === void 0 ? {} : a;
    n = this.transform(n).document, o = this.getVariables(n, o);
    var u = function(f) {
      return t.getObservableFromLink(n, c, f).map(function(h) {
        if (i !== "no-cache" && (Wr(h, s) && t.cache.write({
          query: n,
          result: h.data,
          dataId: "ROOT_SUBSCRIPTION",
          variables: f
        }), t.broadcastQueries()), At(h))
          throw new xe({
            graphQLErrors: h.errors
          });
        return h;
      });
    };
    if (this.transform(n).hasClientExports) {
      var l = this.localState.addExportedVariables(n, o, c).then(u);
      return new R(function(f) {
        var h = null;
        return l.then(function(p) {
          return h = p.subscribe(f);
        }, f.error), function() {
          return h && h.unsubscribe();
        };
      });
    }
    return u(o);
  }, r.prototype.stopQuery = function(e) {
    this.stopQueryNoBroadcast(e), this.broadcastQueries();
  }, r.prototype.stopQueryNoBroadcast = function(e) {
    this.stopQueryInStoreNoBroadcast(e), this.removeQuery(e);
  }, r.prototype.removeQuery = function(e) {
    this.fetchCancelFns.delete(e), this.queries.has(e) && (this.getQuery(e).stop(), this.queries.delete(e));
  }, r.prototype.broadcastQueries = function() {
    this.onBroadcast && this.onBroadcast(), this.queries.forEach(function(e) {
      return e.notify();
    });
  }, r.prototype.getLocalState = function() {
    return this.localState;
  }, r.prototype.getObservableFromLink = function(e, t, n, i) {
    var s = this, o;
    i === void 0 && (i = (o = t == null ? void 0 : t.queryDeduplication) !== null && o !== void 0 ? o : this.queryDeduplication);
    var a, c = this.transform(e).serverQuery;
    if (c) {
      var u = this, l = u.inFlightLinkObservables, f = u.link, h = {
        query: c,
        variables: n,
        operationName: kr(c) || void 0,
        context: this.prepareContext(y(y({}, t), { forceFetch: !i }))
      };
      if (t = h.context, i) {
        var p = l.get(c) || /* @__PURE__ */ new Map();
        l.set(c, p);
        var d = Ee(n);
        if (a = p.get(d), !a) {
          var v = new rt([
            Fr(f, h)
          ]);
          p.set(d, a = v), v.beforeNext(function() {
            p.delete(d) && p.size < 1 && l.delete(c);
          });
        }
      } else
        a = new rt([
          Fr(f, h)
        ]);
    } else
      a = new rt([
        R.of({ data: {} })
      ]), t = this.prepareContext(t);
    var g = this.transform(e).clientQuery;
    return g && (a = ir(a, function(E) {
      return s.localState.runResolvers({
        document: g,
        remoteResult: E,
        context: t,
        variables: n
      });
    })), a;
  }, r.prototype.getResultsFromLink = function(e, t, n) {
    var i = e.lastRequestId = this.generateRequestId();
    n = mn(n);
    var s = this.cache.transformForLink(this.transform(e.document).document);
    return ir(this.getObservableFromLink(s, n.context, n.variables), function(o) {
      var a = ne(o.errors) ? o.errors.slice(0) : [];
      "incremental" in o && ne(o.incremental) && o.incremental.forEach(function(l) {
        l.errors && a.push.apply(a, l.errors);
      });
      var c = ne(a);
      if (i >= e.lastRequestId) {
        if (c && n.errorPolicy === "none")
          throw e.markError(new xe({
            graphQLErrors: a
          }));
        e.markResult(o, s, n, t), e.markReady();
      }
      var u = {
        data: o.data,
        loading: !1,
        networkStatus: M.ready
      };
      return c && n.errorPolicy !== "ignore" && (u.errors = a, u.networkStatus = M.error), u;
    }, function(o) {
      var a = nc(o) ? o : new xe({ networkError: o });
      throw i >= e.lastRequestId && e.markError(a), a;
    });
  }, r.prototype.fetchQueryObservable = function(e, t, n) {
    var i = this;
    n === void 0 && (n = M.loading);
    var s = this.transform(t.query).document, o = this.getVariables(s, t.variables), a = this.getQuery(e), c = this.defaultOptions.watchQuery, u = t.fetchPolicy, l = u === void 0 ? c && c.fetchPolicy || "cache-first" : u, f = t.errorPolicy, h = f === void 0 ? c && c.errorPolicy || "none" : f, p = t.returnPartialData, d = p === void 0 ? !1 : p, v = t.notifyOnNetworkStatusChange, g = v === void 0 ? !1 : v, E = t.context, T = E === void 0 ? {} : E, b = Object.assign({}, t, {
      query: s,
      variables: o,
      fetchPolicy: l,
      errorPolicy: h,
      returnPartialData: d,
      notifyOnNetworkStatusChange: g,
      context: T
    }), S = function(D) {
      b.variables = D;
      var I = i.fetchQueryByPolicy(a, b, n);
      return b.fetchPolicy !== "standby" && I.length > 0 && a.observableQuery && a.observableQuery.applyNextFetchPolicy("after-fetch", t), I;
    }, x = function() {
      return i.fetchCancelFns.delete(e);
    };
    this.fetchCancelFns.set(e, function(D) {
      x(), setTimeout(function() {
        return k.cancel(D);
      });
    });
    var k = new rt(this.transform(b.query).hasClientExports ? this.localState.addExportedVariables(b.query, b.variables, b.context).then(S) : S(b.variables));
    return k.promise.then(x, x), k;
  }, r.prototype.refetchQueries = function(e) {
    var t = this, n = e.updateCache, i = e.include, s = e.optimistic, o = s === void 0 ? !1 : s, a = e.removeOptimistic, c = a === void 0 ? o ? Rr("refetchQueries") : void 0 : a, u = e.onQueryUpdated, l = /* @__PURE__ */ new Map();
    i && this.getObservableQueries(i).forEach(function(h, p) {
      l.set(p, {
        oq: h,
        lastDiff: t.getQuery(p).getDiff()
      });
    });
    var f = /* @__PURE__ */ new Map();
    return n && this.cache.batch({
      update: n,
      optimistic: o && c || !1,
      removeOptimistic: c,
      onWatchUpdated: function(h, p, d) {
        var v = h.watcher instanceof vr && h.watcher.observableQuery;
        if (v) {
          if (u) {
            l.delete(v.queryId);
            var g = u(v, p, d);
            return g === !0 && (g = v.refetch()), g !== !1 && f.set(v, g), g;
          }
          u !== null && l.set(v.queryId, { oq: v, lastDiff: d, diff: p });
        }
      }
    }), l.size && l.forEach(function(h, p) {
      var d = h.oq, v = h.lastDiff, g = h.diff, E;
      if (u) {
        if (!g) {
          var T = d.queryInfo;
          T.reset(), g = T.getDiff();
        }
        E = u(d, g, v);
      }
      (!u || E === !0) && (E = d.refetch()), E !== !1 && f.set(d, E), p.indexOf("legacyOneTimeQuery") >= 0 && t.stopQueryNoBroadcast(p);
    }), c && this.cache.removeOptimistic(c), f;
  }, r.prototype.fetchQueryByPolicy = function(e, t, n) {
    var i = this, s = t.query, o = t.variables, a = t.fetchPolicy, c = t.refetchWritePolicy, u = t.errorPolicy, l = t.returnPartialData, f = t.context, h = t.notifyOnNetworkStatusChange, p = e.networkStatus;
    e.init({
      document: this.transform(s).document,
      variables: o,
      networkStatus: n
    });
    var d = function() {
      return e.getDiff(o);
    }, v = function(S, x) {
      x === void 0 && (x = e.networkStatus || M.loading);
      var k = S.result;
      __DEV__ && !l && !Q(k, {}) && Qs(S.missing);
      var D = function(I) {
        return R.of(y({ data: I, loading: ht(x), networkStatus: x }, S.complete ? null : { partial: !0 }));
      };
      return k && i.transform(s).hasForcedResolvers ? i.localState.runResolvers({
        document: s,
        remoteResult: { data: k },
        context: f,
        variables: o,
        onlyRunForcedResolvers: !0
      }).then(function(I) {
        return D(I.data || void 0);
      }) : D(k);
    }, g = a === "no-cache" ? 0 : n === M.refetch && c !== "merge" ? 1 : 2, E = function() {
      return i.getResultsFromLink(e, g, {
        variables: o,
        context: f,
        fetchPolicy: a,
        errorPolicy: u
      });
    }, T = h && typeof p == "number" && p !== n && ht(n);
    switch (a) {
      default:
      case "cache-first": {
        var b = d();
        return b.complete ? [
          v(b, e.markReady())
        ] : l || T ? [
          v(b),
          E()
        ] : [
          E()
        ];
      }
      case "cache-and-network": {
        var b = d();
        return b.complete || l || T ? [
          v(b),
          E()
        ] : [
          E()
        ];
      }
      case "cache-only":
        return [
          v(d(), e.markReady())
        ];
      case "network-only":
        return T ? [
          v(d()),
          E()
        ] : [E()];
      case "no-cache":
        return T ? [
          v(e.getDiff()),
          E()
        ] : [E()];
      case "standby":
        return [];
    }
  }, r.prototype.getQuery = function(e) {
    return e && !this.queries.has(e) && this.queries.set(e, new vr(this, e)), this.queries.get(e);
  }, r.prototype.prepareContext = function(e) {
    e === void 0 && (e = {});
    var t = this.localState.prepareContext(e);
    return y(y({}, t), { clientAwareness: this.clientAwareness });
  }, r;
}(), Ci = !1, lc = function() {
  function r(e) {
    var t = this;
    this.resetStoreCallbacks = [], this.clearStoreCallbacks = [];
    var n = e.uri, i = e.credentials, s = e.headers, o = e.cache, a = e.ssrMode, c = a === void 0 ? !1 : a, u = e.ssrForceFetchDelay, l = u === void 0 ? 0 : u, f = e.connectToDevTools, h = f === void 0 ? typeof window == "object" && !window.__APOLLO_CLIENT__ && __DEV__ : f, p = e.queryDeduplication, d = p === void 0 ? !0 : p, v = e.defaultOptions, g = e.assumeImmutableResults, E = g === void 0 ? !1 : g, T = e.resolvers, b = e.typeDefs, S = e.fragmentMatcher, x = e.name, k = e.version, D = e.link;
    if (D || (D = n ? new ds({ uri: n, credentials: i, headers: s }) : De.empty()), !o)
      throw __DEV__ ? new N(`To initialize Apollo Client, you must specify a 'cache' property in the options object. 
For more information, please visit: https://go.apollo.dev/c/docs`) : new N(9);
    if (this.link = D, this.cache = o, this.disableNetworkFetches = c || l > 0, this.queryDeduplication = d, this.defaultOptions = v || /* @__PURE__ */ Object.create(null), this.typeDefs = b, l && setTimeout(function() {
      return t.disableNetworkFetches = !1;
    }, l), this.watchQuery = this.watchQuery.bind(this), this.query = this.query.bind(this), this.mutate = this.mutate.bind(this), this.resetStore = this.resetStore.bind(this), this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this), h && typeof window == "object" && (window.__APOLLO_CLIENT__ = this), !Ci && __DEV__ && (Ci = !0, typeof window < "u" && window.document && window.top === window.self && !window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__)) {
      var I = window.navigator, F = I && I.userAgent, j = void 0;
      typeof F == "string" && (F.indexOf("Chrome/") > -1 ? j = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm" : F.indexOf("Firefox/") > -1 && (j = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/")), j && __DEV__ && _.log("Download the Apollo DevTools for a better development experience: " + j);
    }
    this.version = Qa, this.localState = new $s({
      cache: o,
      client: this,
      resolvers: T,
      fragmentMatcher: S
    }), this.queryManager = new cc({
      cache: this.cache,
      link: this.link,
      defaultOptions: this.defaultOptions,
      queryDeduplication: d,
      ssrMode: c,
      clientAwareness: {
        name: x,
        version: k
      },
      localState: this.localState,
      assumeImmutableResults: E,
      onBroadcast: h ? function() {
        t.devToolsHookCb && t.devToolsHookCb({
          action: {},
          state: {
            queries: t.queryManager.getQueryStore(),
            mutations: t.queryManager.mutationStore || {}
          },
          dataWithOptimisticResults: t.cache.extract(!0)
        });
      } : void 0
    });
  }
  return r.prototype.stop = function() {
    this.queryManager.stop();
  }, r.prototype.watchQuery = function(e) {
    return this.defaultOptions.watchQuery && (e = sr(this.defaultOptions.watchQuery, e)), this.disableNetworkFetches && (e.fetchPolicy === "network-only" || e.fetchPolicy === "cache-and-network") && (e = y(y({}, e), { fetchPolicy: "cache-first" })), this.queryManager.watchQuery(e);
  }, r.prototype.query = function(e) {
    return this.defaultOptions.query && (e = sr(this.defaultOptions.query, e)), __DEV__ ? _(e.fetchPolicy !== "cache-and-network", "The cache-and-network fetchPolicy does not work with client.query, because client.query can only return a single result. Please use client.watchQuery to receive multiple results from the cache and the network, or consider using a different fetchPolicy, such as cache-first or network-only.") : _(e.fetchPolicy !== "cache-and-network", 10), this.disableNetworkFetches && e.fetchPolicy === "network-only" && (e = y(y({}, e), { fetchPolicy: "cache-first" })), this.queryManager.query(e);
  }, r.prototype.mutate = function(e) {
    return this.defaultOptions.mutate && (e = sr(this.defaultOptions.mutate, e)), this.queryManager.mutate(e);
  }, r.prototype.subscribe = function(e) {
    return this.queryManager.startGraphQLSubscription(e);
  }, r.prototype.readQuery = function(e, t) {
    return t === void 0 && (t = !1), this.cache.readQuery(e, t);
  }, r.prototype.readFragment = function(e, t) {
    return t === void 0 && (t = !1), this.cache.readFragment(e, t);
  }, r.prototype.writeQuery = function(e) {
    this.cache.writeQuery(e), this.queryManager.broadcastQueries();
  }, r.prototype.writeFragment = function(e) {
    this.cache.writeFragment(e), this.queryManager.broadcastQueries();
  }, r.prototype.__actionHookForDevTools = function(e) {
    this.devToolsHookCb = e;
  }, r.prototype.__requestRaw = function(e) {
    return Fr(this.link, e);
  }, r.prototype.resetStore = function() {
    var e = this;
    return Promise.resolve().then(function() {
      return e.queryManager.clearStore({
        discardWatches: !1
      });
    }).then(function() {
      return Promise.all(e.resetStoreCallbacks.map(function(t) {
        return t();
      }));
    }).then(function() {
      return e.reFetchObservableQueries();
    });
  }, r.prototype.clearStore = function() {
    var e = this;
    return Promise.resolve().then(function() {
      return e.queryManager.clearStore({
        discardWatches: !0
      });
    }).then(function() {
      return Promise.all(e.clearStoreCallbacks.map(function(t) {
        return t();
      }));
    });
  }, r.prototype.onResetStore = function(e) {
    var t = this;
    return this.resetStoreCallbacks.push(e), function() {
      t.resetStoreCallbacks = t.resetStoreCallbacks.filter(function(n) {
        return n !== e;
      });
    };
  }, r.prototype.onClearStore = function(e) {
    var t = this;
    return this.clearStoreCallbacks.push(e), function() {
      t.clearStoreCallbacks = t.clearStoreCallbacks.filter(function(n) {
        return n !== e;
      });
    };
  }, r.prototype.reFetchObservableQueries = function(e) {
    return this.queryManager.reFetchObservableQueries(e);
  }, r.prototype.refetchQueries = function(e) {
    var t = this.queryManager.refetchQueries(e), n = [], i = [];
    t.forEach(function(o, a) {
      n.push(a), i.push(o);
    });
    var s = Promise.all(i);
    return s.queries = n, s.results = i, s.catch(function(o) {
      __DEV__ && _.debug("In client.refetchQueries, Promise.all promise rejected with error ".concat(o));
    }), s;
  }, r.prototype.getObservableQueries = function(e) {
    return e === void 0 && (e = "active"), this.queryManager.getObservableQueries(e);
  }, r.prototype.extract = function(e) {
    return this.cache.extract(e);
  }, r.prototype.restore = function(e) {
    return this.cache.restore(e);
  }, r.prototype.addResolvers = function(e) {
    this.localState.addResolvers(e);
  }, r.prototype.setResolvers = function(e) {
    this.localState.setResolvers(e);
  }, r.prototype.getResolvers = function() {
    return this.localState.getResolvers();
  }, r.prototype.setLocalStateFragmentMatcher = function(e) {
    this.localState.setFragmentMatcher(e);
  }, r.prototype.setLink = function(e) {
    this.link = this.queryManager.link = e;
  }, r;
}(), Ct = /* @__PURE__ */ new Map(), Gr = /* @__PURE__ */ new Map(), qs = !0, Vt = !1;
function Us(r) {
  return r.replace(/[\s,]+/g, " ").trim();
}
function fc(r) {
  return Us(r.source.body.substring(r.start, r.end));
}
function hc(r) {
  var e = /* @__PURE__ */ new Set(), t = [];
  return r.definitions.forEach(function(n) {
    if (n.kind === "FragmentDefinition") {
      var i = n.name.value, s = fc(n.loc), o = Gr.get(i);
      o && !o.has(s) ? qs && console.warn("Warning: fragment with name " + i + ` already exists.
graphql-tag enforces all fragment names across your application to be unique; read more about
this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names`) : o || Gr.set(i, o = /* @__PURE__ */ new Set()), o.add(s), e.has(s) || (e.add(s), t.push(n));
    } else
      t.push(n);
  }), y(y({}, r), { definitions: t });
}
function pc(r) {
  var e = new Set(r.definitions);
  e.forEach(function(n) {
    n.loc && delete n.loc, Object.keys(n).forEach(function(i) {
      var s = n[i];
      s && typeof s == "object" && e.add(s);
    });
  });
  var t = r.loc;
  return t && (delete t.startToken, delete t.endToken), r;
}
function dc(r) {
  var e = Us(r);
  if (!Ct.has(e)) {
    var t = Lo(r, {
      experimentalFragmentVariables: Vt,
      allowLegacyFragmentVariables: Vt
    });
    if (!t || t.kind !== "Document")
      throw new Error("Not a valid GraphQL document.");
    Ct.set(e, pc(hc(t)));
  }
  return Ct.get(e);
}
function Ue(r) {
  for (var e = [], t = 1; t < arguments.length; t++)
    e[t - 1] = arguments[t];
  typeof r == "string" && (r = [r]);
  var n = r[0];
  return e.forEach(function(i, s) {
    i && i.kind === "Document" ? n += i.loc.source.body : n += i, n += r[s + 1];
  }), dc(n);
}
function vc() {
  Ct.clear(), Gr.clear();
}
function yc() {
  qs = !1;
}
function mc() {
  Vt = !0;
}
function gc() {
  Vt = !1;
}
var Ke = {
  gql: Ue,
  resetCaches: vc,
  disableFragmentWarnings: yc,
  enableExperimentalFragmentVariables: mc,
  disableExperimentalFragmentVariables: gc
};
(function(r) {
  r.gql = Ke.gql, r.resetCaches = Ke.resetCaches, r.disableFragmentWarnings = Ke.disableFragmentWarnings, r.enableExperimentalFragmentVariables = Ke.enableExperimentalFragmentVariables, r.disableExperimentalFragmentVariables = Ke.disableExperimentalFragmentVariables;
})(Ue || (Ue = {}));
Ue.default = Ue;
var be, yt;
class X extends ut {
  constructor(t, n, i) {
    super(t, i);
    re(this, be, void 0);
    re(this, yt, void 0);
    this.networkStatus = M.ready, this.partial = !1, H(this, be, !1), this.init(n != null ? n : null);
  }
  get query() {
    return this.document;
  }
  set query(t) {
    this.document = t;
  }
  get canAutoSubscribe() {
    return !!this.client && !!this.document && !this.options.noAutoSubscribe && this.shouldSubscribe();
  }
  hostConnected() {
    super.hostConnected(), te(this, be) && this.observableQuery ? (this.observableQuery.reobserve(), H(this, be, !1)) : this.documentChanged(this.query);
  }
  hostDisconnected() {
    H(this, be, !0), super.hostDisconnected();
  }
  shouldSubscribe(t) {
    var n, i, s;
    return (s = (i = (n = this.options).shouldSubscribe) == null ? void 0 : i.call(n, t)) != null ? s : !0;
  }
  canSubscribe(t) {
    var n, i;
    return !((n = this.options.noAutoSubscribe) != null && n) && !!this.client && !!((i = t == null ? void 0 : t.query) != null ? i : this.document);
  }
  watchQuery(t) {
    var n;
    if (!this.client)
      throw new TypeError("No Apollo client. See https://apolloelements.dev/guides/getting-started/apollo-client/");
    return this.client.watchQuery({
      query: this.query,
      variables: (n = this.variables) != null ? n : void 0,
      context: this.options.context,
      errorPolicy: this.options.errorPolicy,
      fetchPolicy: this.options.fetchPolicy,
      notifyOnNetworkStatusChange: this.options.notifyOnNetworkStatusChange,
      partialRefetch: this.options.partialRefetch,
      pollInterval: this.options.pollInterval,
      returnPartialData: this.options.returnPartialData,
      nextFetchPolicy: this.options.nextFetchPolicy,
      ...t
    });
  }
  nextData(t) {
    var u, l, f, h, p, d;
    this.emitter.dispatchEvent(new CustomEvent("apollo-query-result", {
      detail: t
    }));
    const {
      data: n,
      error: i,
      errors: s,
      loading: o,
      networkStatus: a,
      partial: c
    } = this;
    this.data = t.data, this.error = (u = t.error) != null ? u : null, this.errors = (l = t.errors) != null ? l : [], this.loading = (f = t.loading) != null ? f : !1, this.networkStatus = t.networkStatus, this.partial = (h = t.partial) != null ? h : !1, (d = (p = this.options).onData) == null || d.call(p, t.data), this.notify({
      data: n,
      error: i,
      errors: s,
      loading: o,
      networkStatus: a,
      partial: c
    });
  }
  nextError(t) {
    var s, o;
    const {
      error: n,
      loading: i
    } = this;
    this.emitter.dispatchEvent(new CustomEvent("apollo-error", {
      detail: t
    })), this.error = t, this.loading = !1, (o = (s = this.options).onError) == null || o.call(s, t), this.notify({
      error: n,
      loading: i
    });
  }
  clientChanged() {
    this.canSubscribe() && this.shouldSubscribe() && this.subscribe();
  }
  documentChanged(t) {
    const n = t != null ? t : void 0;
    t !== te(this, yt) && this.canSubscribe({
      query: n
    }) && this.shouldSubscribe({
      query: n
    }) && this.subscribe({
      query: n
    });
  }
  variablesChanged(t) {
    this.observableQuery ? this.refetch(t) : this.canSubscribe({
      variables: t
    }) && this.shouldSubscribe({
      variables: t
    }) && this.subscribe({
      variables: t
    });
  }
  optionsChanged(t) {
    var n, i;
    (i = (n = this.observableQuery) == null ? void 0 : n.setOptions) == null || i.call(n, t);
  }
  async refetch(t) {
    if (!this.observableQuery)
      throw new Error("Cannot refetch without an ObservableQuery");
    return this.observableQuery.refetch(t);
  }
  subscribe(t) {
    var i, s, o, a;
    this.observableQuery && this.observableQuery.stopPolling(), this.observableQuery = this.watchQuery({
      query: this.query,
      variables: (i = this.variables) != null ? i : void 0,
      context: this.options.context,
      errorPolicy: this.options.errorPolicy,
      fetchPolicy: this.options.fetchPolicy,
      notifyOnNetworkStatusChange: this.options.notifyOnNetworkStatusChange,
      partialRefetch: this.options.partialRefetch,
      pollInterval: this.options.pollInterval,
      refetchWritePolicy: this.options.refetchWritePolicy,
      returnPartialData: this.options.returnPartialData,
      ...t
    }), H(this, yt, (o = (s = t == null ? void 0 : t.query) != null ? s : this.query) != null ? o : void 0);
    const {
      loading: n
    } = this;
    return this.loading = !0, this.notify({
      loading: n
    }), (a = this.observableQuery) == null ? void 0 : a.subscribe({
      next: this.nextData.bind(this),
      error: this.nextError.bind(this)
    });
  }
  subscribeToMore(t) {
    var n;
    return (n = this.observableQuery) == null ? void 0 : n.subscribeToMore(t);
  }
  async executeQuery(t) {
    try {
      if (!this.client)
        throw new TypeError("No Apollo client. See https://apolloelements.dev/guides/getting-started/apollo-client/");
      const {
        loading: n
      } = this;
      this.loading = !0, this.notify({
        loading: n
      });
      const i = await this.client.query({
        query: this.query,
        variables: this.variables,
        context: this.options.context,
        errorPolicy: this.options.errorPolicy,
        fetchPolicy: this.options.fetchPolicy === "cache-and-network" ? void 0 : this.options.fetchPolicy,
        notifyOnNetworkStatusChange: this.options.notifyOnNetworkStatusChange,
        partialRefetch: this.options.partialRefetch,
        returnPartialData: this.options.returnPartialData,
        ...t
      });
      return i && this.nextData(i), i;
    } catch (n) {
      throw this.nextError(n), n;
    }
  }
  async fetchMore(t) {
    var s, o, a;
    const {
      loading: n
    } = this;
    this.loading = !0, this.notify({
      loading: n
    });
    const i = {
      query: this.query,
      context: this.options.context,
      variables: (s = this.variables) != null ? s : void 0,
      ...t
    };
    return (o = i.variables) != null || (i.variables = void 0), (a = this.observableQuery) != null || (this.observableQuery = this.watchQuery(i)), this.observableQuery.fetchMore(i).then((c) => {
      const {
        loading: u
      } = this;
      return this.loading = !1, this.notify({
        loading: u
      }), c;
    });
  }
  startPolling(t) {
    this.pollingInterval = window.setInterval(() => {
      this.refetch();
    }, t);
  }
  stopPolling() {
    clearInterval(this.pollingInterval);
  }
}
be = new WeakMap(), yt = new WeakMap();
J([ee], X.prototype, "watchQuery", null);
J([ee], X.prototype, "refetch", null);
J([ee], X.prototype, "subscribe", null);
J([ee], X.prototype, "subscribeToMore", null);
J([ee], X.prototype, "executeQuery", null);
J([ee], X.prototype, "fetchMore", null);
J([ee], X.prototype, "startPolling", null);
J([ee], X.prototype, "stopPolling", null);
var je, mt;
class zs extends ut {
  constructor(t, n, i) {
    super(t, i);
    re(this, je, void 0);
    re(this, mt, void 0);
    H(this, je, !1), this.init(n != null ? n : null);
  }
  get subscription() {
    return this.document;
  }
  set subscription(t) {
    this.document = t;
  }
  get canAutoSubscribe() {
    return !!this.client && !this.options.noAutoSubscribe && this.shouldSubscribe();
  }
  hostConnected() {
    super.hostConnected(), te(this, je) && this.observableSubscription ? this.subscribe() : this.documentChanged(this.subscription);
  }
  hostDisconnected() {
    this.endSubscription(), H(this, je, !0), super.hostDisconnected();
  }
  canSubscribe(t) {
    var n;
    return !this.options.noAutoSubscribe && !!this.client && (!this.observable || !!this.options.shouldResubscribe) && !!((n = t == null ? void 0 : t.query) != null ? n : this.subscription);
  }
  initObservable(t) {
    var c;
    const {
      shouldResubscribe: n = this.options.shouldResubscribe,
      client: i = this.client,
      skip: s = this.options.skip,
      ...o
    } = t != null ? t : {};
    if (!i)
      throw new TypeError("No Apollo client. See https://apolloelements.dev/guides/getting-started/apollo-client/");
    if (this.observable && !n || s)
      return;
    const a = (c = t == null ? void 0 : t.subscription) != null ? c : this.subscription;
    H(this, mt, a), this.observable = i.subscribe({
      variables: this.variables,
      context: this.options.context,
      errorPolicy: this.options.errorPolicy,
      fetchPolicy: this.options.fetchPolicy,
      ...o,
      query: a
    });
  }
  nextData(t) {
    var l, f, h, p, d;
    const {
      data: n,
      error: i,
      errors: s,
      loading: o
    } = this, a = this.client, c = {
      data: (l = t == null ? void 0 : t.data) != null ? l : null,
      loading: !1,
      error: null
    }, u = {
      client: a,
      subscriptionData: c
    };
    this.emitter.dispatchEvent(new CustomEvent("apollo-subscription-result", {
      detail: u
    })), this.data = (f = t == null ? void 0 : t.data) != null ? f : null, this.error = null, this.errors = (h = t == null ? void 0 : t.errors) != null ? h : [], this.loading = !1, (d = (p = this.options).onData) == null || d.call(p, u), this.notify({
      data: n,
      error: i,
      errors: s,
      loading: o
    });
  }
  nextError(t) {
    var s, o;
    const {
      error: n,
      loading: i
    } = this;
    this.emitter.dispatchEvent(new CustomEvent("apollo-error", {
      detail: t
    })), this.error = t, this.loading = !1, (o = (s = this.options).onError) == null || o.call(s, t), this.notify({
      error: n,
      loading: i
    });
  }
  onComplete() {
    var s, o;
    const {
      data: t,
      error: n,
      loading: i
    } = this;
    (o = (s = this.options).onComplete) == null || o.call(s), this.endSubscription(), this.notify({
      data: t,
      error: n,
      loading: i
    });
  }
  endSubscription() {
    this.observableSubscription && this.observableSubscription.unsubscribe();
  }
  shouldSubscribe(t) {
    var n, i, s;
    return (s = (i = (n = this.options).shouldSubscribe) == null ? void 0 : i.call(n, t)) != null ? s : !0;
  }
  clientChanged() {
    this.canSubscribe() && this.shouldSubscribe() && this.subscribe();
  }
  documentChanged(t) {
    const n = t != null ? t : void 0;
    t !== te(this, mt) && (this.cancel(), this.canSubscribe({
      query: n
    }) && this.shouldSubscribe({
      query: n
    }) && this.subscribe());
  }
  variablesChanged(t) {
    this.cancel(), this.canSubscribe({
      variables: t
    }) && this.shouldSubscribe({
      variables: t
    }) && this.subscribe();
  }
  subscribe(t) {
    var s, o;
    this.initObservable(t);
    const n = (s = t == null ? void 0 : t.shouldResubscribe) != null ? s : this.options.shouldResubscribe;
    if (this.observableSubscription && !n)
      return;
    const {
      loading: i
    } = this;
    this.loading = !0, this.notify({
      loading: i
    }), this.observableSubscription = (o = this.observable) == null ? void 0 : o.subscribe({
      next: this.nextData.bind(this),
      error: this.nextError.bind(this),
      complete: this.onComplete.bind(this)
    });
  }
  cancel() {
    this.endSubscription(), this.observableSubscription = void 0, this.observable = void 0;
  }
}
je = new WeakMap(), mt = new WeakMap();
J([ee], zs.prototype, "subscribe", null);
J([ee], zs.prototype, "cancel", null);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Mt = window, In = Mt.ShadowRoot && (Mt.ShadyCSS === void 0 || Mt.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, xn = Symbol(), Mi = /* @__PURE__ */ new WeakMap();
class Bs {
  constructor(e, t, n) {
    if (this._$cssResult$ = !0, n !== xn)
      throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = e, this.t = t;
  }
  get styleSheet() {
    let e = this.o;
    const t = this.t;
    if (In && e === void 0) {
      const n = t !== void 0 && t.length === 1;
      n && (e = Mi.get(t)), e === void 0 && ((this.o = e = new CSSStyleSheet()).replaceSync(this.cssText), n && Mi.set(t, e));
    }
    return e;
  }
  toString() {
    return this.cssText;
  }
}
const bc = (r) => new Bs(typeof r == "string" ? r : r + "", void 0, xn), Ec = (r, ...e) => {
  const t = r.length === 1 ? r[0] : e.reduce((n, i, s) => n + ((o) => {
    if (o._$cssResult$ === !0)
      return o.cssText;
    if (typeof o == "number")
      return o;
    throw Error("Value passed to 'css' function must be a 'css' function result: " + o + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
  })(i) + r[s + 1], r[0]);
  return new Bs(t, r, xn);
}, _c = (r, e) => {
  In ? r.adoptedStyleSheets = e.map((t) => t instanceof CSSStyleSheet ? t : t.styleSheet) : e.forEach((t) => {
    const n = document.createElement("style"), i = Mt.litNonce;
    i !== void 0 && n.setAttribute("nonce", i), n.textContent = t.cssText, r.appendChild(n);
  });
}, Ri = In ? (r) => r : (r) => r instanceof CSSStyleSheet ? ((e) => {
  let t = "";
  for (const n of e.cssRules)
    t += n.cssText;
  return bc(t);
})(r) : r;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var yr;
const Qt = window, Pi = Qt.trustedTypes, wc = Pi ? Pi.emptyScript : "", Fi = Qt.reactiveElementPolyfillSupport, Yr = { toAttribute(r, e) {
  switch (e) {
    case Boolean:
      r = r ? wc : null;
      break;
    case Object:
    case Array:
      r = r == null ? r : JSON.stringify(r);
  }
  return r;
}, fromAttribute(r, e) {
  let t = r;
  switch (e) {
    case Boolean:
      t = r !== null;
      break;
    case Number:
      t = r === null ? null : Number(r);
      break;
    case Object:
    case Array:
      try {
        t = JSON.parse(r);
      } catch {
        t = null;
      }
  }
  return t;
} }, Hs = (r, e) => e !== r && (e == e || r == r), mr = { attribute: !0, type: String, converter: Yr, reflect: !1, hasChanged: Hs };
class Ae extends HTMLElement {
  constructor() {
    super(), this._$Ei = /* @__PURE__ */ new Map(), this.isUpdatePending = !1, this.hasUpdated = !1, this._$El = null, this.u();
  }
  static addInitializer(e) {
    var t;
    this.finalize(), ((t = this.h) !== null && t !== void 0 ? t : this.h = []).push(e);
  }
  static get observedAttributes() {
    this.finalize();
    const e = [];
    return this.elementProperties.forEach((t, n) => {
      const i = this._$Ep(n, t);
      i !== void 0 && (this._$Ev.set(i, n), e.push(i));
    }), e;
  }
  static createProperty(e, t = mr) {
    if (t.state && (t.attribute = !1), this.finalize(), this.elementProperties.set(e, t), !t.noAccessor && !this.prototype.hasOwnProperty(e)) {
      const n = typeof e == "symbol" ? Symbol() : "__" + e, i = this.getPropertyDescriptor(e, n, t);
      i !== void 0 && Object.defineProperty(this.prototype, e, i);
    }
  }
  static getPropertyDescriptor(e, t, n) {
    return { get() {
      return this[t];
    }, set(i) {
      const s = this[e];
      this[t] = i, this.requestUpdate(e, s, n);
    }, configurable: !0, enumerable: !0 };
  }
  static getPropertyOptions(e) {
    return this.elementProperties.get(e) || mr;
  }
  static finalize() {
    if (this.hasOwnProperty("finalized"))
      return !1;
    this.finalized = !0;
    const e = Object.getPrototypeOf(this);
    if (e.finalize(), e.h !== void 0 && (this.h = [...e.h]), this.elementProperties = new Map(e.elementProperties), this._$Ev = /* @__PURE__ */ new Map(), this.hasOwnProperty("properties")) {
      const t = this.properties, n = [...Object.getOwnPropertyNames(t), ...Object.getOwnPropertySymbols(t)];
      for (const i of n)
        this.createProperty(i, t[i]);
    }
    return this.elementStyles = this.finalizeStyles(this.styles), !0;
  }
  static finalizeStyles(e) {
    const t = [];
    if (Array.isArray(e)) {
      const n = new Set(e.flat(1 / 0).reverse());
      for (const i of n)
        t.unshift(Ri(i));
    } else
      e !== void 0 && t.push(Ri(e));
    return t;
  }
  static _$Ep(e, t) {
    const n = t.attribute;
    return n === !1 ? void 0 : typeof n == "string" ? n : typeof e == "string" ? e.toLowerCase() : void 0;
  }
  u() {
    var e;
    this._$E_ = new Promise((t) => this.enableUpdating = t), this._$AL = /* @__PURE__ */ new Map(), this._$Eg(), this.requestUpdate(), (e = this.constructor.h) === null || e === void 0 || e.forEach((t) => t(this));
  }
  addController(e) {
    var t, n;
    ((t = this._$ES) !== null && t !== void 0 ? t : this._$ES = []).push(e), this.renderRoot !== void 0 && this.isConnected && ((n = e.hostConnected) === null || n === void 0 || n.call(e));
  }
  removeController(e) {
    var t;
    (t = this._$ES) === null || t === void 0 || t.splice(this._$ES.indexOf(e) >>> 0, 1);
  }
  _$Eg() {
    this.constructor.elementProperties.forEach((e, t) => {
      this.hasOwnProperty(t) && (this._$Ei.set(t, this[t]), delete this[t]);
    });
  }
  createRenderRoot() {
    var e;
    const t = (e = this.shadowRoot) !== null && e !== void 0 ? e : this.attachShadow(this.constructor.shadowRootOptions);
    return _c(t, this.constructor.elementStyles), t;
  }
  connectedCallback() {
    var e;
    this.renderRoot === void 0 && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), (e = this._$ES) === null || e === void 0 || e.forEach((t) => {
      var n;
      return (n = t.hostConnected) === null || n === void 0 ? void 0 : n.call(t);
    });
  }
  enableUpdating(e) {
  }
  disconnectedCallback() {
    var e;
    (e = this._$ES) === null || e === void 0 || e.forEach((t) => {
      var n;
      return (n = t.hostDisconnected) === null || n === void 0 ? void 0 : n.call(t);
    });
  }
  attributeChangedCallback(e, t, n) {
    this._$AK(e, n);
  }
  _$EO(e, t, n = mr) {
    var i;
    const s = this.constructor._$Ep(e, n);
    if (s !== void 0 && n.reflect === !0) {
      const o = (((i = n.converter) === null || i === void 0 ? void 0 : i.toAttribute) !== void 0 ? n.converter : Yr).toAttribute(t, n.type);
      this._$El = e, o == null ? this.removeAttribute(s) : this.setAttribute(s, o), this._$El = null;
    }
  }
  _$AK(e, t) {
    var n;
    const i = this.constructor, s = i._$Ev.get(e);
    if (s !== void 0 && this._$El !== s) {
      const o = i.getPropertyOptions(s), a = typeof o.converter == "function" ? { fromAttribute: o.converter } : ((n = o.converter) === null || n === void 0 ? void 0 : n.fromAttribute) !== void 0 ? o.converter : Yr;
      this._$El = s, this[s] = a.fromAttribute(t, o.type), this._$El = null;
    }
  }
  requestUpdate(e, t, n) {
    let i = !0;
    e !== void 0 && (((n = n || this.constructor.getPropertyOptions(e)).hasChanged || Hs)(this[e], t) ? (this._$AL.has(e) || this._$AL.set(e, t), n.reflect === !0 && this._$El !== e && (this._$EC === void 0 && (this._$EC = /* @__PURE__ */ new Map()), this._$EC.set(e, n))) : i = !1), !this.isUpdatePending && i && (this._$E_ = this._$Ej());
  }
  async _$Ej() {
    this.isUpdatePending = !0;
    try {
      await this._$E_;
    } catch (t) {
      Promise.reject(t);
    }
    const e = this.scheduleUpdate();
    return e != null && await e, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    var e;
    if (!this.isUpdatePending)
      return;
    this.hasUpdated, this._$Ei && (this._$Ei.forEach((i, s) => this[s] = i), this._$Ei = void 0);
    let t = !1;
    const n = this._$AL;
    try {
      t = this.shouldUpdate(n), t ? (this.willUpdate(n), (e = this._$ES) === null || e === void 0 || e.forEach((i) => {
        var s;
        return (s = i.hostUpdate) === null || s === void 0 ? void 0 : s.call(i);
      }), this.update(n)) : this._$Ek();
    } catch (i) {
      throw t = !1, this._$Ek(), i;
    }
    t && this._$AE(n);
  }
  willUpdate(e) {
  }
  _$AE(e) {
    var t;
    (t = this._$ES) === null || t === void 0 || t.forEach((n) => {
      var i;
      return (i = n.hostUpdated) === null || i === void 0 ? void 0 : i.call(n);
    }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(e)), this.updated(e);
  }
  _$Ek() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = !1;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$E_;
  }
  shouldUpdate(e) {
    return !0;
  }
  update(e) {
    this._$EC !== void 0 && (this._$EC.forEach((t, n) => this._$EO(n, this[n], t)), this._$EC = void 0), this._$Ek();
  }
  updated(e) {
  }
  firstUpdated(e) {
  }
}
Ae.finalized = !0, Ae.elementProperties = /* @__PURE__ */ new Map(), Ae.elementStyles = [], Ae.shadowRootOptions = { mode: "open" }, Fi == null || Fi({ ReactiveElement: Ae }), ((yr = Qt.reactiveElementVersions) !== null && yr !== void 0 ? yr : Qt.reactiveElementVersions = []).push("1.4.2");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var gr;
const $t = window, ze = $t.trustedTypes, Li = ze ? ze.createPolicy("lit-html", { createHTML: (r) => r }) : void 0, he = `lit$${(Math.random() + "").slice(9)}$`, Ws = "?" + he, Sc = `<${Ws}>`, Be = document, pt = (r = "") => Be.createComment(r), dt = (r) => r === null || typeof r != "object" && typeof r != "function", Gs = Array.isArray, Oc = (r) => Gs(r) || typeof (r == null ? void 0 : r[Symbol.iterator]) == "function", et = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, ji = /-->/g, Vi = />/g, me = RegExp(`>|[ 	
\f\r](?:([^\\s"'>=/]+)([ 	
\f\r]*=[ 	
\f\r]*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g"), Qi = /'/g, $i = /"/g, Ys = /^(?:script|style|textarea|title)$/i, Dc = (r) => (e, ...t) => ({ _$litType$: r, strings: e, values: t }), ae = Dc(1), He = Symbol.for("lit-noChange"), $ = Symbol.for("lit-nothing"), qi = /* @__PURE__ */ new WeakMap(), Fe = Be.createTreeWalker(Be, 129, null, !1), Tc = (r, e) => {
  const t = r.length - 1, n = [];
  let i, s = e === 2 ? "<svg>" : "", o = et;
  for (let c = 0; c < t; c++) {
    const u = r[c];
    let l, f, h = -1, p = 0;
    for (; p < u.length && (o.lastIndex = p, f = o.exec(u), f !== null); )
      p = o.lastIndex, o === et ? f[1] === "!--" ? o = ji : f[1] !== void 0 ? o = Vi : f[2] !== void 0 ? (Ys.test(f[2]) && (i = RegExp("</" + f[2], "g")), o = me) : f[3] !== void 0 && (o = me) : o === me ? f[0] === ">" ? (o = i != null ? i : et, h = -1) : f[1] === void 0 ? h = -2 : (h = o.lastIndex - f[2].length, l = f[1], o = f[3] === void 0 ? me : f[3] === '"' ? $i : Qi) : o === $i || o === Qi ? o = me : o === ji || o === Vi ? o = et : (o = me, i = void 0);
    const d = o === me && r[c + 1].startsWith("/>") ? " " : "";
    s += o === et ? u + Sc : h >= 0 ? (n.push(l), u.slice(0, h) + "$lit$" + u.slice(h) + he + d) : u + he + (h === -2 ? (n.push(void 0), c) : d);
  }
  const a = s + (r[t] || "<?>") + (e === 2 ? "</svg>" : "");
  if (!Array.isArray(r) || !r.hasOwnProperty("raw"))
    throw Error("invalid template strings array");
  return [Li !== void 0 ? Li.createHTML(a) : a, n];
};
class vt {
  constructor({ strings: e, _$litType$: t }, n) {
    let i;
    this.parts = [];
    let s = 0, o = 0;
    const a = e.length - 1, c = this.parts, [u, l] = Tc(e, t);
    if (this.el = vt.createElement(u, n), Fe.currentNode = this.el.content, t === 2) {
      const f = this.el.content, h = f.firstChild;
      h.remove(), f.append(...h.childNodes);
    }
    for (; (i = Fe.nextNode()) !== null && c.length < a; ) {
      if (i.nodeType === 1) {
        if (i.hasAttributes()) {
          const f = [];
          for (const h of i.getAttributeNames())
            if (h.endsWith("$lit$") || h.startsWith(he)) {
              const p = l[o++];
              if (f.push(h), p !== void 0) {
                const d = i.getAttribute(p.toLowerCase() + "$lit$").split(he), v = /([.?@])?(.*)/.exec(p);
                c.push({ type: 1, index: s, name: v[2], strings: d, ctor: v[1] === "." ? xc : v[1] === "?" ? Ac : v[1] === "@" ? Nc : Xt });
              } else
                c.push({ type: 6, index: s });
            }
          for (const h of f)
            i.removeAttribute(h);
        }
        if (Ys.test(i.tagName)) {
          const f = i.textContent.split(he), h = f.length - 1;
          if (h > 0) {
            i.textContent = ze ? ze.emptyScript : "";
            for (let p = 0; p < h; p++)
              i.append(f[p], pt()), Fe.nextNode(), c.push({ type: 2, index: ++s });
            i.append(f[h], pt());
          }
        }
      } else if (i.nodeType === 8)
        if (i.data === Ws)
          c.push({ type: 2, index: s });
        else {
          let f = -1;
          for (; (f = i.data.indexOf(he, f + 1)) !== -1; )
            c.push({ type: 7, index: s }), f += he.length - 1;
        }
      s++;
    }
  }
  static createElement(e, t) {
    const n = Be.createElement("template");
    return n.innerHTML = e, n;
  }
}
function We(r, e, t = r, n) {
  var i, s, o, a;
  if (e === He)
    return e;
  let c = n !== void 0 ? (i = t._$Co) === null || i === void 0 ? void 0 : i[n] : t._$Cl;
  const u = dt(e) ? void 0 : e._$litDirective$;
  return (c == null ? void 0 : c.constructor) !== u && ((s = c == null ? void 0 : c._$AO) === null || s === void 0 || s.call(c, !1), u === void 0 ? c = void 0 : (c = new u(r), c._$AT(r, t, n)), n !== void 0 ? ((o = (a = t)._$Co) !== null && o !== void 0 ? o : a._$Co = [])[n] = c : t._$Cl = c), c !== void 0 && (e = We(r, c._$AS(r, e.values), c, n)), e;
}
class Ic {
  constructor(e, t) {
    this.u = [], this._$AN = void 0, this._$AD = e, this._$AM = t;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  v(e) {
    var t;
    const { el: { content: n }, parts: i } = this._$AD, s = ((t = e == null ? void 0 : e.creationScope) !== null && t !== void 0 ? t : Be).importNode(n, !0);
    Fe.currentNode = s;
    let o = Fe.nextNode(), a = 0, c = 0, u = i[0];
    for (; u !== void 0; ) {
      if (a === u.index) {
        let l;
        u.type === 2 ? l = new Et(o, o.nextSibling, this, e) : u.type === 1 ? l = new u.ctor(o, u.name, u.strings, this, e) : u.type === 6 && (l = new Cc(o, this, e)), this.u.push(l), u = i[++c];
      }
      a !== (u == null ? void 0 : u.index) && (o = Fe.nextNode(), a++);
    }
    return s;
  }
  p(e) {
    let t = 0;
    for (const n of this.u)
      n !== void 0 && (n.strings !== void 0 ? (n._$AI(e, n, t), t += n.strings.length - 2) : n._$AI(e[t])), t++;
  }
}
class Et {
  constructor(e, t, n, i) {
    var s;
    this.type = 2, this._$AH = $, this._$AN = void 0, this._$AA = e, this._$AB = t, this._$AM = n, this.options = i, this._$Cm = (s = i == null ? void 0 : i.isConnected) === null || s === void 0 || s;
  }
  get _$AU() {
    var e, t;
    return (t = (e = this._$AM) === null || e === void 0 ? void 0 : e._$AU) !== null && t !== void 0 ? t : this._$Cm;
  }
  get parentNode() {
    let e = this._$AA.parentNode;
    const t = this._$AM;
    return t !== void 0 && e.nodeType === 11 && (e = t.parentNode), e;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(e, t = this) {
    e = We(this, e, t), dt(e) ? e === $ || e == null || e === "" ? (this._$AH !== $ && this._$AR(), this._$AH = $) : e !== this._$AH && e !== He && this.g(e) : e._$litType$ !== void 0 ? this.$(e) : e.nodeType !== void 0 ? this.T(e) : Oc(e) ? this.k(e) : this.g(e);
  }
  O(e, t = this._$AB) {
    return this._$AA.parentNode.insertBefore(e, t);
  }
  T(e) {
    this._$AH !== e && (this._$AR(), this._$AH = this.O(e));
  }
  g(e) {
    this._$AH !== $ && dt(this._$AH) ? this._$AA.nextSibling.data = e : this.T(Be.createTextNode(e)), this._$AH = e;
  }
  $(e) {
    var t;
    const { values: n, _$litType$: i } = e, s = typeof i == "number" ? this._$AC(e) : (i.el === void 0 && (i.el = vt.createElement(i.h, this.options)), i);
    if (((t = this._$AH) === null || t === void 0 ? void 0 : t._$AD) === s)
      this._$AH.p(n);
    else {
      const o = new Ic(s, this), a = o.v(this.options);
      o.p(n), this.T(a), this._$AH = o;
    }
  }
  _$AC(e) {
    let t = qi.get(e.strings);
    return t === void 0 && qi.set(e.strings, t = new vt(e)), t;
  }
  k(e) {
    Gs(this._$AH) || (this._$AH = [], this._$AR());
    const t = this._$AH;
    let n, i = 0;
    for (const s of e)
      i === t.length ? t.push(n = new Et(this.O(pt()), this.O(pt()), this, this.options)) : n = t[i], n._$AI(s), i++;
    i < t.length && (this._$AR(n && n._$AB.nextSibling, i), t.length = i);
  }
  _$AR(e = this._$AA.nextSibling, t) {
    var n;
    for ((n = this._$AP) === null || n === void 0 || n.call(this, !1, !0, t); e && e !== this._$AB; ) {
      const i = e.nextSibling;
      e.remove(), e = i;
    }
  }
  setConnected(e) {
    var t;
    this._$AM === void 0 && (this._$Cm = e, (t = this._$AP) === null || t === void 0 || t.call(this, e));
  }
}
class Xt {
  constructor(e, t, n, i, s) {
    this.type = 1, this._$AH = $, this._$AN = void 0, this.element = e, this.name = t, this._$AM = i, this.options = s, n.length > 2 || n[0] !== "" || n[1] !== "" ? (this._$AH = Array(n.length - 1).fill(new String()), this.strings = n) : this._$AH = $;
  }
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(e, t = this, n, i) {
    const s = this.strings;
    let o = !1;
    if (s === void 0)
      e = We(this, e, t, 0), o = !dt(e) || e !== this._$AH && e !== He, o && (this._$AH = e);
    else {
      const a = e;
      let c, u;
      for (e = s[0], c = 0; c < s.length - 1; c++)
        u = We(this, a[n + c], t, c), u === He && (u = this._$AH[c]), o || (o = !dt(u) || u !== this._$AH[c]), u === $ ? e = $ : e !== $ && (e += (u != null ? u : "") + s[c + 1]), this._$AH[c] = u;
    }
    o && !i && this.j(e);
  }
  j(e) {
    e === $ ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, e != null ? e : "");
  }
}
class xc extends Xt {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(e) {
    this.element[this.name] = e === $ ? void 0 : e;
  }
}
const kc = ze ? ze.emptyScript : "";
class Ac extends Xt {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(e) {
    e && e !== $ ? this.element.setAttribute(this.name, kc) : this.element.removeAttribute(this.name);
  }
}
class Nc extends Xt {
  constructor(e, t, n, i, s) {
    super(e, t, n, i, s), this.type = 5;
  }
  _$AI(e, t = this) {
    var n;
    if ((e = (n = We(this, e, t, 0)) !== null && n !== void 0 ? n : $) === He)
      return;
    const i = this._$AH, s = e === $ && i !== $ || e.capture !== i.capture || e.once !== i.once || e.passive !== i.passive, o = e !== $ && (i === $ || s);
    s && this.element.removeEventListener(this.name, this, i), o && this.element.addEventListener(this.name, this, e), this._$AH = e;
  }
  handleEvent(e) {
    var t, n;
    typeof this._$AH == "function" ? this._$AH.call((n = (t = this.options) === null || t === void 0 ? void 0 : t.host) !== null && n !== void 0 ? n : this.element, e) : this._$AH.handleEvent(e);
  }
}
class Cc {
  constructor(e, t, n) {
    this.element = e, this.type = 6, this._$AN = void 0, this._$AM = t, this.options = n;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(e) {
    We(this, e);
  }
}
const Ui = $t.litHtmlPolyfillSupport;
Ui == null || Ui(vt, Et), ((gr = $t.litHtmlVersions) !== null && gr !== void 0 ? gr : $t.litHtmlVersions = []).push("2.4.0");
const Mc = (r, e, t) => {
  var n, i;
  const s = (n = t == null ? void 0 : t.renderBefore) !== null && n !== void 0 ? n : e;
  let o = s._$litPart$;
  if (o === void 0) {
    const a = (i = t == null ? void 0 : t.renderBefore) !== null && i !== void 0 ? i : null;
    s._$litPart$ = o = new Et(e.insertBefore(pt(), a), a, void 0, t != null ? t : {});
  }
  return o._$AI(r), o;
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var br, Er;
class at extends Ae {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
  }
  createRenderRoot() {
    var e, t;
    const n = super.createRenderRoot();
    return (e = (t = this.renderOptions).renderBefore) !== null && e !== void 0 || (t.renderBefore = n.firstChild), n;
  }
  update(e) {
    const t = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(e), this._$Do = Mc(t, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    var e;
    super.connectedCallback(), (e = this._$Do) === null || e === void 0 || e.setConnected(!0);
  }
  disconnectedCallback() {
    var e;
    super.disconnectedCallback(), (e = this._$Do) === null || e === void 0 || e.setConnected(!1);
  }
  render() {
    return He;
  }
}
at.finalized = !0, at._$litElement$ = !0, (br = globalThis.litElementHydrateSupport) === null || br === void 0 || br.call(globalThis, { LitElement: at });
const zi = globalThis.litElementPolyfillSupport;
zi == null || zi({ LitElement: at });
((Er = globalThis.litElementVersions) !== null && Er !== void 0 ? Er : globalThis.litElementVersions = []).push("3.2.2");
const _r = Ue`
    query getCounterDataForToday($from: Timestamp!, $to: Timestamp!, $pointId: ID!, $type: String!){
        signalsAggregation(aggregate: {from: $from, to: $to}, where: {pointId: $pointId, type: $type, unit: GENERIC}) {
            count
        }
    }
`, Rc = "https://iot.dimensionfour.io/graph";
function Bi(r = Rc, e, t) {
  const n = new ds({ uri: r, credentials: "include" }), i = new De((o, a) => (o.setContext(({ headers: c = {} }) => ({
    headers: {
      ...c,
      "x-tenant-id": e,
      "x-tenant-key": t
    }
  })), a(o)));
  return new lc({
    uri: r,
    cache: new rc(),
    link: Va(i, n)
  });
}
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const Dt = (r) => r != null ? r : $, Pc = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTYiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1NiA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQyLjQxMDcgNDguMDAwNFY0Mi44ODkzQzQyLjQxMDcgNDAuMTc4MiA0MS4zNDY3IDM3LjU3ODEgMzkuNDUyOCAzNS42NjFDMzcuNTU4OSAzMy43NDQgMzQuOTkwMiAzMi42NjcgMzIuMzExOCAzMi42NjdIMTIuMTE0QzkuNDM1NjMgMzIuNjY3IDYuODY2OTQgMzMuNzQ0IDQuOTczMDMgMzUuNjYxQzMuMDc5MTIgMzcuNTc4MSAyLjAxNTE0IDQwLjE3ODIgMi4wMTUxNCA0Mi44ODkzVjQ4LjAwMDQiIHN0cm9rZT0iIzFFMUEyQyIgc3Ryb2tlLXdpZHRoPSIyLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjIuMjEzMSAyMi40NDQ2QzI3Ljc5MDYgMjIuNDQ0NiAzMi4zMTIgMTcuODY3OSAzMi4zMTIgMTIuMjIyM0MzMi4zMTIgNi41NzY2OCAyNy43OTA2IDIgMjIuMjEzMSAyQzE2LjYzNTcgMiAxMi4xMTQzIDYuNTc2NjggMTIuMTE0MyAxMi4yMjIzQzEyLjExNDMgMTcuODY3OSAxNi42MzU3IDIyLjQ0NDYgMjIuMjEzMSAyMi40NDQ2WiIgc3Ryb2tlPSIjMUUxQTJDIiBzdHJva2Utd2lkdGg9IjIuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik01NC4wMTUxIDQ4LjAwMDJWNDIuODg5MUM1NC4wMTM0IDQwLjYyNDIgNTMuMjY4NyAzOC40MjM5IDUxLjg5NzggMzYuNjMzOUM1MC41MjY5IDM0Ljg0MzggNDguNjA3NSAzMy41NjUzIDQ2LjQ0MDkgMzIuOTk5IiBzdHJva2U9IiMxRTFBMkMiIHN0cm9rZS13aWR0aD0iMi41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTM2LjM0MTggMi4zMzIwM0MzOC41MTQxIDIuODk1MDMgNDAuNDM5NSA0LjE3Mzg0IDQxLjgxNDUgNS45NjY4NUM0My4xODk1IDcuNzU5ODcgNDMuOTM1OCA5Ljk2NTEgNDMuOTM1OCAxMi4yMzQ5QzQzLjkzNTggMTQuNTA0NyA0My4xODk1IDE2LjcwOTkgNDEuODE0NSAxOC41MDI5QzQwLjQzOTUgMjAuMjk1OSAzOC41MTQxIDIxLjU3NDcgMzYuMzQxOCAyMi4xMzc3IiBzdHJva2U9IiMxRTFBMkMiIHN0cm9rZS13aWR0aD0iMi41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==", Fc = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI2LjIuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA4IDgiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDggODsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOm5vbmU7c3Ryb2tlOiMxRTFBMkM7c3Ryb2tlLXdpZHRoOjEuNTtzdHJva2UtbGluZWNhcDpzcXVhcmU7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO30KPC9zdHlsZT4KPHBhdGggY2xhc3M9InN0MCIgZD0iTTYuOCw1LjFsMC0zLjUgTTYuNywxLjZsLTMuNSwwIE02LjIsMkwxLjgsNi41Ii8+Cjwvc3ZnPgo=", Lc = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI2LjIuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA4IDgiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDggODsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOm5vbmU7c3Ryb2tlOiMxRTFBMkM7c3Ryb2tlLXdpZHRoOjEuNTtzdHJva2UtbGluZWNhcDpzcXVhcmU7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO30KPC9zdHlsZT4KPHBhdGggY2xhc3M9InN0MCIgZD0iTTMuMiw2LjVsMy41LDAgTTYuNyw2LjVsMC0zLjUgTTYuMiw2TDEuOCwxLjUiLz4KPC9zdmc+Cg==";
class jc extends at {
  constructor() {
    super();
    _t(this, "query", new X(this, _r));
    _t(this, "queryRelativeComparator", new X(this, _r));
    _t(this, "queryCounterOutValue", new X(this, _r));
    this.time_window = "today", this.title = "Number of visitors";
  }
  static get properties() {
    return {
      api_endpoint: { type: String },
      title: { type: String },
      usecase: { type: String },
      tenant_id: { type: String },
      tenant_key: { type: String },
      point_id: { type: String },
      type: { type: String },
      signal_type_in: { type: String },
      signal_type_out: { type: String },
      show_history: { type: Boolean },
      time_window: {
        type: String,
        reflect: !0
      }
    };
  }
  firstUpdated() {
    this.usecase === "visitors_now" ? this.getCounterValueNow({
      signalTypeIn: this.signal_type_in,
      signalTypeOut: this.signal_type_out
    }) : this.getData({
      timeWindow: "today"
    });
  }
  getData({ timeWindow: t = this.timeWindow }) {
    const n = new Date(), i = new Date();
    let s = new Date(), o = new Date();
    const a = Bi(this.api_endpoint, this.tenant_id, this.tenant_key);
    t === "today" ? (n.setHours(0, 0, 0, 0), s.setDate(s.getDate() - 1), s.setHours(0, 0, 0, 0), o.setDate(o.getDate() - 1), o.setHours(23, 59, 59, 0)) : t === "yesterday" ? (n.setDate(n.getDate() - 1), n.setUTCHours(0, 0, 0, 0), i.setDate(i.getDate() - 1), i.setUTCHours(22, 59, 59, 999), s = new Date(n), s.setDate(n.getDate() - 1), o = new Date(i), o.setDate(i.getDate() - 1)) : t === "this-week" ? (n.setDate(n.getDate() - (n.getDay() + 6) % 7), n.setUTCHours(0, 0, 0, 0), s = new Date(n), s.setDate(n.getDate() - 7), s.getDay() !== 1 ? s.setDate(s - (s.getDay() + 6) % 7) : s.setDate(s.getDate() - 7), o = new Date(s), o.setDate(s.getDate() + 7), o.getDay() !== 0 ? o.setDate(o.getDate() - o.getDay()) : o.setDate(o.getDate() - 7)) : t === "last-week" && (n.getDay() !== 1 ? n.setDate(n.getDate() - 7 - (n.getDay() + 6) % 7) : n.setDate(n.getDate() - 7), i.getDay() !== 0 ? i.setDate(i.getDate() - i.getDay()) : i.setDate(i.getDate() - 7), s = new Date(n), s.setDate(n.getDate() - 7), o = new Date(i), o.setDate(i.getDate() - 7)), this.query.variables = {
      from: n.toISOString(),
      to: i.toISOString(),
      pointId: this.point_id,
      type: this.type
    }, this.queryRelativeComparator.variables = {
      from: s.toISOString(),
      to: o.toISOString(),
      pointId: this.point_id,
      type: this.type
    }, this.query.client = a, this.queryRelativeComparator.client = a, this.query.executeQuery(), this.queryRelativeComparator.executeQuery();
  }
  getCounterValueNow({ signalTypeIn: t, signalTypeOut: n }) {
    const i = Bi(this.api_endpoint, this.tenant_id, this.tenant_key), s = new Date();
    s.setUTCHours(0, 0, 0, 0);
    const o = new Date();
    o.setUTCHours(23, 0, 0, 999), this.query.variables = {
      from: s.toISOString(),
      to: o.toISOString(),
      pointId: this.point_id,
      type: t
    }, this.queryCounterOutValue.variables = {
      from: s.toISOString(),
      to: o.toISOString(),
      pointId: this.point_id,
      type: n
    }, this.query.client = i, this.queryCounterOutValue.client = i, this.query.executeQuery(), this.queryCounterOutValue.executeQuery();
  }
  render() {
    var o, a, c, u, l, f;
    const { data: t, loading: n } = this.query;
    let i = (a = (o = t == null ? void 0 : t.signalsAggregation) == null ? void 0 : o[0]) == null ? void 0 : a.count;
    i = i != null ? i : 0;
    let s = null;
    if (this.usecase === "visitors_now") {
      const { data: h, loading: p } = this.queryCounterOutValue;
      let d = (u = (c = h == null ? void 0 : h.signalsAggregation) == null ? void 0 : c[0]) == null ? void 0 : u.count;
      d = d != null ? d : 0, i = i - d;
    } else {
      const { data: h, loading: p } = this.queryRelativeComparator;
      let d = (f = (l = h == null ? void 0 : h.signalsAggregation) == null ? void 0 : l[0]) == null ? void 0 : f.count;
      d = d != null ? d : 0;
      const v = this.timeWindow === "this-week" || this.timeWindow === "last-week" ? "week" : "day";
      i > d ? s = ae`
        <span class="sub-header-sprite">
          <img src=${Fc}><span>${i - d}</span>
        </span>
        <span class="sub-header-description">More than the ${v} before</span>
      ` : i < d && (s = ae`
        <span class="sub-header-sprite">
          <img src=${Lc}><span>${d - i}</span>
        </span>
        <span class="sub-header-description">Less than the ${v} before</span>
      `);
    }
    return ae`
      <div class="container">
        <div class="header">
            <div class="header-title">${this.title}</div>
            ${this.usecase === "visitors_now" ? ae`
               <div class="clock">${new Date().toLocaleString("en-US", { hour: "numeric", hour12: !0 })}</div>
            ` : ae`
              <div class="header-dropdown">
                ${this.show_history ? ae`
                  <select @change="${this._changeTimeWindow}">
                        <option value="today" selected=${Dt(this.time_window === "today" ? !0 : void 0)}>Today</option>
                        <option value="yesterday" selected=${Dt(this.time_window === "yesterday" ? !0 : void 0)}>Yesterday</option>
                        <option value="this-week" selected=${Dt(this.time_window === "this-week" ? !0 : void 0)}>This Week</option>
                        <option value="last-week" selected=${Dt(this.time_window === "last-week" ? !0 : void 0)}>Last Week</option>
                    </select>
                ` : ""}
                  ${n ? ae`<div>loading...</div>` : ae`<div></div>`}
              </div>
              `}
        </div>
        <div class="sub-header">
          ${s}
        </div>
        <div class="content">
            <div class="content-numberic-value">
            ${i || 0}
            </div>
            <div class="content-illustration-container"><img src=${Pc}></div>
        </div>
        
      </div>
    `;
  }
  _changeTimeWindow(t) {
    const n = t.target.value;
    this.timeWindow = n, this.getData(n);
  }
  static get styles() {
    return Ec`
      :host {
        --color-purple: #5258EB;
        --color-gray-purple: #E4E5FF;
        --color-dark-blue: #151275;
        width: 100%;
        min-height: 450px;
      }
      .container {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        background-color: white;
        padding: 45px;
        border-radius: 9px;
        min-height: 380px;
        box-shadow: 3px 4px 25px rgba(30, 26, 44, 0.02);
      }

      .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .header-title {
        font-size: 40px;
      }

      .sub-header {
        margin: 30px 0;
        display: flex;
        align-items: center;
      }

      .sub-header-sprite {
        background-color: #EDF2F8;
        color: black;
        border-radius: 6px;
        width: min-content;
        min-width: 24px;
        height: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 9px;
        margin-right: 15px;
      }

      .sub-header-sprite img {
        margin-right: 5px;
        width: 12px;
      }

      .sub-header-description {
        color: black;
      }

      .content {
        display: flex;
        height: 200px;
        margin-top: 30px;
        align-items: baseline;
        color: white;
      }

      .content-numberic-value {
        font-size: 200px;
        font-weight: bold;
        line-height: 1;
        color: black;
      }
      
      .clock {
        background-color: #EDF2F8;
        font-size: 21px;
        padding: 6px 24px;
      }
      
      .content-illustration-container img {
        width: 90px;
      }
    `;
  }
}
window.customElements.define("d4-counter-sensor", jc);
export {
  jc as default
};
